import EnValidateMessages from "@/plugins/VeeValidate/EnValidateMessages.json";
import UzValidateMessages from "@/plugins/VeeValidate/UzValidateMessages.json";
import RuValidateMessages from "@/plugins/VeeValidate/RuValidateMessages.json";
import CyrlValidationMessages from "@/plugins/VeeValidate/CyrlValidateMessages.json";
import { orderItemStatus } from "@/utils/constants";

export default {
  en: {
    search: "Search",
    fromUp: "from",
    fromTo: "to",
    data: "Date",
    telegramBotLink: "Telegram bot link:",
    yourPhoneAccept:
      "Your phone number for receipt of confirmation and telegram:",
    youdonothaveaccess: "You do not have access to this page :(",
    backToHome: "Back to cabinet",
    officeProducts: "Office products",
    storeTheOffice: "Office storage",
    employees: "Employees",
    FINISHED: "Completed",
    STARTED: "In progress",
    process: "Process",
    designatedPerson: "Designated person",
    carriageFrom: "Carriage from",
    stillageFrom: "Stillage from",
    stillageTo: "Stillage to",
    carriageTo: "Carriage to",
    endDate: "End date",
    startDate: "Start date",
    attachDepartmentToUser: "Attach department to user",
    numberOfProducts: "Number of products",
    invCode: "Inv. code",
    exportExel: "Export to Excel",
    attachProduct: "Attach product",
    attachedToEmployee: "Attached to an employee",
    departmentName: "Department name",
    totalNumberOfProducts: "Total Number of products",
    addDepartment: "Add department",
    codeForInventory: "Code for inventory",
    generation: "Generation",
    generateQrCodeAndInventoryCode: "Generate QR code and inventory code",
    numberOfProductCount: "Quantity",
    forrealization: "For realization",
    foruse: "For use",
    productCondition: "Product condition",
    productPhotos: "Product photos",
    quantityProducts: "Quantity of products",
    dataModified: "Date modified",
    resPerson: "Responsible person (Warehouse Manager)",
    resPerson1: "Responsible person",
    myOffice: "My office",
    movingproducts: "Moving products",
    videoInstruction: "Video instruction",
    productManagementTitle: "Management product",
    fio: "Full name",
    modules: "Modules",
    navModalTitle: "Warehouse Location",
    navModalDescription: "You can share the location",
    navModalBtn: "Go to Map",
    close: "Close",
    changeTariff: "Change plan",
    changeYourTariff: "To continue, please change your subscription plan",
    hitYouLimit: "You've hit your limit",
    apply: "Apply",
    selectZoneForWarehousePlaceholder: "Select a zone for warehouse",
    selectZoneWhichYouWant: "Select the zone you want to attach",
    warehouseNotHere: "Attached warehouses not found",
    fullParcent: "Full",
    goBlackWarehouse: "Go to the black warehouse",
    attachToZone: "Attach to the zone",
    showOnTheMap: "Show on the Map",
    editBlackWarehouse: "Edit Black warehouse",
    numberOfStillage: "Number of racking",
    zone: "Zone",
    fromWhichWarehouse: "From which warehouse?",
    whichWarehouse: "Which warehouse?",
    selectProduct: "Select product",
    numberOfPlaces: "Number of places:",
    totalQuantity: "Total quantity",
    positionStillage: "Position in stillages",
    writeQuantity: "write quantity",
    move: "Move",
    busyCount: "Busy:",
    emptyCount: "Empty:",
    hiddenWarehouseDescription:
      "Giving visibility and control to specific individuals to store and manage certain types of goods.",
    hiddenWarehouse: "Hidden warehouse",
    regularWarehouseDescription: "This is a standard room for placing shelves",
    regularWarehouse: "Regular warehouse",
    areaWarehouseDescription:
      "By choosing this type, you create a space where several small or large warehouses can be located.",
    areaWarehouse: "Area Warehouse",
    typeWarehouses: "Warehouse types",
    typeWarehouse: "Warehouse type",
    selectWarehouseType: "Select warehouse type",
    createWarehouseSubTitle: "Let's start from scratch",
    addPermission: "Add Permission",
    editWarehouse: "Edit Warehouse",
    tin: "Tin",
    productPhoto: "Фото товара",
    productCharacteristics: "Product characteristics",
    certificateNumber: "№ сертификата",
    sign: "Sign",
    whatEDSKey: "What is an EDS?",
    loginWithEDS: "Login with EDS",
    loginTab: "Вход в систему",
    incomingGoods: "Incoming goods",
    outgoingGoods: "Outgoing goods",
    remainingCurrently: "Remaining (currently)",
    shippedProducts: "Shipped products",
    consignmentNote: "Consignment Note",
    gotIt: "Got it",
    unreceivedProducts: "Unreceived products",
    sourceWarehouse: "Warehouse source",
    serverErrorMessages: {
      UNSIGNED_ENTITY_NOT_FOUND: "Unsigned entity not found",
      CHANGE_WAREHOUSE: "This product is not available in this warehouse",
      PRODUCT_NAME_AND_ATTRIBUTE_WITH_DUPLICATE:
        "A product with this name exists",
      PRODUCT_NAME_MAX_LENGTH:
        "The product name consists of a maximum of 600 characters",
      HAS_CARRIAGE: "There is carriage here",
      CONTRACT_ITEM_CHANGE_STATUS:
        "It is impossible to move from one state to another",
      PRODUCT_NOT_GIVEN_DEPARTMENT: "Not commissioned",
      CONTRACT_NUMBER_BUSY: "Contract is busy",
      USER_NOT_FOUND_WITH_USERNAME: "User is not fount with this username",
      ORDER_INITIATOR_NOT_FOUND: "Initiator was not found in the order clause",
      ACCOUNTANT: "Accountant",
      CHEIF_ACCOUNTANT: "Chief accountant",
      TIME_OF_DELIVERY: "Time of delivery",
      ACCOUNT_CODE: "Account code",
      INVENTORY_VALUE: "Inventory value",
      INVOICE_N: "Invoice №",
      CONTRACT_NUMBER: "Contract number",
      SUPPLIER_COMPANY_NAME: "Supplier company name",
      RECIEVED_EMPLOYEE: "Received employee",
      ACCORDING_TO_DOCUMENT: "According to document",
      ACCEPTED: "Accepted",
      DEPARTURE_TIME: "Departure time",
      NAME_OF_RECEIVED_COMPANY: "Name of received company",
      REPORT_ON_MATERIALS_IN_ASSORTMENT: "Materials report between",
      PRODUCT_REVENUE_STATEMENT: "Materials income report between",
      PRODUCT_EXPENSE_REPORT_IN_ASSORTMENT: "Materials income expense between",
      INITIAL_BALANCE: "Initial balance",
      COMING: "Income",
      EXPENSE: "Expense",
      REMAINDER: "Final remainder",
      QUANTITY: "Quantity",
      TOTAL_COST: "Total cost",
      TOTAL: "Total:",
      PREPARED: "Prepared:",
      AGREED: "Agreed:",
      FINANCIALLY_RESPONSIBLE_PERSON: "Financially responsible person",
      PRODUCTION_DIRECTOR: "Production director",
      CHECKED: "Checked:",
      WORK_SHOP_HEAD_OF_DEPARTMENT: "Head of department",
      FINANCIAL_DIRECTOR: "Financial director",
      MATERIAL_TECHNICAL_CONTROL_DEPARTMENT:
        "Material and technical control department",
      CHECK: "Check",
      OFF_BALANCE_SHEET_REPORT: "Off-balance sheet report",
      DEP_WORKSHOP: "Department/Workshop",
      KIPIA: "KIPIA",
      CODE: "Code",
      PRODUCT_NAME: "Product name",
      DATE_OF_ACCEPTANCE: "Acceptance date",
      DATE_OF_DELIVERY: "Delivery date",
      UNIT: "Unit",
      PRICE: "Price",
      CHOOSE_THE_WAREHOUSE: "Select the warehouse",
      PRODUCE_HISTORY_IS_NULL: "Produce History is null",
      THE_AMOUNT_OF_PRODUCT_DELIVERED_IS_MORE:
        "The amount of product delivered is more than the amount requested by the initiator",
      MUST_GIVE_AT_LEAST_ONE: "You must give at least one",
      ERROR_SAVING_FILE: "Error to save file",
      ONLY_PDF_FILE_CAN_BE_COMPRESSED:
        "It is possible to compress only pdf file ",
      OUT_OF_LIMIT: "Out of limit",
      THIS_USER_HAS_NOT_PHONE_NUMBER: "This user has not phone number",
      YOU_HAVE_NO_ACCESS_TO_RECOVER_YOUR_PASSWORD:
        "You have no access to recover your password",
      STILLAGE_IS_NULL: "Stellage is null",
      NO_DEPARTMENT_IN_WAREHOUSE: "Warehouse does not belong to any department",
      CAN_NOT_RETURN_DEPARTMENT: "Returns can only be made to the warehouse",
      APPLICATION_NOT_FOUND: "Application not found",
      ACCOUNTANT_NOT_FOUND: "Select the accounting department",
      ACCOUNTANT_TELEGRAM_GROUP_NOT_FOUND:
        "Attach a telegram group in the accounting section",
      WAREHOUSE_REQUIRED: "Select the warehouse",
      AKT_FILE_REQUIRED: "AKT file required",
      NO_PRODUCT_FOUND_BY_ID: "Product ID not found",
      PRODUCT_ALREADY_TAKEN: "Product already taken",
      USER_HAS_NOT_PERMISSION_TO_GET_PRODUCT:
        "The user is not entitled to receive the product for this order",
      ORDER_ID_NOT_FOUND: "Order ID not found",
      DATA_NOT_FOUND: "No data",
      DEPARTMENT_OMTK_NOT_FOUND: "ОМТК department is not found",
      CHOOSE_THE_REQUEST_TYPE: "Select the question type",
      RECOVERING_PASSWORD_IS_FINISHED:
        "Recovering password is finished, try from the beginning",
      REQUESTCOUNT_IS_REQUIRED: "Request count is required",
      "0_OR_A_SMALL_VALUE_CAN_NOT_BE_ACCEPTED": "This should not be 0 or below",

      CHOOSE_DEPARTMENT_TYPE: "Choose department type",
      PRODUCT_ID_NOT_FOUND: "Product ID is not found",
      AMONG_THE_SELECTED_PRODUCTS_TAKEN_OUT:
        "Among the selected there are products from the warehouse. Re-select products",
      MORE_PRODUCTS_ARE_BEING_PROVIDED:
        "More products are being delivered than indicated in the order",
      IMPOSSIBLE_TO_TAKE_ON_THE_TWO_PARTIES_AT_ONCE:
        "It is impossible to pick up two batches at once. Need to take one",
      GOODS_HAVE_NOT_BEEN_GIVEN_FOR_THIS_ORDER_PARTIES:
        "For this order and batch, the goods have not been delivered",
      ALREADY_TAKEN_AWAY_PRODUCTS_FOR_THIS_ORDER_PARTIES:
        "Given products are taken away for this order",
      TAKE_MORE_PRODUCTS_THAN_GIVEN: "You take more products than is given out",
      USER_NOT_ATTACHED_TO_DEPARTMENT:
        "The user who wrote the application is not attached to the section",
      USER_NOT_ATTACHED_TO_WAREHOUSE:
        "The user who wrote the application is not attached to the warehouse",
      CONTRACT_IS_NOT_FOUND: "Contact is not found",
      CANNOT_ACCEPT_MORE_THAN_ONE_SHIPMENT:
        "Cannot accept more than given quantity",
      PRODUCT_TYPE_NOT_FOUND: "Product type not found",
      PRODUCT_GROUP_NOT_FOUND: "Product group not found",
      SERVLET_RESPONSE_FOR_GENERATE_QR_CODE_IS_NULL:
        "Servlet response for generate QR code is null",
      MUST_ENTER_NAME: "Name is required",
      CUSTOMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Customer with the same name has already registered",
      CUSTOMER_NOT_FOUND: "Customer not found",

      THE_CARRIAGE_DOES_NOT_BELONG_ANY_STELLAGE:
        "This carriage does not belong to any stellage",
      STELLAGE_NOT_FOUND: "Stellage not found",
      REQUEST_IS_NULL: "Request is null",
      COLUMN_SETTINGS_IS_NULL: "Column settings is null",
      ENTER_COLUMN_LABEL: "Enter column label",
      PARENT_ID_FOR_CONTRACT_ITEM_NOT_FOUND:
        "Parent ID for contract item not found",
      HAS_CONTRACT_ALREADY: "There is contract here",
      HAS_ORDER_ALREADY: "There is order here",
      HAS_PRODUCT_ALREADY: "There is product here",
      PRODUCT_IN_STOCK_ROT: "There is product in warehouse. You cannot delete",
      IDS_FIELD_REQUIRED: "ID is required",
      CARRIAGE_IS_NULL: "Carriage is null",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Contract item partition accepted",
      CONTRACT_ITEM_PART_ACCEPT: "Contract item partially accepted",
      CONTRACT_ITEM_ACCEPT: "Contract item accepted",
      CONTRACT_ITEM_REJECT: "Contract item rejected",
      TELEGRAM_GROUP_REQUIRED: "Telegram group required",
      TELEGRAM_GROUP_NOT_FOUND: "Telegram group is not found",
      CONCLUTION_DATE_REQUIRED: "The date of the contract is required",
      GUESS_RECEIVE_DATE_REQUIRED: "Estimated delivery time is required",
      PRODUCTS_DO_NOT_COME_IN_ONE_BATCH_CANNOT_ADDED:
        "Products do not come in one batch cannot be added",
      SECOND_PRODUCT_WAS_NOT_FOUND: "Second product was not found",
      THERE_IS_NO_WAREHOUSE_IN_THIS_DEPARTMENT:
        "There is no warehouse in this department",
      PRODUCTS_REQUESTED_ORDER_NOT_THE_STATUS_PROVIDED:
        "Products requested order are not in the provided status",
      EXCEEDED_THE_QUANTITY_PRODUCT_ORDERED_ALONG_WITH_THE_QUANTITY_PRODUCT_PREVIOUSLY_REQUESTED:
        "Along with the previously requested product quantities, it exceeded the product quantity to be ordered",
      more_than_quantity_product_ordered:
        "You are asking for more than the quantity of product to be ordered",
      PRODUCT_WAREHOUSE_IS_NOT_ENOUGH: "Products is not enough in warehouse",
      YOU_HAVE_NOT_ENTERED_PRODUCT_NUMBER:
        "You have not entered a product number",
      ENTER_THE_QUERY_TYPE: "Enter the query type",
      MORE_REQUESTED_PRODUCT_QUANTITY_IS_INCLUDED_THE_ORDER:
        "More requested product quantity is included in the order",
      CANNOT_DELETE_ITEM_BECAUSE_THE_ITEM_HAS_ALREADY_BEEN_USED:
        "You cannot delete lot because the products have been used",
      PARTY_NOT_FOUND: "Party not found",
      LOT_NOT_FOUND: "Lot not found",
      WANT_IMPORT_MORE_THAN_VOLUME_OF_PRODUCT_RECEIVED:
        "You want to bring in more than the amount of product received",
      INVENTORY_COMPLETE_YOU_HAVE_START_OVER_AGAIN:
        "Inventory completed. Start again",
      INVENTORY_HAS_BEEN_STARTED_WAREHOUSE_YOU_CAN_CONTINUE:
        "Inventory has been started in this warehouse. You can continue",
      REQUEST_NOT_FOUND: "Request not found",
      order_and_products_given_under_batch_were_taken_away:
        "Order and products given under batch were taken away",
      UNIT_TYPE_NOT_MATCH: "Unit type did not match",
      SMS_NOT_SEND: "Message are not sent",
      CELLS_USED: "Select the cell",
      CELL_NOT_FOUND: "Cell not found",
      HAS_STELAGE: "There is stillage here",
      SELECT_THE_WAREHOUSE: "Select the warehouse",
      UNIQUE_KEY_DID_NOT_MATCH: "Unique key did not match",
      TEAM_NOT_FOUND: "Team not found",
      TEAM_NOT_REQUIRED: "Team required",
      TEAM_LEADER_NOT_FOUND: "Team leader not found",
      TEAM_LEADER_REQUIRED: "Team leader required",
      HISTORY_OF_MEDICINE_TAKEN_REQUIRED: "History of medicine taken required",
      HISTORY_OF_MEDICINE_TAKEN_NOT_FOUND:
        "No history of medications taken was found",
      MEDICINE_NOT_FOUND: "Medicine not found",
      MEDICINE_REQUIRED: "Medicine required",
      PATIENT_NOT_FOUND: "Patient not found",
      PATIENT_REQUIRED: "Patient required",
      PASSPORT_REQUIRED: "Passport number required",
      RENT_NOT_FOUND: "Rent not found",
      RENT_REQUIRED: "Rent required",
      EXPIRED_DATE_REQUIRED: "Expiry date required",
      ELIGIBLE_TO_RECEIVE_GOOD_FOR_THIS_ORDER:
        "No permission to order this product",
      AMOUNT_ENTERED_MORE_THEN_AMOUNT_LEFT_IN_WAREHOUSE:
        "Amount entered is more than the amount left in warehouse",
      PRODUCT_IS_NOT_ENOUGH_IN_WAREHOUSE: "Product is not enough in warehouse",
      CHECK_DATABASE: "Check database. No data",
      USER_NOT_REGISTERED: "User is not registered",
      NUMBER_OF_ROWS_IS_NOT_ENOUGH: "Number of rows is not enough",
      OLD_PASSWORD_INCORRECT: "Old password incorrect",
      OLD_PASSWORD_REQUIRED: "Old password required",
      RECOVER_YOUR_PASSWORD:
        "You do not have permission to reset your password",
      CONFIRMATION_CODE_REQUIRED: "Confirmation code required",
      USER_REQUIRED: "User required",
      PHONE_NUMBER_RIGHT_ENTER: "Enter your phone number correctly",
      PHONE_NUMBER_REQUIRED: "Phone number required",
      USERNAME_REQUIRED: "Username required",
      EMAIL_HAS_ALREADY: "User email is registered",
      PHONE_NUMBER_HAS_ALREADY: "User phone number is registered",
      USER_NAME_HAS_ALREADY: "Username is registered",
      HAS_NOT_ACCESS: "You have no access",
      USER_NOT_FOUND: "User not found",
      UNIT_TYPE_DOES_NOT_MATCH: "Unit type does not match",
      SMS_DO_NOT_SEND: "Message is not sent",
      PERMISSION_NOT_FOUND: "Permission not found",
      ROLE_NOT_FOUND: "Role not found",
      ORDER_ITEM_COUNT_COUNTABLE: "Value should be integer",
      PRODUCT_IS_NOT_ENOUGH: "Product is not enough",
      PARTITION_NOT_FOUND: "Party not found",
      ORDER_ITEM_AND_CONTRACT_ITEM_REQUIRED:
        "Order and contract elements required",
      PACKAGE_TYPE_NAME_CREATE_ALREADY: "Package type name already created",
      PACKAGE_TYPE_NOT_FOUND: "Package type not found",
      PACKAGE_NOT_FOUND: "Package not found",
      COUNT_ENOUGHT: "You entered a large amount",
      COUNT_REQUIRED: "Product quantity required",
      OUTGOING_CONTRACT_NUMBER_BUSY: "This contract number is occupied",
      PASSWORD_CHANGE_ACCESS:
        "You do not have permission to change your password",
      CONFIRMATION_CODE_IS_INCORRECT: "Confirmation code is incorrect",
      ORDER_ITEM_REJECT_MUCH_COUNT:
        "Many of the products requested were canceled",
      OPPORTUNITY_NOT_MATCH_COUNT:
        "The amount entered did not match the amount in the contract",
      OPPORTUNITY_COUNT_REQUIRED: "Opportunity count required",
      ORDER_ITEM_REQUIRED: "Order items required",
      UNITTYPE_REQUIRED: "Unit type required",
      PRODUCT_NOT_FOUND: "Product not found",
      PRODUCT_REQUIRED: "Product required",
      INVENTARIZATION_REQUIRED: "Inventorization required",
      INVENTARIZATION_NOT_FOUND: "Inventorization not found",
      GIVEN_PRODUCT_TAKEN_AWAY: "Products for this order are taken away",
      GIVEN_PRODUCT_NOT_FOUND: "Products are not given for this orders",
      PRODUCT_ALREADY_TAKEN_AWAY: "Product already taken away",
      MORE_PRODUCTS_DELIVERED_THAN_SPECIFIED_ORDER:
        "More products are being delivered than specified in the order",
      USER_AGREEMENT_REQUIRED: "User agreement required",
      WAREHOUSE_NOT_FOUND: "Warehouse not found",
      WAREHOUSE_IS_REQUIRED: "Warehouse required",
      DEPARTMENT_REQUIRED: "Department required",
      DEPARTMENT_HAS_USERS_NOT_DELETE:
        "This section cannot be deleted because there are users in this section",
      ACTION_ALREADY_DONE: "You have done this action",
      REJECT_REASON_REQUIRED: "Show a reason for the cancellation",
      SUPPLIER_TYPE_REQUIRED: "Supplier type required",
      UNITTYPE_NOT_FOUND_IN_CONTRACT: "Unit type not found in contract",
      PRODUCT_NOT_FOUND_IN_CONTRACT: "Product not found in contract",
      CONTRACT_ITEM_COUNT_LARGE:
        "More than the amount specified in the contract",
      DESCRIPTION_REQUIRED: "Description required",
      COLUMN_SETTINGS_NOT_FOUND: "Column settings not found",
      TABLE_NOT_SELECTED: "Table not selected",
      PRODUCT_DID_NOT_TO_MATCH: "Product did not match",
      CARRIAGE_NOT_FOUND: "Carriage not found",
      CARRIAGE_IS_REQUIRED: "Carriage required",
      ORDER_COUNT_NOT_ENOUGH: "Order count not enough",
      PRODUCT_ITEM_COUNT_NOT_ENOUGH: "Product item count not enough",
      PRODUCT_ITEM_REQUIRED: "Product item required",
      PRODUCT_ITEM_NOT_FOUND: "Product item not found",
      CONTRACT_REQUIRED: "Contract required",
      CONTRACT_NOT_FOUND: "Contract not found",
      PARTION_NOT_FOUND: "Product party not found",
      PRODUCT_TAKEN_FROM_WAREHOUSE: "Product is taken from warehouse",
      PRODUCTS_IS_REQUIRED: "Products is required",
      ATTRIBUTE_NOT_FOUND: "Attribute not found",
      FILE_NOT_FOUND: "File not found",
      USERNAME_OR_PASSWORD_OR_BLOCK_ACCOUNT:
        "Incorrect username or password or the user is not active in this system",
      USERNAME_OR_PASSWORD_WRONG: "Incorrect username or password",
      PRODUCT_COUNT_NOT_DOT_MATCH: "The number of products did not match",
      OUTGOING_CONTRACT_COUNT_NOT_DOT_MATCH:
        "You have entered more than the amount specified in the contract",
      TO_REVIEW_WAREHOUSE: "MCD is considering",
      PRODUCT_RECEIVED: "Product Received",
      ENTER_POSITIVE_VALUE: "Enter positive value",
      ORDER_BUSY: "Order busy",
      formatFileNotSupported: "Format file not supported",
      NAME_ALREADY_EXISTS: EnValidateMessages.messages.exist
        .replace("{_title_}", "name")
        .replace("{_field_}", "attribute"),
      CONTRACT_DECISION_HAS_ALREADY_BEEN_MADE:
        "Contract decision has already been made",
      HASH_CODE_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Hash code"
      ),
      DOCUMENT_PARAMS_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Document params"
      ),
      ACTION_TYPE_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Action type"
      ),
      CONTRACT_ITEM_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Contract item"
      ),
      BAD_CREDENTIALS: "Login or password wrong",
      SUPPLIERTYPE_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Supplier type"
      ),
      SUPPLIER_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Supplier"
      ),
      CONFIRMATION_CODE_IS_EXPIRED: "Confirmation code is expired",
      GIVEN_OLD_PASSWORD_INCORRECT: "Old password incorrect",
      USERNAME_NOT_FOUND: "User name not found",
      NAME_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Name"
      ),
      UNITTYPE_NOT_FOUND: "Unit type not found",
      BLOCK_ACCOUNT: "Account has blocked",
      BAD_REQUEST: "Request invalid",
      NOT_FOUND: "Not found",
      UNAUTHORIZED: "Unauthorized",
      FILE_REQUIRED: "The file required",
      ERROR_WHILE_SAVING_FILE: "An error occurred while uploading the file",
      SUPPLIER_NOT_FOUND: "Supplier not found",
      NOT_ENOUGH_INFORMATION: "Not enough information",
      CONTRACT_ITEM_NOT_FOUND: "Contract not found",
      INITIATOR_NOT_FOUND: "Initiator not found",
      MUST_ENTER_INITIATOR: "The Initiator field is required",
      CONTRACT_ITEM_ID_IS_NULL: "Contract id must not null",
      CUSTUMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "The supplier with the same name is already registered",
      DEPARTMENT_NOT_FOUND: "Department not found",
      ID_REQUIRED: "Id required",
      ORDER_ITEM_ID_REQUIRED: "Order item required",
      ORDER_ITEM_NOT_FOUND: "Order item not found",
      ORDER_ITEMS_REQUIRED: "Order items required",
      ORDER_NOT_FOUND: "Order not found",
      ERROR_SENDING_OTP_CODE: "Error sending otp code",
      REQUESTCOUNT_AND_GIVENCOUNT_IS_REQUIRED:
        "The field request count and given count fields are required",
      CONTRACT_NUMBER_REQUIRED: "Contract number required",
      OUTGOING_CONTRACT_NOT_FOUND: "Outgoing contract not found",
      REALIZATOR_REQUIRED: "The Implementator field required",
      REALIZATOR_NOT_FOUND: "The Implementator not found",
      USER_AGREEMENT_NOT_FOUND: "User agreement not found",
      NEW_PASSWORD_REQUIRED: "The New password field is required",
      ENTER_TIME_FORMAT_CORRECTLY: "Please enter time correctly",
    },
    accountingCode: "Accounting code",
    accepted: "Accepted",
    hintSendOrderAfterCreate:
      "Successfully created a request. Now send a request to MCD with this button",
    uploadPhoto: "Upload a photo",
    enterText: "Enter text",
    find: "Find",
    start: "Start",
    warnings: "Warnings",
    downloadProductList: "Download list of products",
    carriageAddress: "Carriage address",
    stillageAddress: "Stillage address",
    viewFile: "View file",
    productReport: "Product report",
    productIsNotPlace: "The product is not in place",
    numNotEnough: "Quantity is not enough",
    quantityInExcess: "Quantity in excess",
    productCount: "Product count",
    productIssued: "Product Issued",
    givenProduct: "Given",
    givenProductQuantity: "Quantity of products to be given",
    addWithFile: "Add product with file",
    allCarriagesEmpty: "All carriages are empty",
    halfEmpty: "Сarriages are тще empty",
    carriagesFull: "Carriages are full",
    warehouseIndicators:
      "The indicators on the right side of the stellage mean the following:",
    hint: "Hint",
    rightClickingMouse:
      "Select the desired cell to place the product by right-clicking the mouse",
    viewContractDetails: "View the contract details",
    productAcceptance: "Product acceptance",
    admissionConfirmation: "Admission confirmation",
    agreementStatus: {
      ORDER_ITEM_PRODUCE: "Accepted",
      USER_AGREEMENT_ACCEPTED: "User agreement accepted",
      USER_AGREEMENT_REJECTED: "User agreement rejected",
    },
    noApprovedContracts: "There are no contracts that need to be approved",
    confirmWithKey: "Confirm with a key",
    accountCode: "Account Code",
    placedBy: "By whom",
    deliveredDate: "Date of arrival at the warehouse",
    takenAwayDate: "Taken Away Date",
    aboutProduct: "About the product",
    existingInv: "This product is inventorized",
    inventarizationStopped:
      "Inventorization is stopped in the {warehouse} warehouse",
    continueInventarization: "Continue",
    finishInventarization: "Complete",
    receive: "Receive",
    toWriteOff: "Write off",
    naming: "Name",
    designation: "Designation",
    row: "Row",
    hiddenWarehouses: "Hidden warehouses",
    supportService: "Support",
    divisionType: "Subdivision type",
    toCancel: "Cancel",
    chooseAnotherStatus: "Choose another status",
    selectWarehouse: "Select warehouse",
    datePlaceholder: "dd/mm/yyyy",
    downloadTemplateFile: "Download a template file for importing a product",
    organizationName: "Organization name",
    weekShortTitle: {
      0: "Sun",
      1: "Mon",
      2: "Tue",
      3: "Wed",
      4: "Thu",
      5: "Fri",
      6: "Sat",
    },
    weekShort: {
      0: "S",
      1: "M",
      2: "T",
      3: "W",
      4: "T",
      5: "F",
      6: "S",
    },
    monthsNames: {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December",
    },
    monthsNamesShort: {
      0: "Jan",
      1: "Feb",
      2: "Mar",
      3: "Apr",
      4: "May",
      5: "Jun",
      6: "Jul",
      7: "Aug",
      8: "Sep",
      9: "Oct",
      10: "Nov",
      11: "Dec",
    },
    startInventarization: "Start inventorization",
    inventarization: "Inventorization",
    wantToDistribute: "Do you want to distribute {count} product?",
    enterQuantity: "Enter the amount",
    distribution: "Distribution",
    orderQuantity: "Quantity of orders on request",
    totalOrders: "Total number of orders",
    productDelivery: "Product Delivery",
    place: "Place",
    spaceLeft: "Is there any more space left after the product is installed?",
    putProduct: "I really put it here",
    confirmPlacement: "Confirm that you have placed the product on this place",
    placeInFreeSpace: "Place in free space",
    placedDate: "Date of placement",
    invDate: "Inv date",
    whoPosted: "Who posted",
    quantity: "Quantity",
    placedProducts: "Placed Products",
    placeHere: "Place here",
    selectPlacement: "Select an area to place",
    tmtPlacement: "Placement of product",
    determinePlacement: "Locate n Place-",
    existingQr: "This QR is loaded",
    addQrCode: "Add QR code",
    showDetails: "Show Details",
    enterQrCode: "Enter the QR code",
    scan: "Scan",
    pressToScan: "Press the button to scan the QR code",
    placement: "Placement",
    leftToCapitalize: "Left to capitalize",
    palletsNumber: "Number of Palletes",
    invoiceNumber: "Invoice number",
    invoiceDate: "Invoice date",
    actNumber: "Act number",
    gtd: "GTD",
    manufactureDate: "Date of manufacture",
    dataOfReceipt: "Date of receipt",
    numberOfPackages: "Number of packages",
    createIncome: "Income generation",
    createLots: "Create lots",
    thinkDefective:
      "Do you really think that {count} {unit_type} items are defective?",
    rejectedCount: "Rejected number",
    enterAmount: "Enter the amount that TMTs accept",
    defectiveGoodsNumber: "Specify the number of defective goods TMTs",
    leaveComment: "Leave a comment",
    attachPhotosAndComment: "Leave a comment and picture",
    matched: "Matched",
    partialAdmission: "Partial admission",
    notCompatible: "Not compatible",
    partyReception: "Party Reception",
    wantToChange: "Do you really want to change?",
    wantToAdd: "Do you really want to add?",
    addAnotherRecipient: "Add another recipient",
    sendPushNotification: "Sending push notification",
    changeEmployee: "Change Employee",
    sectionName: "Section name",
    chooseInitiator: "Choose an entrepreneur",
    selectSection: "Section Selection",
    changeInitiator: "Do you want to replace this employee?",
    selectAll: "Select all",
    acceptedInitiatorCount: "Number of initiators received",
    partiallyAccepted: "Partially accepted",
    confirmWithEimzo: "Confirm with e-signature",
    selectKey: "Select the key",
    eimzo: {
      valid: "Действителен",
      certificateNumber: "№ сертификата",
      certificate: "Certificate",
      stir: "STIR",
      fullName: "Full Name",
      organization: "Organization",
      expiryDate: "Validity of the certificate",
      pnfl: "JSHSHIR",
    },
    numberOfDelinquencies: "Number of delinquencies",
    showDuplicates: "Show duplicates",
    duplicateProducts: "Duplicate products",
    basicToolReports: "Fixed assets report",
    basicToolReportsTitle: "Generate a report on fixed assets",
    oldQr: "Old QR",
    newQr: "New QR",
    moveCount: "Movable count",
    Id: "Id",
    moveQr: "Shuffle to new QR",
    moveQrToExist: "Shuffle to existing QR",
    moveProduct: "Move product",
    moveProductConfirmDesc: "Do you really want to move this item?",
    moveToWarehouse: "Give back to warehouse",
    existQr: "Exist QR",
    splitQr: "Split QR",
    materialsThatEnd: "Materials that end",
    analytics: "Analytics",
    frequentlyGoodsMaterials: "Frequently used products",
    yearShort: "{0} y.",
    delaysReport: "Delays report",
    invalidProductReport: "Invalid product report",
    latencyRequests: "Latency requests",
    expirationGoodsMaterials: "Report on expiration of goods and materials",
    developedBy: "Developed by {0}",
    expired: "Expired",
    contractInitiator: "Contract initiator",
    pageCount: "Page count",
    uploadFile: "Upload file",
    authorization: "Authorization",
    weight: "Weight/count",
    reload: "Reload",
    reindexAll: "Reindex all",
    reindex: "Reindex",
    allProduct: "All products",
    qrCode: "QR code",
    msdsFile: "MSDS file",
    print: "Print",
    dateAcceptance: "Date of acceptance",
    wantToContinue: "Want to continue ?",
    loading: "Loading...",
    updatedByUser: "Updated by user",
    changed: "Changed",
    price: "Price",
    gaveUser: "Who gave",
    printQrCode: "Print QR code | Print QR codes",
    ourProducts: "Our products",
    writeOff: "Write off",
    writeOffProduct: "Write off product",
    file: "File",
    reference: "References",
    writeOffed: "Write offed",
    ozl: "PLD",
    searchForNumber: "Search for number",
    login: "Login",
    categoryProduct: "Product category",
    password: "Password",
    ourOrders: "Our orders",
    create: "Create",
    createNewRequest: "Create new request",
    or: "or",
    orderNotAddYet: "Order not add yet. Click plus to add request.",
    addOrderItemToRequest: "Add product to request",
    sortable: "Sortable",
    minWidth: "Min. width",
    orderRequestItemNumber: "№ in request",
    limitProductCount: "Minimum inventory",
    productCategory: "Product category",
    timeToBeEntered: "Created time",
    pendingPurchaseDate: "Pending purchase date",
    updatedDate: "Updated date",
    itemConclusionDate: "Date of last acts/operations",
    count: "Count",
    countShort: "Count",
    countQr: "Count QR",
    unit: "Measure",
    from: "from",
    downloadFile: "Download file",
    downLoadFileContract: "Download file contract",
    historyContractCode: "History contract {code}",
    fileRequest: "File request №{numb}",
    error: "Error",
    inventoryTime: "Inventory time",
    writeOffTime: "Write-off time",
    writeOffByUser: "Written off by (user)",
    numberOfValidProducts: "Number of valid products",
    numberOfInvalidProducts: "Number of invalid products",
    inventory: "Inventory",
    envNumber: "ENV number",
    errorHasOccurred: "An error has occurred",
    prev: "Back",
    productName: "Product name",
    whoImplemented: "Who implemented",
    sendDepartmentName: "The department from which the products came",
    send: "Send",
    typeProduct: "Product type",
    receiverDate: "Actual delivery date",
    date: "Date",
    extraOptions: "Extra options",
    extra: "Extra",
    more: "More",
    sendDate: "Time the request was sent",
    placeProductIn: "Place product in {warehouse}",
    type: "Type",
    status: "Status",
    noDataAvailable: "No data",
    prevStatus: "Предыдущий статус",
    currentStatus: "Текущий статус",
    nameOfSupplier: "Name",
    nameOfCustomer: "Name of customer",
    warehouse: "Warehouse",
    createWarehouse: "Create warehouse",
    product: "Product",
    columns: "Columns",
    attachFile: "Attach file",
    deliveryDate: "Delivery date",
    orderSent: "Order sent",
    sendAgain: "Send again",
    productGroup: "Product group",
    reportInventory: "Report inventory",
    writeOffFromThem: "Write off them",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    add: "Add",
    searchForName: "Search for name",
    orderItemByDepartment: "Order item by department",
    productCreate: "Create product",
    productEdit: "Edit product",
    editCategory: "Edit category",
    byCategory: "Number of query items by category",
    byOrderItemStatus: "By order item status",
    byTime: "Number of requests by time",
    category: "Category",
    nameOfGroup: "Name of group",
    name: "Name",
    group: "Group",
    description: "Description",
    notIncomeSmsHint: "SmS did not arrive. Try again!",
    stillageStatus: {
      full: "Full",
      empty: "Empty",
      hasSpace: "Has space",
    },
    warehouseFieldType: {
      corridor: "Corridor",
      field: "Field",
      stillage: "Stillage",
      carriage: "Carriage",
    },
    action: "Action",
    typeProducts: "Product types",
    realization: "Realization",
    inventoried: "Inventoried",
    day: "Day",
    month: "Month",
    year: "Year",
    allTime: "All time",
    omtk: "MCD",
    groupProducts: "Group products",
    whoProduced: "Who produced",
    finishOrder: "Complete request",
    contractCompleteDate: "Contract closing date",
    nContract: "Contract №",
    groups: "Groups",
    requests: "Requests",
    requestNumber: "Request number",
    requestNumberN: "Request number {number}",
    numberPositionInContract: "Position № in contracts",
    newVersionFoundHint: "A new version is found. Refresh to load it?",
    occupancyPercent: "Occupancy percent",
    occupiedPlacePercent: "Occupied place {percent}%",
    subdivision: "Department",
    initiator: "Initiator",
    categoryTMC: "Category TMC",
    documents: "Documents",
    typeTMC: "Type TMC",
    contractNumber: "Contract number",
    contractDocuments: "Contract documents",
    number: "Number",
    requestStatus: "Request status",
    requestPositionStatus: "Request position status",
    viewHistory: "View history",
    packageCount: "Package count",
    userName: "User name",
    assumptionSendDate: "Estimated delivery date",
    importFromExcel: "Import from excel",
    exampleExcel: "Download example file for import product",
    guessReceiveDate: "Estimated delivery date",
    phone: "Phone number",
    firstName: "Name",
    changePassword: "Change password",
    viewContractHistory: "View contract history",
    doYouWantGoBack: "Do you really want to return this status?",
    lastName: "Last name",
    email: "Email",
    middleName: "Surname",
    filter: "Filter",
    whoChangeStatus: "Who changed the request status",
    statusChangedUser: "Who changed the status of request",
    positionStatus: "Position of status",
    ourRequest: "Our requests",
    clear: "Clear",
    itIsEmpty: "It is empty",
    addProduct: "Add product",
    hasProductInWereHouse: "Product is in stock",
    implementator: "Implementator",
    clearFilter: "Clear filter",
    expiration: "Expiration days",
    notEnoughProduct: "Not enough quantity",
    implementDate: "Realization date",
    noProduct: "Out of stock",
    noPlacementProduct: "No placement product",
    enterValue: "Enter value",
    addAttribute: "Add attribute",
    material: "Material",
    nameAttribute: "Name attribute",
    reportWriteOff: "Write-off  report",
    value: "Value",
    attributes: "Attributes",
    used: "Used",
    attributeProduct: "Attribute product",
    forgetPassword: "Forget password?",
    passwordChanged: "Password changed",
    logOut: "Log out",
    enterToSystem: "Enter to system",
    notification: "Notification",
    next: "Next",
    confirmPassword: "Confirm password",
    limit: "Limit",
    filled: "Filled",
    income: "Income",
    incomeReport: "Income report",
    movedToWarehouseAndInProgress: "Moved to warehouse and in progress",
    reportIncome: "Report income",
    reportExpense: "Expense report",
    show: "Show",
    department: "Department",
    department2: "Department",
    departmentIdAlert:
      "You must have a department to use the system. Please contact the admin!",
    successfullySaved: "Successfully saved",
    addedNewOrder: "Added new order",
    addedNewContract: "Added new contract",
    enable: "Enable",
    updatedSuccessfully: "Changed successfully!",
    successfullyAccepted: "Successfully accepted",
    successfullyRejected: "Successfully rejected",
    newPassword: "New password",
    oldPassword: "Old password",
    oldWarehouse: "Old warehouse",
    successfullyDeleted: "Successfully deleted",
    title: "Title",
    orderHistoryNumb: "Order history {numb}",
    successfullySent: "Successfully sent",
    deleteDepartmentHint:
      "If you delete this department, all users will also be deleted in this department!",
    receptionDate: "Input reception date",
    typeDelivery: "Type of delivery",
    contractDate: "Contract date",
    estimatedDeliveryDate: "Estimated delivery date",
    sendNotificationToOMTK: "Send notification to MCD",
    sendNotification: "Send notification",
    sendNotificationToAccounting: "Send notification to Accounting",
    toOMTK: "To MCD",
    toAccounting: "To Accounting",
    accountant: "Accountant",
    contractHistory: "Contract history | Contract item history",
    orderHistory: "Order history | Item order history",
    productHistory: "Product history",
    provider: "Provider",
    users: "Users",
    dateWriteOff: "Date write off",
    doYouWantReject: "Do you want reject {count}",
    outGoingContracts: "Outgoing contracts",
    listOfVisits: "List of visits",
    done: "Done",
    allAttributes: "All attributes",
    attributeSearch: "Attribute Search",
    valueSearch: "Value search",
    roles: "Roles",
    additionalRole: "Additional role",
    permissions: "Permissions",
    internal: "Internal",
    import: "Import",
    categories: "Categories",
    added: "Added",
    productNumber: "Product number",
    lotName: "Lot name",
    searchByName: "Search by name",
    requestSubmissionDate: "Request Submission Date",
    createContract: "Create contract",
    filterBySupplier: "Search by supplier",
    filterByInitiator: "Search by supplier initiator",
    profile: "Profile",
    all: "All",
    addToContract: "Add to contract",
    settings: "Settings",
    tableName: "Product name",
    columnLabel: "Column name",
    columnValue: "Column value",
    reject: "Reject",
    nameOfProduct: "Product name",
    measure: "Measure",
    measureShort: "Measure",
    terminate: "Terminate",
    contractTerminated: "Terminate contract",
    signed: "Signed",
    addMoreProductToRequest:
      "This product has already been added to this request add more",
    products: "Products",
    tender: "Send to PLD",
    groupOfProduct: "Group product",
    dateWhenYouNeedToPutEverything: "Estimated delivery date",
    hide: "Hide",
    remainingContract: "Remaining contract",
    remains: "Remains",
    implemented: "Implemented",
    willBeAddedToNewRequest: "{0} will be added to the new request",
    dateOfConclusionContract: "Contract date",
    new: "New",
    enterDate: "Enter date",
    customer: "Customer",
    rejectRequest: "Reject request",
    addPosition: "Add to position",
    expenses: "Expenses",
    //status
    [orderItemStatus.YES_PRODUCT]: "Ready to produce",
    NOT_ACCEPTED_ORDER: "Not satisfied",
    RECEIVED: "Received",
    DELETED: "Deleted",
    [orderItemStatus["ISSUED_ORDER_ITEM"]]: "The product has arrived",
    [orderItemStatus["OZL_TO_DEPARTMENT"]]: "Waiting for change",
    [orderItemStatus["DELIVERY_EXPECTED"]]: "Delivery expected",
    [orderItemStatus["READY_TO_PRODUCE"]]: "Product in stock",
    [orderItemStatus["COMPLETED"]]: "Completed",
    ACCEPTED_ORDER: "Satisfied",
    TO_REVIEW_WAREHOUSE: "MCD is considering",
    NO_PRODUCT: "TMS out of stock",
    [orderItemStatus.YES_PRODUCT]: "TMS in stock",
    REJECT_ORDER_ITEM: "Request rejected by MCD",
    PAPER_EXPECTED_SPECIFICATION: "Paper specification is expected",
    PENDING_PURCHASE: "Pending purchase",
    PRODUCT_DELIVERED: "Product delivered",
    APPLICATION_REJECTED_OZL: "Request terminated by PLD",
    CONTRACT_CONCLUTION: "Contract concluded",
    CONTRACT_TERMINATED: "Contract terminated",
    NEW: "New",
    to: "to",
    parentNameCategories: "Parent category name",
    resentHint: "You can send again via",
    columnName: "Column name in table",
    parent: "Parent",
    reasonRejectContract: "Reason for termination",
    acceptedCount: "Number Received",
    uploadFileRequest: "Upload file request",
    contractRejectionHint:
      "Please enter the reason for termination of the contract",
    conclusionAndReceived: "Concluded and accepted",
    newCategoryName: "New Category Name",
    addCategory: "Add category",
    addInventory: "Add inventory",
    nameCategory: "Name category",
    nameOfGoodsAndMaterials: "Name of goods and materials",
    acceptedContracts: "Accepted contracts",
    conclusionContracts: "Conclusion contracts",
    reasonForRefusal: "Reason for refusal or termination",
    changeCategory: "Change category",
    changeInventory: "Change inventory",
    addGroup: "Add Group",
    homeFurniture: "Home furniture",
    hasCount: "Available",
    livingRoomFurniture: "Furniture for the living room",
    initiatorOzl: "Initiator PLD",
    areAvailable: "Are available",
    notEnoughQuantity: "Not enough quantity",
    hasPlace: "Has place",
    noPlace: "No place",
    yes: "Yes",
    notAvailable: "Not available",
    sendToOzl: "Send to PLD",
    specAccepted: "Specification accepted",
    productAvailableNotEnoughQuantity: "Inventory is there is not enough",
    givePartiallyProduct: "Materials are available, partially issue",
    state: "Status",
    editGroup: "Edit group",
    editZone: "Edit zone",
    createZone: "Create zone",
    suppliers: "Suppliers",
    supplier: "Supplier",
    giveOut: "Give out",
    available: "Available",
    refuse: "Refuse",
    asked: "Asked",
    requestApproved: "Request approved",
    team: "Team",
    addRealizationProduct: "Add realization product",
    hidden: "Hidden",
    mainWarehouse: "Main warehouse",
    inWarehouse: "In warehouse",
    mainDepartment: "Main department",
    productsInDraft: "Products in draft",
    browseFile: "Choose file or drag the file here",
    wantAddProduct: "Do you want to add product?",
    warehouses: "Warehouses",
    orders: "Orders",
    teamLeader: "Team leader",
    productCode: "Product code",
    countOfRequested: "Count of request",
    requestRejection: "Request rejection",
    requestRejectionHint: "Please enter a reason for rejecting the request",
    movingProducts: "Moving products",
    requestFinishHint: "Please enter a reason for finishing the request",
    reasonRejectRequest: "Reason to reject the request",
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    createSupplier: "Create supplier",
    createOrder: "Create order",
    createType: "Create type",
    typeSupply: "Type of delivery",
    update: "Update",
    updateNewVersion: "Update",
    updateType: "Update type",
    updateSupplier: "Update supplier",
    updateCustomer: "Update customer",
    position: "Position",
    visible: "Visible",
    numberRequest: "Request №",
    approve: "Approve",
    approveRequest: "Approve request",
    no: "No",
    yesDelete: "Yes, delete",
    warning: "Warning!",
    wantDeleteHint: "Do you really want to delete?",
    comment: "Comment",
    color: "Color",
    size: "Size",
    youHaveNotAccess: "You have not access",
    acts: "Acts",
    editContract: "Edit contract",
    attachAct: "Attach act",
    code: "Code",
    address: "Address",
    contracts: "Contracts",
    open: "Open",
    nameGroup: "Group name",
    addToBasket: "Add to basket",
    moveProductStatus: {
      NEW: "New",
      APPROVED: "Approved",
      REJECTED: "Rejected",
    },
    receptionStatus: {
      NEW: "Not issued",
      REQUEST_DONE: "Issued",
    },
    history: "History",
    successMessages: {
      reIndexed: "Re indexed",
    },

    notificationTemplate: {
      departmentToOmtk: "{userName} wants to pick up {count} {productName}",
      ozlToOmtkProfitProduct:
        "Under this contract №{contractNumber} {productName} has arrived",
      ozlToAccountProfitProduct:
        "The delivery of goods for this position  is expected under the contact {contractNumber}. Please, prepare a power of attorney.",
    },
    orderItemStatusDescription: {
      [orderItemStatus.YES_PRODUCT]: "You can pick it up at warehouse {name}",
      [orderItemStatus["PAPER_EXPECTED_SPECIFICATION"]]:
        "Contact the appropriate department to create a purchase requisition",
    },
    outGoingContractStatus: {
      CONCLUDED: "Concluded",
      COMPLETED: "Completed",
    },
    contractStatus: {
      /**
       * * Contract status
       * */
      USER_AGREEMENT_ACCEPTED: "Accepted",
      USER_AGREEMENT_DELETED: "Deleted",
      USER_AGREEMENT_REJECTED: "Rejected",
      USER_AGREEMENT_PART_ACCEPTED: "Partially Accepted",

      CONTRACT_CONCLUTION: "Contract concluded",
      CONTRACT_ACCEPTED: "Contract Accepted",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Contract item partition accepted",
      PART_ACCEPTED: "Partially accepted",
      CONTRACT_REJECT: "Terminated",
      /**
       * * Contract item status
       * */
      NEW: "New",
      CONTRACT_ITEM_ACCEPTED: "Contract accepted",
      DELETED: "Deleted",
      CONTRACT_ITEM_REJECT: "Contract rejected",
      CONTRACT_ITEM_PART_ACCEPTED: "Partially accepted",
      CONTRACT_NEW: "New",
    },
    contractOmtkStatus: {
      /**
       * * Contract item status
       * */
      CONTRACT_ITEM_ACCEPTED: "Accepted",
      CONTRACT_ITEM_REJECT: "Rejected",
      CONTRACT_ITEM_PART_ACCEPTED: "Partial admission",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Partition accepted",
      NEW: "New",
    },
    contractDivisionStatus: {
      /**
       * * Contract item status
       * */
      ACCEPTED: "Accepted",
      REJECTED: "Rejected",
      PART_ACCEPTED: "Partial admission",
      WAITING: "My decision is pending",
    },
    orderItemStateOmtk: {
      available: "Available",
      noAvailable: "Not available",
      notEnough: "Not enough quantity",
    },
    productPackageType: {
      COUNTABLE: "Countable",
      PACKAGEABLE: "Partitionable",
    },
    productItemStatus: {
      NEW: "New",
      PRODUCT_PRODUCED: "Product produced",
      PRODUCT_USED: "Used",
      DELETED: "Deleted",
    },

    validation: EnValidateMessages.messages,
    $vuetify: {
      fileInput: {
        counter: "{0} files",
      },
      dataIterator: {
        loadingText: "Loading",
      },
      datePicker: {
        nextMonthAriaLabel: "next month",
        prevMonthAriaLabel: "prev month",
        prevYearAriaLabel: "prev year",
        nextYearAriaLabel: "next year",
      },
      noDataText: "No data",
      pagination: {
        ariaLabel: {
          next: "Next",
          wrapper: "Wrapper",
          previous: "Previous",
          currentPage: "Current page",
          page: "Page",
        },
      },
      dataTable: {
        sortBy: "Sort by",
        ariaLabel: {
          sortNone: "Sort no",
          activateAscending: "Active ascending",
          activateDescending: "activateDescending",
          sortAscending: "sortAscending",
          sortDescending: "sortDescending",
          activateNone: "activateNone",
        },
      },
    },
    errors: {
      productNotSaved: "Product is not saved",
      "Request aborted": "Request aborted",
      noRequestAdded: "No request added",
      "Request failed with status code 400": "Request failed 400",
      "Request failed with status code 500": "Request failed 500",
      "Request failed with status code 502": "Request failed 500",
      "Request failed with status code 401": "Request failed 401",
      "Request failed with status code 404":
        "Request failed with status code 404",
      "Network Error": "Network error or something wrong with the server",
      "E-Imzo not installed": "E-Imzo not installed",
    },
    packageType: "Package type",
    printQr: "Print QR",
    printedQr: "Printed",
    notPrintedQr: "Not printed",
    acceptUser: "Received (user)",
    reports: "Reports",
    materialReport: "Material report",
    dashboardTableType: {
      graph: "Graph",
      table: "Table",
    },
    getMaterialReport: "Download material report",
    support: "Support",
    dateFrom: "Date from",
    dateTo: "Date to",
  },
  ru: {
    search: "Поиск",
    fromUp: "от",
    fromTo: "до",
    data: "Дата",
    telegramBotLink: "Ссылка на телеграм бота:",
    yourPhoneAccept: "Ваш номер телефона для получения уведомления в телеграм:",
    backToHome: "Вернуться в кабинет",
    youdonothaveaccess: "У вас нет доступа к этой странице :(",
    officeProducts: "Товары офиса",
    storeTheOffice: "Склад офиса",
    employees: "Сотрудники",
    FINISHED: "Завершен",
    STARTED: "В процессе",
    process: "Процесс",
    designatedPerson: "Назначенное лицо",
    carriageFrom: "Из каретке",
    stillageFrom: "Из стеллажа",
    stillageTo: "В стеллажа",
    carriageTo: "В каретке",
    endDate: "Дата окончания",
    startDate: "Дата начала",
    attachDepartmentToUser: "Прикрепить к отделу",
    numberOfProducts: "Кол-во товаров",
    invCode: "Инв. код",
    exportExel: "Экспорт в Excel",
    attachProduct: "Прикрепить товар",
    attachedToEmployee: "Прикреплен к сотруднику",
    departmentName: "Название отдела",
    totalNumberOfProducts: "Общая Кол-во товаров",
    addDepartment: "Добавить отдел",
    codeForInventory: "Код для инвентиризации",
    generation: "Генерация",
    generateQrCodeAndInventoryCode:
      "Генерировать QR-код и код для инвентаризаций ",
    forrealization: "Для реализации",
    foruse: "Для использования",
    productCondition: "Состояние товара",
    productPhotos: "Фотографии товара",
    quantityProducts: "Количество товара",
    dataModified: "Дата изменения",
    resPerson: "Ответственное лицо (Завсклад)",
    resPerson1: "Ответственное лицо",
    myOffice: "Мой офис",
    movingproducts: "Перемещение товара ",
    videoInstruction: "Видео инструкция",
    productManagementTitle: "Управление продуктами",
    fio: "Ф.И.О",
    modules: "Модули",
    navModalTitle: "Местоположение склада",
    navModalDescription: "Вы можете поделится локации",
    navModalBtn: "Перейти на карту",
    close: "Закрывать",
    changeTariff: "Изменить тариф",
    changeYourTariff: "Чтобы продолжить, пожалуйста измените свой тариф",
    hitYouLimit: "Вы привесили свой лимит",
    apply: "Применить",
    selectZoneForWarehousePlaceholder: "Выберите зону для склада",
    selectZoneWhichYouWant: "Выберите зону которую хотите прикрепит",
    warehouseNotHere: "Прикрепленные склады не найдены",
    fullParcent: "Заполнено",
    goBlackWarehouse: "Перейти на черный склад",
    attachToZone: "Прикрепит к зону",
    showOnTheMap: "Показать на карте",
    editBlackWarehouse: "Изменить черный склад",
    numberOfStillage: "Кол-во стеллажей",
    zone: "Зона",
    fromWhichWarehouse: "Из какого склада?",
    whichWarehouse: "В какой склад?",
    selectProduct: "Выбрать товар",
    totalQuantity: "Общая кол-во",
    positionStillage: "Место положения в стиллажах",
    writeQuantity: "напишите кол-во",
    move: "Переместить",
    numberOfPlaces: "Кол-во мест:",
    busyCount: "Занято:",
    emptyCount: "Пусто:",
    hiddenWarehouseDescription:
      "Предоставление видимости и контроля определенным лицам для хранения и управления товарами определенного типа.",
    hiddenWarehouse: "Скрыть склад",
    regularWarehouseDescription:
      "это стандартное помещение для размещения стеллаж ",
    regularWarehouse: "Обычный склад",
    areaWarehouseDescription:
      "Выбирая этот тип вы создаете пространство где может расположиться несколько малых или больших складов.",
    areaWarehouse: "Зона складов",
    typeWarehouses: "Типы складов",
    selectWarehouseType: "Выберете тип склада",
    createWarehouseSubTitle: "Начинаем с чистого листа",
    addPermission: "Добавить разрешение",
    editWarehouse: "Изменить склад",
    tin: "Тин",
    productPhoto: "Фото товара",
    productCharacteristics: "Характеристики товара",
    certificateNumber: "№ сертификата",
    sign: "Войти",
    whatEDSKey: "Что такое ЭЦП ключ?",
    loginWithEDS: "Вход с помощью ЭЦП",
    loginTab: "Вход в систему",
    incomingGoods: "Входящие товары",
    outgoingGoods: "Исходящие товары",
    remainingCurrently: "Остаток (на текущий момент)",
    shippedProducts: "Продукты отправлены",
    consignmentNote: "Накладная",
    gotIt: "Понятно",
    unreceivedProducts: "Не полученные продукты",
    sourceWarehouse: "Источник склада",
    hintSendOrderAfterCreate:
      "Успешно создали запрос. Теперь отправте запрос в ОМТК с помощью этой кнопки ",
    serverErrorMessages: {
      UNSIGNED_ENTITY_NOT_FOUND: "Товар не найден",
      CHANGE_WAREHOUSE: "Товар отсутствует на этом складе",
      PRODUCT_NAME_AND_ATTRIBUTE_WITH_DUPLICATE:
        "Товар с таким именем существует",
      PRODUCT_NAME_MAX_LENGTH:
        "Название продукта состоит максимум из 600 символов",
      HAS_CARRIAGE: "Здесь есть каретка",
      CONTRACT_ITEM_CHANGE_STATUS:
        "Невозможно перейти из одного состояния в другое",
      PRODUCT_NOT_GIVEN_DEPARTMENT: "Не введен в эксплуатацию",
      CONTRACT_NUMBER_BUSY: "Контракт занят",
      USER_NOT_FOUND_WITH_USERNAME:
        "Пользователь не найден с этим именем пользователя",
      ORDER_INITIATOR_NOT_FOUND: "Инициатор не найден в пункте заказа",
      ACCOUNTANT: "Бухгалтер",
      CHEIF_ACCOUNTANT: "Главный бухгалтер",
      TIME_OF_DELIVERY: "Время доставки",
      ACCOUNT_CODE: "Код счета",
      INVENTORY_VALUE: "Инвентарная стоимость",
      INVOICE_N: "Счет №",
      CONTRACT_NUMBER: "Контактный номер",
      SUPPLIER_COMPANY_NAME: "Название компании-поставщика",
      RECIEVED_EMPLOYEE: "Принятый сотрудник",
      ACCORDING_TO_DOCUMENT: "Согласно документу",
      ACCEPTED: "Принятый",
      DEPARTURE_TIME: "Время отправления",
      NAME_OF_RECEIVED_COMPANY: "Название полученной компании",
      REPORT_ON_MATERIALS_IN_ASSORTMENT: "Материалы отчета между",
      PRODUCT_REVENUE_STATEMENT: "Отчет о поступлении материалов между",
      PRODUCT_EXPENSE_REPORT_IN_ASSORTMENT:
        "Расходы на доходы от материалов между",
      INITIAL_BALANCE: "Начальный баланс",
      COMING: "Доход",
      EXPENSE: "Расход",
      REMAINDER: "Окончательный остаток",
      add: "Количество:",
      TOTAL_COST: "Общая стоимость",
      TOTAL: "Всего:",
      PREPARED: "Готовый:",
      AGREED: "Согласованный:",
      FINANCIALLY_RESPONSIBLE_PERSON: "Финансово ответственное лицо",
      PRODUCTION_DIRECTOR: "Директор по производству",
      CHECKED: "Проверено:",
      WORK_SHOP_HEAD_OF_DEPARTMENT: "Глава департамента",
      FINANCIAL_DIRECTOR: "Финансовый директор",
      MATERIAL_TECHNICAL_CONTROL_DEPARTMENT:
        "Отдел материально-технического контроля",
      CHECK: "Счет",
      OFF_BALANCE_SHEET_REPORT: "Отчет за балансом",
      DEP_WORKSHOP: "Отд/цех",
      KIPIA: "КИПиА",
      CODE: "Код",
      PRODUCT_NAME: "Наименование товара",
      DATE_OF_ACCEPTANCE: "Дата принятия",
      DATE_OF_DELIVERY: "Дата доставки",
      UNIT: "Единица измерения",
      PRICE: "Цена",
      CHOOSE_THE_WAREHOUSE: "Выберите склад",
      PRODUCE_HISTORY_IS_NULL: "История продуктов пуста",
      THE_AMOUNT_OF_PRODUCT_DELIVERED_IS_MORE:
        "Количество доставленного продукта превышает количество, запрошенное инициатором",
      MUST_GIVE_AT_LEAST_ONE: "Вы должны дать хотя бы один",
      ERROR_SAVING_FILE: "Ошибка сохранения файла",
      ONLY_PDF_FILE_CAN_BE_COMPRESSED: "Можно сжать только файл pdf",
      OUT_OF_LIMIT: "Вне предела",
      THIS_USER_HAS_NOT_PHONE_NUMBER:
        "У этого пользователя нет номера телефона",
      YOU_HAVE_NO_ACCESS_TO_RECOVER_YOUR_PASSWORD:
        "У вас нет доступа для восстановления пароля",
      STILLAGE_IS_NULL: "Стеллаж равен нулю",
      NO_DEPARTMENT_IN_WAREHOUSE: "Склад не принадлежит ни одному отделу",
      CAN_NOT_RETURN_DEPARTMENT: "Возврат возможен только на склад",
      APPLICATION_NOT_FOUND: "Приложение не найдено",
      ACCOUNTANT_NOT_FOUND: "Выберите отдел бухгалтерии",
      ACCOUNTANT_TELEGRAM_GROUP_NOT_FOUND:
        "Прикрепить телеграмм группу в разделе бухгалтерия",
      WAREHOUSE_REQUIRED: "Выберите склад",
      AKT_FILE_REQUIRED: "Требуется файл AKT",
      "0_OR_A_SMALL_VALUE_CAN_NOT_BE_ACCEPTED": "Это не должно быть 0 или ниже",
      NO_PRODUCT_FOUND_BY_ID: "По идентификатору продукт не найдено",
      PRODUCT_ALREADY_TAKEN: "Продукт уже забрали",
      USER_HAS_NOT_PERMISSION_TO_GET_PRODUCT:
        "Пользователь не имеет права получить продукт по данному заказу",
      ORDER_ID_NOT_FOUND: "По идентификатору заказа не найдено",
      DATA_NOT_FOUND: "Информация не найдена",
      DEPARTMENT_OMTK_NOT_FOUND: "Отдел ОМТК не найден",
      CHOOSE_THE_REQUEST_TYPE: "Выберите тип вопроса",
      RECOVERING_PASSWORD_IS_FINISHED:
        "Восстановление пароля завершено, попробуйте сначала",
      REQUESTCOUNT_IS_REQUIRED: "Укажите количество запросов",
      CHOOSE_DEPARTMENT_TYPE: "Выберите тип отдела",
      PRODUCT_ID_NOT_FOUND: "Идентификатор продукта не найден",
      AMONG_THE_SELECTED_PRODUCTS_TAKEN_OUT:
        "Среди отобранных есть товары со склада. Повторный выбор продуктов",
      MORE_PRODUCTS_ARE_BEING_PROVIDED:
        "Доставляется больше товаров, чем указано в заказе",
      IMPOSSIBLE_TO_TAKE_ON_THE_TWO_PARTIES_AT_ONCE:
        "Невозможно забрать по двух партиям сразу. Нужно брать по одному",
      GOODS_HAVE_NOT_BEEN_GIVEN_FOR_THIS_ORDER_PARTIES:
        "По этому заказу и партию товар не отдан",
      ALREADY_TAKEN_AWAY_PRODUCTS_FOR_THIS_ORDER_PARTIES:
        "Данные продукты забираются для этого заказа",
      TAKE_MORE_PRODUCTS_THAN_GIVEN: "Вы даете больше продуктов, чем выдано",
      USER_NOT_ATTACHED_TO_DEPARTMENT:
        "Пользователь, написавший заявку, не привязан к разделу",
      USER_NOT_ATTACHED_TO_WAREHOUSE:
        "Пользователь, написавший заявку, не привязан к складу",
      CONTRACT_IS_NOT_FOUND: "Контакт не найден",
      CANNOT_ACCEPT_MORE_THAN_ONE_SHIPMENT:
        "Не может принять больше заданного количества",
      PRODUCT_TYPE_NOT_FOUND: "Тип продукта не найден",
      PRODUCT_GROUP_NOT_FOUND: "Группа товаров не найдена",
      SERVLET_RESPONSE_FOR_GENERATE_QR_CODE_IS_NULL:
        "Ответ сервлета для создания QR-кода равен нулю",
      MUST_ENTER_NAME: "Укажите имя",
      CUSTOMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Клиент с таким именем уже зарегистрирован",
      CUSTOMER_NOT_FOUND: "Клиент не найден",

      PARENT_ID_FOR_CONTRACT_ITEM_NOT_FOUND:
        "Родительский идентификатор для позиции контракта не найден",
      THE_CARRIAGE_DOES_NOT_BELONG_ANY_STELLAGE:
        "Эта повозка не принадлежит ни к какому стеллажу",
      STELLAGE_NOT_FOUND: "Стеллаж не найден",
      REQUEST_IS_NULL: "Запрос недействителен",
      COLUMN_SETTINGS_IS_NULL: "Параметры столбца пусты",
      ENTER_COLUMN_LABEL: "Введите метку столбца",

      HAS_CONTRACT_ALREADY: "Здесь есть договор",
      HAS_ORDER_ALREADY: "Здесь порядок",
      HAS_PRODUCT_ALREADY: "Здесь есть товар",
      PRODUCT_IN_STOCK_ROT: "Есть товар на складе. Вы не можете удалить",
      IDS_FIELD_REQUIRED: "Обязательное поле ID",
      CARRIAGE_IS_NULL: "Перевозка недействительна",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Пункт договора принят партия",
      CONTRACT_ITEM_PART_ACCEPT: "Пункт контракта частично принят",
      CONTRACT_ITEM_ACCEPT: "Пункт контракта принят",
      CONTRACT_ITEM_REJECT: "Пункт контракта отклонен",
      TELEGRAM_GROUP_REQUIRED: "Требуется группа Telegram",
      TELEGRAM_GROUP_NOT_FOUND: "Группа Telegram не найдена",
      CONCLUTION_DATE_REQUIRED: "Дата договора обязательна",
      GUESS_RECEIVE_DATE_REQUIRED: "Требуется расчетное время доставки",
      PRODUCTS_DO_NOT_COME_IN_ONE_BATCH_CANNOT_ADDED:
        "Товар не идет одной партией нельзя добавить",
      SECOND_PRODUCT_WAS_NOT_FOUND: "Второй товар не найден",
      THERE_IS_NO_WAREHOUSE_IN_THIS_DEPARTMENT: "В этом отделе нет склада",
      PRODUCTS_REQUESTED_ORDER_NOT_THE_STATUS_PROVIDED:
        "Запрошенные продукты не находятся в указанном статусе",
      EXCEEDED_THE_QUANTITY_PRODUCT_ORDERED_ALONG_WITH_THE_QUANTITY_PRODUCT_PREVIOUSLY_REQUESTED:
        "Наряду с ранее запрошенным количеством продукта оно превысило количество заказанного продукта",
      more_than_quantity_product_ordered:
        "Вы запрашиваете больше, чем количество товара для заказа",
      PRODUCT_WAREHOUSE_IS_NOT_ENOUGH: "Товара не хватает на складе",
      YOU_HAVE_NOT_ENTERED_PRODUCT_NUMBER: "Вы не ввели число продукта",
      ENTER_THE_QUERY_TYPE: "Введите тип запроса",
      MORE_REQUESTED_PRODUCT_QUANTITY_IS_INCLUDED_THE_ORDER:
        "В заказ включено больше запрошенного количества товара",
      CANNOT_DELETE_ITEM_BECAUSE_THE_ITEM_HAS_ALREADY_BEEN_USED:
        "Вы не можете удалить много, потому что продукты были использованы",
      PARTY_NOT_FOUND: "Партия не найдена",
      LOT_NOT_FOUND: "Лот не найден",
      WANT_IMPORT_MORE_THAN_VOLUME_OF_PRODUCT_RECEIVED:
        "Вы хотите принести больше, чем количество полученного продукта",
      INVENTORY_COMPLETE_YOU_HAVE_START_OVER_AGAIN:
        "Этот инвентарь завершен. Вы должны начать все сначала",
      INVENTORY_HAS_BEEN_STARTED_WAREHOUSE_YOU_CAN_CONTINUE:
        "На этом складе начата инвентаризация. Вы можете продолжить",
      REQUEST_NOT_FOUND: "Запрос не найден",
      order_and_products_given_under_batch_were_taken_away:
        "Заказ и товары, отданные под партию, были изъяты",
      UNIT_TYPE_NOT_MATCH: "Тип объекта не соответствует",
      SMS_NOT_SEND: "Сообщение не отправляется",
      CELLS_USED: "Выберите ячейку",
      CELL_NOT_FOUND: "Ячейка не найдена",
      HAS_STELAGE: "Здесь есть стеллаж",
      SELECT_THE_WAREHOUSE: "Выберите склад",
      UNIQUE_KEY_DID_NOT_MATCH: "Уникальный ключ не совпал",
      TEAM_NOT_FOUND: "Команда не найдена",
      TEAM_NOT_REQUIRED: "Требуется команда",
      TEAM_LEADER_NOT_FOUND: "Лидер группы не найден",
      TEAM_LEADER_REQUIRED: "Требуется руководитель группы",
      HISTORY_OF_MEDICINE_TAKEN_REQUIRED:
        "Необходим анамнез принимаемых лекарств",
      HISTORY_OF_MEDICINE_TAKEN_NOT_FOUND: "История приема лекарств не найдена",
      MEDICINE_NOT_FOUND: "Лекарство не найдено",
      MEDICINE_REQUIRED: "Требуется лекарство",
      PATIENT_NOT_FOUND: "Пациент не найден",
      PATIENT_REQUIRED: "Требуется пациент",
      PASSPORT_REQUIRED: "Требуется номер паспорта",
      RENT_NOT_FOUND: "Аренда не найдена",
      RENT_REQUIRED: "Требуется арендная плата",
      EXPIRED_DATE_REQUIRED: "Требуется срок действия",
      ELIGIBLE_TO_RECEIVE_GOOD_FOR_THIS_ORDER:
        "Нет разрешения на заказ этого продукта",
      AMOUNT_ENTERED_MORE_THEN_AMOUNT_LEFT_IN_WAREHOUSE:
        "Введенная сумма больше, чем сумма, оставшаяся на складе",
      PRODUCT_IS_NOT_ENOUGH_IN_WAREHOUSE: "Товара не хватает на складе",
      CHECK_DATABASE: "Проверить базу данных. Нет данных",
      USER_NOT_REGISTERED: "Пользователь не зарегистрирован",
      NUMBER_OF_ROWS_IS_NOT_ENOUGH: "Недостаточное количество рядов",
      OLD_PASSWORD_INCORRECT: "Старый пароль неверный",
      OLD_PASSWORD_REQUIRED: "Требуется старый пароль",
      RECOVER_YOUR_PASSWORD: "У вас нет разрешения на сброс пароля",
      CONFIRMATION_CODE_REQUIRED: "Требуется код подтверждения",
      USER_REQUIRED: "Требуется пользователь",
      PHONE_NUMBER_RIGHT_ENTER: "Введите свой номер телефона правильно",
      PHONE_NUMBER_REQUIRED: "Требуется номер телефона",
      USERNAME_REQUIRED: "Требуется имя пользователя",
      EMAIL_HAS_ALREADY: "Электронная почта пользователя зарегистрирована",
      PHONE_NUMBER_HAS_ALREADY: "Номер телефона зарегистрирован",
      USER_NAME_HAS_ALREADY: "Имя пользователя зарегистрировано",
      HAS_NOT_ACCESS: "У вас нет доступа",
      USER_NOT_FOUND: "Пользователь не найден",
      UNIT_TYPE_DOES_NOT_MATCH: "Единица продукта не соответствует",
      SMS_DO_NOT_SEND: "Сообщение не отправлено",
      PERMISSION_NOT_FOUND: "Разрешение не найдено",
      ROLE_NOT_FOUND: "Роль не найдена",
      ORDER_ITEM_COUNT_COUNTABLE: "Значение должно быть целым числом",
      PRODUCT_IS_NOT_ENOUGH: "Недостаточное количество товара",
      PARTITION_NOT_FOUND: "Партия не найден",
      ORDER_ITEM_AND_CONTRACT_ITEM_REQUIRED:
        "Элементы заказа и контракта не включены",
      PACKAGE_TYPE_NAME_CREATE_ALREADY: "Имя типа пакета уже создано",
      PACKAGE_TYPE_NOT_FOUND: "Тип пакета не найден",
      PACKAGE_NOT_FOUND: "Пакет не найден",
      COUNT_ENOUGHT: "Вы ввели большую сумму",
      COUNT_REQUIRED: "Количество продукта не включено",
      OUTGOING_CONTRACT_NUMBER_BUSY: "Этот номер контракта занят",
      PASSWORD_CHANGE_ACCESS: "У вас нет разрешения на смену пароля",
      CONFIRMATION_CODE_IS_INCORRECT: "Код подтверждения неверный",
      ORDER_ITEM_REJECT_MUCH_COUNT:
        "Многие из запрошенных продуктов были отменены",
      OPPORTUNITY_NOT_MATCH_COUNT:
        "Введенная сумма не соответствует сумме в договоре",
      OPPORTUNITY_COUNT_REQUIRED: "Ни одно из значений не введено",
      ORDER_ITEM_REQUIRED: "Заказные позиции не включены",
      UNITTYPE_REQUIRED: "Требуется тип устройства",
      PRODUCT_NOT_FOUND: "Товар не найден",
      PRODUCT_REQUIRED: "Требуется продукт",
      INVENTARIZATION_REQUIRED: "Требуется инвентаризация",
      INVENTARIZATION_NOT_FOUND: "Инвентаризация не найдена",
      GIVEN_PRODUCT_TAKEN_AWAY: "Товары по этому заказу забирают",
      GIVEN_PRODUCT_NOT_FOUND:
        "По данному заказу и партиям не было предоставлено товаров",
      PRODUCT_ALREADY_TAKEN_AWAY: "Товар уже забрали",
      MORE_PRODUCTS_DELIVERED_THAN_SPECIFIED_ORDER:
        "Доставляется больше товаров, чем указано в заказе",
      USER_AGREEMENT_REQUIRED: "Пользовательское соглашение не включено",
      WAREHOUSE_NOT_FOUND: "Склад не найден",
      WAREHOUSE_IS_REQUIRED: "Склад не выбран",
      DEPARTMENT_REQUIRED: "Раздел не выбран",
      DEPARTMENT_HAS_USERS_NOT_DELETE:
        "Этот раздел нельзя удалить, так как в этом разделе есть пользователи",
      ACTION_ALREADY_DONE: "Вы совершили это действие",
      REJECT_REASON_REQUIRED: "Укажите причину отмены",
      SUPPLIER_TYPE_REQUIRED: "Требуется тип поставщика",
      UNITTYPE_NOT_FOUND_IN_CONTRACT: "Тип объекта не указан в договоре",
      PRODUCT_NOT_FOUND_IN_CONTRACT: "Продукт не найден в контракте",
      CONTRACT_ITEM_COUNT_LARGE: "Больше суммы, указанной в договоре",
      DESCRIPTION_REQUIRED: "Требуется описание",
      COLUMN_SETTINGS_NOT_FOUND: "Настройки столбца не найдены",
      TABLE_NOT_SELECTED: "Таблица не выбрана",
      PRODUCT_DID_NOT_TO_MATCH: "Товар не соответствует",
      CARRIAGE_NOT_FOUND: "Каретка не найден",
      CARRIAGE_IS_REQUIRED: "Каретка не выбран",
      ORDER_COUNT_NOT_ENOUGH: "Количество заказов недостаточно",
      PRODUCT_ITEM_COUNT_NOT_ENOUGH: "Недостаточное количество товаров",
      PRODUCT_ITEM_REQUIRED: "Требуется товар",
      PRODUCT_ITEM_NOT_FOUND: "Товар не найден",
      CONTRACT_REQUIRED: "Требуется контракт",
      CONTRACT_NOT_FOUND: "Контракт не найден",
      PARTION_NOT_FOUND: "Партия товара не найдена",
      PRODUCT_TAKEN_FROM_WAREHOUSE: "Товар взят со склада",
      PRODUCTS_IS_REQUIRED: "Требуется Продукты",
      ATTRIBUTE_NOT_FOUND: "Атрибут не найден",
      FILE_NOT_FOUND: "Файл не найден",
      USERNAME_OR_PASSWORD_OR_BLOCK_ACCOUNT:
        "Неверное имя пользователя или пароль или пользователь не активен в этой системе",
      USERNAME_OR_PASSWORD_WRONG: "Неверное имя пользователя или пароль",
      PRODUCT_COUNT_NOT_DOT_MATCH: "Количество товаров не соответствует",
      OUTGOING_CONTRACT_COUNT_NOT_DOT_MATCH:
        "Вы ввели сумму больше указанной в договоре",
      TO_REVIEW_WAREHOUSE: "На рассмотрении ОМТК",
      PRODUCT_RECEIVED: "Товар принят",
      ENTER_POSITIVE_VALUE: "Введите положительное значение",
      ORDER_BUSY: "Заказ занят",
      formatFileNotSupported: "Формат файла не поддерживается",
      NAME_ALREADY_EXISTS: RuValidateMessages.messages.exist
        .replace("{_title_}", "именем")
        .replace("{_field_}", "аттрибут"),
      CONTRACT_DECISION_HAS_ALREADY_BEEN_MADE:
        "Решение о контракте уже принято",
      HASH_CODE_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Hash code"
      ),
      DOCUMENT_PARAMS_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Параметры документа"
      ),
      ACTION_TYPE_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Тип действия"
      ),
      CONTRACT_ITEM_REQUIRED: EnValidateMessages.messages.required.replace(
        "{_field_}",
        "Пункт контракта"
      ),
      BAD_CREDENTIALS: "Логин или пароль неправильно введен",
      SUPPLIERTYPE_REQUIRED: RuValidateMessages.messages.required.replace(
        "{_field_}",
        "Тип Поставщика"
      ),
      SUPPLIER_REQUIRED: RuValidateMessages.messages.required.replace(
        "{_field_}",
        "Поставщик"
      ),
      CONFIRMATION_CODE_IS_EXPIRED: "Неправильно введен подтверждения кода",
      GIVEN_OLD_PASSWORD_INCORRECT: "Старый пароль неправильно введен",
      USERNAME_NOT_FOUND: "Пользователь не найден",
      NAME_REQUIRED: RuValidateMessages.messages.required.replace(
        "{_field_}",
        "Имя"
      ),
      UNITTYPE_NOT_FOUND: "Ед.измерения не найдено",
      BLOCK_ACCOUNT: "Аккоунт блокирован",
      BAD_REQUEST: "Запрос не действительный",
      NOT_FOUND: "Не найдено",
      UNAUTHORIZED: "Нет авторизаций или токен устарел",
      FILE_REQUIRED: 'Поле файл обязательно для заполнения"',
      ERROR_WHILE_SAVING_FILE: "Произошло ошибка при сохранении файл",
      SUPPLIER_NOT_FOUND: "Поставщик не найдено",
      NOT_ENOUGH_INFORMATION: "Нет необходимых данных",
      CONTRACT_ITEM_NOT_FOUND: "Контракт не найдено",
      INITIATOR_NOT_FOUND: "Инициатор не найдено",
      MUST_ENTER_INITIATOR: 'Поле Инициатор обязательно для заполнения"',
      CONTRACT_ITEM_ID_IS_NULL: 'Контракт файл обязательно для заполнения"',
      CUSTUMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Поставщик с таким именем уже зарегистрирован",
      DEPARTMENT_NOT_FOUND: "Подразделение не найдено",
      ID_REQUIRED: 'Поле ID  обязательно для заполнения"',
      ORDER_ITEM_ID_REQUIRED: 'Поле ID запроса обязательно для заполнения"',
      ORDER_ITEM_NOT_FOUND: "Запрос не найдено",
      ORDER_ITEMS_REQUIRED: "Запросы не найдено",
      ORDER_NOT_FOUND: "Запрос не найдено",
      ERROR_SENDING_OTP_CODE: "Произошло ошибка при отправке OTP_CODE",
      REQUESTCOUNT_AND_GIVENCOUNT_IS_REQUIRED:
        'Поля количество запрошенных и предоставленных обязательны для заполнения"',
      CONTRACT_NUMBER_REQUIRED:
        'Поле номер контракта обязателен для заполнения"',
      OUTGOING_CONTRACT_NOT_FOUND: " Исходящий контракт не найдено",
      REALIZATOR_REQUIRED: 'Поле Реализатор обязательно для заполнения"',
      REALIZATOR_NOT_FOUND: "Реализатор не найдено",
      USER_AGREEMENT_NOT_FOUND: "Пользовательское соглашение не найдено",
      NEW_PASSWORD_REQUIRED: 'Поле новый пароль обязательно для заполнения"',
      ENTER_TIME_FORMAT_CORRECTLY: "Введите формат времени правильно",
    },
    accountingCode: "Код учёт",
    accepted: "Принято",
    uploadPhoto: "Загрузить фото",
    enterText: "Введите текст",
    find: "Найти",
    start: "Начать",
    warnings: "Предупреждения",
    downloadProductList: "Скачать список продукты",
    carriageAddress: "Адрес каретки",
    stillageAddress: "Адрес стеллажа",
    viewFile: "Посмотреть файл",
    productReport: "Отчет о товаре",
    productIsNotPlace: "Товар не на месте",
    numNotEnough: "Кол-во не хватает",
    quantityInExcess: "  Кол-во в избытке",
    productCount: "Количество продукта",
    givenProductQuantity: "Количество продукт необходимо выдать",
    addWithFile: "Добавить товар с файлом",
    productIssued: "Продукт выдан",
    givenProduct: "Выдан",
    hint: "Подсказка",
    rightClickingMouse:
      "Выберите нужную ячейку для размещения продукта, щелкнув правой кнопкой мыши",
    viewContractDetails: "Посмотреть детали контракта",
    admissionConfirmation: "Подтвердить прием",
    productAcceptance: "Прием товара",
    agreementStatus: {
      ORDER_ITEM_PRODUCE: "Принято",
      USER_AGREEMENT_ACCEPTED: "Принято",
      USER_AGREEMENT_REJECTED: "Отклоненный",
    },
    noApprovedContracts: "Нет контрактов",
    confirmWithKey: "Подписание документов ЭЦП",
    accountCode: "Код счета",
    placedBy: "Кем выдан (Ф. И. О.)",
    deliveredDate: "Дата прибытия на склад",
    takenAwayDate: "Срок хранения товара",
    aboutProduct: "О продукте",
    existingInv: "Этот товар уже инвентаризован",
    inventarizationStopped:
      "Процесс инвентаризации приостановлен на: {warehouse} складе",
    continueInventarization: "Продолжить",
    finishInventarization: "Закончить",
    receive: "Получить",
    toWriteOff: "Списать",
    allCarriagesEmpty: "Все кареткы пусты",
    halfEmpty: "Каретка не пустая",
    carriagesFull: "Каретка полная",
    warehouseIndicators: "Индикаторы с правой стороны стеллаж означают:",
    naming: "Наименование",
    designation: "Обозначение",
    row: "Ряд",
    hiddenWarehouses: "Скрытые склады",
    supportService: "Служба поддержки",
    divisionType: "Тип подразделения",
    toCancel: "Отменить",
    chooseAnotherStatus: "Выбрать другой статус",
    selectWarehouse: "Выберите склад",
    datePlaceholder: "дд/мм/гг",
    downloadTemplateFile: "Скачать шаблон",
    organizationName: "Название организации",
    weekShortTitle: {
      0: "Вс",
      1: "Пн",
      2: "Вт",
      3: "Ср",
      4: "Чт",
      5: "Пт",
      6: "Сб",
    },
    weekShort: {
      0: "В",
      1: "П",
      2: "В",
      3: "С",
      4: "Ч",
      5: "П",
      6: "С",
    },
    monthsNames: {
      0: "Январь",
      1: "Февраль",
      2: "Март",
      3: "Апрель",
      4: "Май",
      5: "Июнь",
      6: "Июль",
      7: "Август",
      8: "Сентябрь",
      9: "Октябрь",
      10: "Ноябрь",
      11: "Декабрь",
    },
    monthsNamesShort: {
      0: "Янв",
      1: "Фев",
      2: "Мар",
      3: "Апр",
      4: "Май",
      5: "Июн",
      6: "Июл",
      7: "Авг",
      8: "Сен",
      9: "Окт",
      10: "Ноя",
      11: "Дек",
    },
    numberOfProductCount: "Кол-во",
    numberOfDelinquencies: "Кол-во",
    showDuplicates: "Показать дубликаты",
    startInventarization: "Начать инвентаризацию",
    inventarization: "Инвентаризация",
    wantToDistribute: "Вы хотите выдать {count} товаров?",
    enterQuantity: "Введите кол-во",
    distribution: "К выдаче",
    orderQuantity: "Кол-вo заказов по запросу",
    totalOrders: "Общее кол-во заказов",
    productDelivery: "Выдача",
    place: "Место",
    spaceLeft: "Осталось ли еще свободное место?",
    confirmPlacement: "Разместить в указанном месте?",
    putProduct: "Подтвердить",
    placeInFreeSpace: "Разместить на свободное место",
    placedDate: "Дата размещения",
    invDate: "Дата инвентаризации",
    whoPosted: "Разместил (Ф.И.О)",
    quantity: "Кол-во",
    placedProducts: "Размещенные товары",
    placeHere: "Разместить здесь?",
    selectPlacement: "Выберите место размещения",
    tmtPlacement: "Разместить Продукт",
    determinePlacement: "Определить место размещения",
    existingQr: "Этот QR уже добавлен",
    addQrCode: "Добавить QR-код",
    showDetails: "Показать детали",
    enterQrCode: "Введите QR-код",
    scan: "Сканировать",
    pressToScan: "Нажмите кнопку, чтобы отсканировать QR-код",
    placement: "Размещение",
    leftToCapitalize: "Осталось оприходовать",
    palletsNumber: "Кол-во поддонов",
    invoiceNumber: "Номер сч/ф",
    invoiceDate: "Дата сч/ф",
    actNumber: "Номер акта",
    gtd: "ГТД",
    manufactureDate: "Дата производства",
    dataOfReceipt: "Дата прихода",
    numberOfPackages: "Кол-во упаковок",
    createIncome: "Создать приход",
    createLots: "Создать лоты",
    contractDivisionStatus: {
      /**
       * * Contract item status
       * */
      ACCEPTED: "Принято мной",
      REJECTED: "Отклонено мной полностью",
      PART_ACCEPTED: "Принять частично",
      WAITING: "Ожидается мое решение",
    },
    thinkDefective:
      "Вы действительно считаете, что {count} {unit_type} товара бракованные?",
    rejectedCount: "Кол-во отклоненных",
    enterAmount: "Укажите кол-во принимаемого Товары",
    defectiveGoodsNumber: "Укажите количество бракованных Товары",
    leaveComment: "Приложите комментарий",
    attachPhotosAndComment: "Добавьте фото и напишите комментарий",
    matched: "Соответствует",
    partialAdmission: "Принять частично",
    notCompatible: "Не соответствует",
    partyReception: "Принять партию",
    wantToChange: "Вы действительно хотите изменить?",
    wantToAdd: "Вы действительно хотите добавить?",
    contractOmtkStatus: {
      /**
       * * Contract item status
       * */
      CONTRACT_ITEM_ACCEPTED: "Принято мной",
      CONTRACT_ITEM_REJECT: "Отклонено мной полностью",
      CONTRACT_ITEM_PART_ACCEPTED: "Принято частично",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "По партиям принято частично",
      NEW: "Новый",
    },
    addAnotherRecipient: "Добавить другого принимающего",
    sendPushNotification: "Отправить push-уведомление",
    changeEmployee: "Сменить инициатора",
    chooseInitiator: "Выбрать инициатора",
    selectSection: "Выберите отдел",
    changeInitiator:
      "Вы уверены что хотите заменить этого инициатора на другого?",
    selectAll: "Выбрать всех",
    acceptedInitiatorCount: "Количество инициаторов, получивших",
    partiallyAccepted: "Обработано частично",
    confirmWithEimzo: "Подтвердить подписью ЭЦП",
    selectKey: "Выберите ключ",
    eimzo: {
      valid: "Действителен",
      certificateNumber: "№ сертификата",
      certificate: "Сертификат",
      stir: "ИНН",
      fullName: "Ф.И.О.",
      organization: "Организация",
      expiryDate: "Срок действия сертификата",
      pnfl: "ЖШШИР",
    },
    duplicateProducts: "Дубликаты товаров",
    basicToolReportsTitle: "Отчет по основным средствам",
    basicToolReports: "Сформировать отчет по основным средствам",
    oldQr: "Действующий QR-код",
    newQr: "Новый QR",
    moveCount: "Перемещаемое количество",
    Id: "ID",
    moveQr: "Перевести в новый QR-код",
    moveQrToExist: "Перевести на действующий QR-код",
    moveProduct: "Перемещение товара",
    moveProductConfirmDesc: "Переместить товар?",
    moveToWarehouse: "Вернут в склад",
    existQr: "Действующий QR-код",
    splitQr: "Разделить QR",
    materialsThatEnd: "Товары которые заканчиваются",
    analytics: "Аналитика",
    frequentlyGoodsMaterials: "Часто используемые Товары",
    yearShort: "{0} г.",
    delaysReport: "Отчет по Товар, полученных не в срок",
    invalidProductReport: "Отчет по бракованным Товар",
    latencyRequests: "Задержка запросов",
    expirationGoodsMaterials: "Отчет по Товар с истекшим сроком хранения",
    developedBy: "Разработано в {0}",
    expired: "Срок годности истекает",
    contractInitiator: "Ф.И.О. инициатора контракта",
    pageCount: "Номер страницы",
    uploadFile: "Загрузить файл",
    authorization: "Авторизация",
    weight: "Весь/кол-во",
    reload: "Обновить",
    reindexAll: "Переиндексировать все",
    reindex: "Переиндексации",
    dateAcceptance: "Дата оприходования",
    wantToContinue: "Хочешь продолжать?",
    loading: "Загружается...",
    updatedByUser: "Пользователь-редактор",
    changed: "Изменено",
    price: "Цена",
    gaveUser: "Выдал (Ф.И.О.)",
    allProduct: "Все Товар",
    qrCode: "QR-код",
    msdsFile: "MSDS файл",
    print: "Распечатка",
    printQrCode: "Распечать QR | Распечать QR",
    ourProducts: "Наши Товар",
    writeOff: "Списание",
    writeOffProduct: "Списание",
    file: "Файл",
    reference: "Справочники",
    writeOffed: "Списано",
    ozl: "ОЗЛ",
    login: "Логин пользователя",
    password: "Пароль",
    ourOrders: "Наши запросы",
    create: "Создать",
    createNewRequest: "Создать новый запрос",
    or: "или",
    orderNotAddYet:
      "Заявки еще не добавлен. Нажмите плюс чтобы добавить заявку.",
    addOrderItemToRequest: "Добавить Товар в запрос",
    sortable: "Сортируемый",
    minWidth: "Мин. ширина",
    orderRequestItemNumber: "№ позиции в запросе",
    limitProductCount: "Минимальное количество запасов",
    categoryProduct: "Категория товара",
    productCategory: "Категория товара",
    timeToBeEntered: "Дата пос. запроса",
    pendingPurchaseDate: "Дата принятия спецификации",
    updatedDate: "Дата изменения",
    itemConclusionDate: "Дата последних операций",
    count: "Количество",
    countShort: "Кол-во",
    countQr: "Кол-во qr",
    unit: "Единица измерения",
    from: "с",
    downloadFile: "Скачать файл",
    downLoadFileContract: "Скачать файл контракта",
    historyContractCode: "История {code} контракта",
    fileRequest: "Файл запроса №{numb}",
    error: "Ошибка",
    inventoryTime: "Время инвентаризации",
    writeOffTime: "Дата и время списания",
    writeOffByUser: "Кем списано (Ф.И.О.)",
    numberOfValidProducts: "Number of valid products",
    numberOfInvalidProducts: "Number of invalid products",
    inventory: "Инвентаризация",
    envNumber: "ENV номер",
    errorHasOccurred: "Произошла ошибка",
    prev: "Назад",
    productName: "Название товара",
    whoImplemented: "Ф.И.О. исполнителя",
    sendDepartmentName: "Отправитель Товар",
    send: "Отправить",
    typeProduct: "Тип Товар",
    receiverDate: "Фактическая дата поставки",
    date: "Выберите дату",
    extraOptions: "Дополнительные параметры",
    extra: "Дополнительно",
    more: "Подробнее",
    sendDate: "Дата и время отправки запроса",
    placeProductIn: "Разместить Товар в {warehouse}",
    type: "Тип",
    typeWarehouse: "Тип склада",
    status: "Статус",
    noDataAvailable: "Нет данных",
    prevStatus: "Предыдущий статус",
    currentStatus: "Текущий статус",
    nameOfSupplier: "Наименование поставщика",
    nameOfCustomer: "Наименование клиента",
    warehouse: "Склад",
    createWarehouse: "Создать склад",
    product: "Товар",
    columns: "Столбцы",
    filter: "Фильтр",
    attachFile: "Прикрепить файл",
    deliveryDate: "Дата срока поставки",
    orderSent: "Запрос отправлен",
    sendAgain: "Отправить еще раз",
    productGroup: "Группа Товар",
    reportInventory: "Отчет об инвентаризациях",
    writeOffFromThem: "Списано",
    edit: "Редактировать",
    delete: "Удалить",
    cancel: "Отмена",
    save: "Сохранить",
    add: "Добавить",
    searchForName: "Поиск по названию",
    orderItemByDepartment: "Запросы от подразделений",
    searchForNumber: "Поиск по номеру",
    productCreate: "Создать Товар",
    productEdit: "Изменить Товар",
    editCategory: "Изменить категорию",
    byCategory: "Количество запросов по категориям",
    byOrderItemStatus: "Запросы по статусам",
    byTime: "Количество запросов за период",
    category: "Категория",
    nameOfGroup: "Название группы",
    name: "Название",
    group: "Группа",
    description: "Описание",
    notIncomeSmsHint: "Не пришло SmS. Попробуйте еще раз!",
    stillageStatus: {
      full: "Нет мест",
      empty: "Свободный",
      hasSpace: "Есть место",
    },
    warehouseFieldType: {
      corridor: "Коридор",
      field: "Место",
      stillage: "Стеллаж",
      carriage: "Каретка",
    },
    action: "Действие",
    typeProducts: "Типы продуктов",
    realization: "Реализация",
    inventoried: "Проинвентаризировано",
    day: "День",
    month: "Месяц",
    year: "Год",
    allTime: "Период",
    groupProducts: "Группы продуктов",
    whoProduced: "Кто производил",
    finishOrder: "Закрыть запрос",
    contractCompleteDate: "Дата закрытия контракта",
    nContract: "№ контракта",
    groups: "Группы",
    requests: "Запросы",
    ourRequest: "Наши запросы",
    clear: "Очистить",
    itIsEmpty: "Пустой",
    addProduct: "Добавить Товар",
    hasProductInWereHouse: "Тмц есть в наличие",
    implementator: "Реализатор",
    clearFilter: "Очистить фильтр",
    expiration: "Срок годности (день)",
    notEnoughProduct: "Не хватает количество",
    implementDate: "Дата реализации",
    noProduct: "Нет в наличие",
    noPlacementProduct: "Товар отсутствует",
    enterValue: "Введите значение",
    addAttribute: "Создать атрибут",
    material: "Материал",
    nameAttribute: "Название атрибута",
    reportWriteOff: "Отчет о списании",
    value: "Значение",
    attributes: "Атрибуты",
    used: "Бывший в эксплуатации",
    attributeProduct: "Атрибуты Товар",
    done: "Готово",
    requestNumber: "Номер запроса",
    requestNumberN: "Номер запроса {number}",
    numberPositionInContract: "№ позиции в контракте",
    newVersionFoundHint: "Найдена новая версия. Обновить, чтобы загрузить?",
    occupancyPercent: "Процент занятости",
    occupiedPlacePercent: "Занятое место {percent}%",
    subdivision: "Подразделение",
    initiator: "Ф.И.О. инициатора:",
    categoryTMC: "Категория Товар",
    documents: "Документы",
    typeTMC: "Тип Товар",
    contractNumber: "Номер контракта",
    contractDocuments: "Документ контракта",
    number: "№ п/п",
    requestStatus: "Статус запроса",
    requestPositionStatus: "Статус позиции в запросе",
    viewHistory: "Показать историю",
    packageCount: "Количество QR-кода",
    userName: "Имя пользователя",
    assumptionSendDate: "Предполож. дата отправки",
    importFromExcel: "Импортировать из Excel",
    exampleExcel: "Скачать пример файл для импортировать Товар",
    guessReceiveDate: "Предполож. дата поставки",
    phone: "Номер телефона",
    firstName: "Ф.И.О. пользователя",
    changePassword: "Изменить пароль",
    viewContractHistory: "Показать история контракта",
    doYouWantGoBack: "Вы действительно хотите вернуть этот статус?",
    lastName: "Отчество",
    email: "Email",
    middleName: "Фамилия",
    forgetPassword: "Забыли пароль?",
    passwordChanged: "Пароль изменено",
    logOut: "Выйти",
    enterToSystem: "Войти в систему",
    notification: "Уведомление",
    next: "Следующий",
    confirmPassword: "Подтверждение пароля",
    limit: "Лимит",
    filled: "Сўм",
    income: "Приход",
    incomeReport: "Отчет о приходах",
    movedToWarehouseAndInProgress:
      "Товар перемещен в другой склад. Ожидается подтверждение",
    reportIncome: "reportIncome",
    reportExpense: "Создать отчет о расходах",
    show: "Показать",
    department: "Подразделение",
    department2: "Отдел",
    departmentIdAlert:
      "Для использования системы у вас должен быть отдел. Пожалуйста, свяжитесь с администратором!",
    successfullySaved: "Успешно сохранено",
    addedNewOrder: "Добавлен новый запрос",
    addedNewContract: "Добавлен новый контракт",
    enable: "Включено",
    updatedSuccessfully: "Успешно изменено!",
    successfullyAccepted: "Успешно принято",
    successfullyRejected: "Успешно отклонено",
    newPassword: "Новый пароль",
    oldPassword: "Старый пароль",
    oldWarehouse: "Старый склад",
    successfullyDeleted: "Успешно удалено",
    title: "Заголовок",
    orderHistoryNumb: "История {numb} запроса",
    successfullySent: "Успешно отправлено",
    deleteDepartmentHint:
      "При удалении отдела его пользователи также удаляться. Продолжить?",
    receptionDate: "Введите дату приема Товар",
    typeDelivery: "Тип поставки",
    contractDate: " Дата заключения контракта",
    estimatedDeliveryDate: "Предположительная дата поставки",
    sendNotificationToOMTK: "Отправить уведомление в ОМТК",
    sendNotification: "Отправить уведомление",
    sendNotificationToAccounting: "Отправить уведомление в Бухгалтерию",
    toOMTK: "В ОМТК",
    toAccounting: "В Бухгалтерию",
    accountant: "Бухгалтерия",
    contractHistory: "История контракта | История позиций контракта",
    orderHistory: "История запроса | История позиции запроса",
    productHistory: "История Товар",
    provider: "Поставщик",
    users: "Пользователи",
    dateWriteOff: "Время списания",
    doYouWantReject: "Вы хотите отклонить {count}",
    outGoingContracts: "Исходящие контракты",
    listOfVisits: "Список посещений ",
    whoChangeStatus: "Кто перевел запрос в этот статус",
    statusChangedUser: "Запрос переведен в другой статус (Ф.И.О. пользователя)",
    positionStatus: "Статус позиции",
    allAttributes: "Все атрибуты",
    attributeSearch: "Поиск атрибута",
    valueSearch: "Поиск значения",
    roles: "Роли",
    additionalRole: "Дополнительная роль",
    permissions: "Разрешения",
    internal: "Внутренний",
    import: "Импортный",
    categories: "Категории",
    added: "Добавлено",
    productNumber: "Номер продукта",
    lotName: "Називания лота",
    searchByName: "Поиск по названию",
    requestSubmissionDate: "Дата отправки запроса",
    createContract: "Создать контракт",
    filterBySupplier: "Поиск по поставщику",
    filterByInitiator: "Поиск по инициатору",
    profile: "Профиль",
    all: "Все",
    addToContract: "Добавить в контракт",
    settings: "Настройки",
    tableName: "Название таблицы",
    columnLabel: "Название колонки",
    columnValue: "Название значения",
    reject: "Отклонить",
    nameOfProduct: "Название Товар",
    measure: "Единицa измерения",
    measureShort: "Ед. измерения",
    terminate: "Расторгнуть",
    contractTerminated: "Расторжение контракта",
    signed: "Подписан",
    addMoreProductToRequest:
      "Этот продукт уже добавлен в этот запрос добавьте еще ",
    products: "Товары",
    omtk: "OMTK",
    tender: "отправить в ОЗЛ",
    groupOfProduct: "Группа Товар",
    dateWhenYouNeedToPutEverything: "Дата поставки",
    hide: "Скрыть",
    remainingContract: "Остаток по контракту",
    remains: "Осталось",
    implemented: "Реализовано",
    willBeAddedToNewRequest: "{0} будет добавлено в новый запрос",
    dateOfConclusionContract: "Дата заключения контракта",
    new: "New",
    enterDate: "Введите дату",
    customer: "Заказчик",
    rejectRequest: "Отклонение запроса",
    addPosition: "Добавить позицию",
    expenses: "Расход",
    //status

    NOT_ACCEPTED_ORDER: "Не удовлетворен",
    RECEIVED: "Получен",
    DELETED: "Удалено",
    [orderItemStatus["ISSUED_ORDER_ITEM"]]: "Товар поступил",
    [orderItemStatus["COMPLETED"]]: "Завершен",
    [orderItemStatus["OZL_TO_DEPARTMENT"]]: "Ожидает изменений",
    [orderItemStatus["DELIVERY_EXPECTED"]]: "Контракт заключен",
    [orderItemStatus["READY_TO_PRODUCE"]]: "Товар выдан",
    [orderItemStatus.YES_PRODUCT]: "Готов к выдаче",
    ACCEPTED_ORDER: "Удовлетворен",
    TO_REVIEW_WAREHOUSE: "На рассмотрении ОМТК",
    NO_PRODUCT: "TMЦ нет на складе",
    [orderItemStatus.YES_PRODUCT]: "TMЦ на складе",
    REJECT_ORDER_ITEM: "Заявка отклонена ОМТК",
    PAPER_EXPECTED_SPECIFICATION: "Ожидается бумажная спецификация",
    PENDING_PURCHASE: "Ожидается закупка",
    PRODUCT_DELIVERED: "Товар доставлен",
    APPLICATION_REJECTED_OZL: "Заявка отклонена ОЗЛ",
    CONTRACT_CONCLUTION: "Контракт заключен",
    CONTRACT_TERMINATED: "Контракт Расторгнуть",
    NEW: "Новый",
    to: "по",
    parentNameCategories: "Название родительской категории",
    resentHint: "Вы можете снова отправить через",
    columnName: "Название колонки в таблице",
    parent: "Родитель",
    reasonRejectContract: "Причина отказа или расторжения",
    acceptedCount: "Кол-во принятого товара",
    uploadFileRequest: "Загрузить файл заявки",
    contractRejectionHint: "Напишите причину расторжения контракта",
    conclusionAndReceived:
      "Заключенные контракты и Полученные товары по контракту",
    newCategoryName: "Название новой категории",
    addCategory: "Добавить категорию",
    addInventory: "Добавить TMЦ",
    nameCategory: "Название категории",
    nameOfGoodsAndMaterials: "Название Товар",
    acceptedContracts: "Полученные товары по контракту",
    conclusionContracts: "Заключенные контракты",
    reasonForRefusal: "Причина отказа или расторжения",
    changeCategory: "Изменить категорию",
    changeInventory: "Изменить Товар",
    addGroup: "Добавить группу",
    homeFurniture: "Мебель для дома",
    hasCount: "В наличии",
    livingRoomFurniture: "Мебель для гостиной",
    initiatorOzl: "Инициатор OZL",
    areAvailable: "Есть в наличии",
    notEnoughQuantity: "Не хватает кол-ва",
    hasPlace: "Есть место",
    noPlace: "Нет места",
    yes: "Да",
    notAvailable: "Нет в наличии",
    sendToOzl: "Товар нет отправить в ОЗЛ",
    specAccepted: "Спецификация принята",
    productAvailableNotEnoughQuantity: "Товар есть кол-во не хватает",
    givePartiallyProduct: "Товар есть, выдать частично",
    state: "Статус",
    editGroup: "Редактирование",
    editZone: "Редактировать зону",
    createZone: "Создать зону",
    suppliers: "Поставщики",
    supplier: "Поставщик",
    giveOut: "Выдать",
    available: "Есть",
    refuse: "Отказываться",
    asked: "Спросил",
    requestApproved: "Запрос одобрен",
    team: "Группа",
    addRealizationProduct: "Добавить реализованный Товар",
    hidden: "Скрытый",
    mainWarehouse: "Главный склад",
    inWarehouse: "На складе",
    mainDepartment: "Главное подразделение",
    productsInDraft: "Продукты в черновике",
    browseFile: "Кликните или перетащите файл сюда",
    wantAddProduct: "Добавить Товар?",
    warehouses: "Склады",
    orders: "Запросы",
    teamLeader: "Лидер группы",
    productCode: "Код учета",
    countOfRequested: "Количество запрошенных",
    requestRejection: "Отклонения запроса",
    requestRejectionHint: "Напишите причину отклонения запроса",
    movingProducts: "Перемещение товаров",
    requestFinishHint: "Укажите причину закрытия запроса",
    reasonRejectRequest: "Причина отклонения запроса",
    months: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ],
    createSupplier: "Создать поставщика",
    createOrder: "Создать заявку",
    createType: "Создать тип",
    typeSupply: "Тип доставки",
    update: "Загрузить",
    updateNewVersion: "Загрузить",
    updateType: "Изменить тип",
    updateSupplier: "Изменить Поставщика",
    updateCustomer: "Изменить клиента",
    position: "Позиция",
    visible: "Видимый",
    numberRequest: "№ запроса",
    approve: "Одобрить",
    approveRequest: "Одобрить запрос",
    no: "Нет",
    yesDelete: "Да, удалить",
    warning: "Предупреждение!",
    wantDeleteHint: "Вы хотите удалить ?",
    comment: "Комментарии",
    color: "Изменить цвет",
    size: "Размер шрифта",
    youHaveNotAccess: "У Вас нет доступа",
    acts: "Акты",
    editContract: "Изменить контракт",
    attachAct: "Прикрепить акт",
    code: "Код",
    address: "Адрес",
    contracts: "Контракты",
    open: "Открыть",
    nameGroup: "Название группы",
    addToBasket: "Добавить в корзинку",
    moveProductStatus: {
      NEW: "Новый",
      APPROVED: "Принято",
      REJECTED: "Отклонено",
    },
    receptionStatus: {
      NEW: "Не выдан",
      REQUEST_DONE: "Выдан",
    },
    history: "История события",
    successMessages: {
      reIndexed: "Заиндексирован",
    },

    notificationTemplate: {
      departmentToOmtk: "{userName} хочет забрать {count} {productName}",
      ozlToOmtkProfitProduct:
        "По контракту №{contractNumber} {productName} поступило Товар",
      ozlToAccountProfitProduct:
        "По контракту {contractNumber} Ожидается поставка товара по этой позиции. Прошу подготовить доверенность.",
    },
    orderItemStatusDescription: {
      [orderItemStatus.YES_PRODUCT]: "Товар на складе {name}",
      [orderItemStatus["PAPER_EXPECTED_SPECIFICATION"]]:
        "Обратитесь в соответствующее подразделение для создания заявки на закупку",
    },
    outGoingContractStatus: {
      CONCLUDED: "Заключен",
      COMPLETED: "Завершен",
    },
    contractStatus: {
      /**
       * * Contract status
       * */
      USER_AGREEMENT_ACCEPTED: "Принято",
      USER_AGREEMENT_DELETED: "Удалено",
      USER_AGREEMENT_REJECTED: "Отклоненный",
      USER_AGREEMENT_PART_ACCEPTED: "Принят частично",

      CONTRACT_CONCLUTION: "Контракт заключен",
      CONTRACT_ACCEPTED: "Контракт одобрен", //"Контракт принят",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Получена партия товара",
      PART_ACCEPTED: "Принят частично",
      CONTRACT_REJECT: "Расторгнуть",
      /**
       * * Contract item status
       * */
      NEW: "Новый",
      CONTRACT_ITEM_ACCEPTED: "Товар принят",
      DELETED: "Удалено",
      CONTRACT_ITEM_REJECT: "Расторг",
      CONTRACT_ITEM_PART_ACCEPTED: "Принят частично",
      CONTRACT_NEW: "New",
    },
    orderItemStateOmtk: {
      available: "Есть в наличии",
      noAvailable: "Нет в наличии",
      notEnough: "Не хватает кол-ва",
    },
    productPackageType: {
      PACKAGEABLE: "Партия (это в коробке)",
      COUNTABLE: "Штучно",
    },
    productItemStatus: {
      NEW: "Новый",
      PRODUCT_PRODUCED: "Товар используются",
      PRODUCT_USED: "Использован",
      DELETED: "Удалено",
    },
    validation: RuValidateMessages.messages,
    $vuetify: {
      fileInput: {
        counter: "{0} files",
      },
      dataIterator: {
        loadingText: "Загружается",
      },
      datePicker: {
        nextMonthAriaLabel: "next month",
        prevMonthAriaLabel: "prev month",
        prevYearAriaLabel: "prev year",
        nextYearAriaLabel: "next year",
      },
      noDataText: "Нет данных",
      pagination: {
        ariaLabel: {
          next: "Next",
          wrapper: "Wrapper",
          previous: "Previous",
          currentPage: "Current page",
          page: "Page",
        },
      },
      dataTable: {
        sortBy: "Сортировка",
        ariaLabel: {
          sortNone: "Sort no",
          activateAscending: "Active ascending",
          activateDescending: "activateDescending",
          sortAscending: "sortAscending",
          sortDescending: "sortDescending",
          activateNone: "activateNone",
        },
      },
    },
    errors: {
      productNotSaved: "Товар не сохранено",
      "Request aborted": "Request aborted",
      noRequestAdded: "Ни одного запроса не добавлено ",
      "Request failed with status code 400": "Request failed 400",
      "Request failed with status code 500": "Request failed 500",
      "Request failed with status code 502": "Request failed 500",
      "Request failed with status code 401": "Request failed 401",
      "Request failed with status code 404":
        "Request failed with status code 404",
      "Network Error": "Нет подключение или что-то не так со сервером",
      "E-Imzo not installed": "Э-имзо не установлено",
    },
    packageType: "Тип упаковки",
    packagesTypes: {
      COUNTABLE: "Штучно",
      PACKAGEABLE: "Упаковка",
      PARTITIONABLE: "Частями",
    },
    printQr: "Распечать QR",
    printedQr: "Распечатано",
    notPrintedQr: "Не распечатано",
    acceptUser: "Принял (Ф.И.О.)",
    reports: "Отчеты",
    materialReport: "Материальный отчет",
    dashboardTableType: {
      graph: "График",
      table: "Таблица",
    },
    getMaterialReport: "Сформировать материальный отчет",
    support: "Служба поддержки",
    dateFrom: "Дата c:",
    dateTo: "Дата по:",
  },
  uz: {
    search: "Qidirish",
    fromUp: "dan",
    fromTo: "gacha",
    data: "Sana",
    telegramBotLink: "Telegram bot havolasi:",
    yourPhoneAccept:
      "Telegramda bildirishnomalarni olish uchun telefon raqamingiz:",
    backToHome: "Kabinetga qaytish",
    youdonothaveaccess: "Sizda bu sahifaga ruxsat yo'q :(",
    officeProducts: "Ofis mahsulotlari",
    storeTheOffice: "Ofis ombori",
    employees: "Xodimlar",
    FINISHED: "Bajarildi",
    STARTED: "Jarayonda",
    process: "Jarayon",
    designatedPerson: "Mas'ul shaxs",
    carriageFrom: "Kareykadan",
    stillageFrom: "Stillagdan",
    stillageTo: "Stillajga",
    carriageTo: "Kareykaga",
    endDate: "Tugash sanasi",
    startDate: "Boshlanish sanasi",
    attachDepartmentToUser: "Bo'limga biriktirish",
    numberOfProducts: "Mahsulotlar soni",
    invCode: "Inv. kod",
    exportExel: "Excelga ko'chirish",
    attachProduct: "Mahsulotni biriktiring",
    attachedToEmployee: "Xodimga biriktirilgan",
    departmentName: "Bo'lim nomi",
    totalNumberOfProducts: "Umumiy tovarlar soni",
    addDepartment: "Bo'lim qo'shing",
    codeForInventory: "Inventarizatsiya uchun kod",
    generation: "Generatsiya",
    generateQrCodeAndInventoryCode: "QR kod va inventar kodini yarating",
    numberOfProductCount: "Miqdor",
    forrealization: "Sotuv uchun",
    foruse: "Foydalanish uchun",
    productCondition: "Mahsulot holati",
    productPhotos: "Mahsulot fotosuratlari",
    quantityProducts: "Mahsulotlar miqdori",
    dataModified: "O'zgartirilgan sana",
    resPerson: "Mas'ul shaxs (ombor boshlig'i)",
    resPerson1: "Mas'ul shaxs",
    myOffice: "Mening ofisim",
    videoInstruction: "Video ko'rsatma",
    movingproducts: "Tovarlarni ko'chirish",
    productManagementTitle: "Mahsulotlarni boshqarish",
    fio: "F.I.O",
    modules: "Modullar",
    navModalTitle: "Ombor joylashuvi",
    navModalDescription: "Siz joylashuvni ulashingiz mumkin",
    navModalBtn: "Xaritaga o'ting",
    close: "Yopish",
    changeTariff: "Tarifni o'zgartirish",
    changeYourTariff: "Davom etish uchun tarifingizni oʻzgartiring",
    hitYouLimit: "Limitga yetdingiz",
    apply: "Saqlash",
    selectZoneForWarehousePlaceholder: "Zonani nomini kiriting",
    selectZoneWhichYouWant: "Biriktirmoqchi bo'lgan zonani tanlang",
    warehouseNotHere: "Biriktirilgan omborlar topilmadi",
    fullParcent: "To'la",
    goBlackWarehouse: "Qora omborxonaga o'tish",
    attachToZone: "Zonaga biriktirish",
    showOnTheMap: "Xaritadan ko'rsatish",
    editBlackWarehouse: "Qora omborxonani o'zgartirish",
    numberOfStillage: "Stellajlar soni",
    zone: "Zona",
    fromWhichWarehouse: "Qaysi ombordan?",
    whichWarehouse: "Qaysi ombor?",
    selectProduct: "Mahsulotni tanlang",
    totalQuantity: "Umumiy miqdori",
    positionStillage: "Shelfda joylashuvi",
    writeQuantity: "Miqdorni yozing",
    move: "Ko'chirish",
    numberOfPlaces: "Joylar soni:",
    busyCount: "Band:",
    emptyCount: "Bo'sh:",
    hiddenWarehouse: "Yashirin ombor",
    hiddenWarehouseDescription:
      "Alohida tipdagi tovarlarni saqlash va boshqarish uchun ma'lum shaxslarga ko'rish va boshqarish imkoniyatini berish.",
    regularWarehouseDescription: "bu standart stillajlar joylashadigan xona",
    regularWarehouse: "Oddiy ombor",
    areaWarehouseDescription:
      "Ushbu turni tanlab, siz bir nechta kichik yoki katta omborlar joylashishi mumkin bo'lgan joy yaratasiz.",
    areaWarehouse: "Hududli Ombor",
    typeWarehouses: "Ombor turlari",
    typeWarehouse: "Ombor turi",
    selectWarehouseType: "Ombor turini tanlang",
    createWarehouseSubTitle: "Keling, noldan boshlaylik",
    addPermission: "Ruxsat biriktirish",
    editWarehouse: "Omborxonani o'zgartirish",
    tin: "Tin",
    productPhoto: "Фото товара",
    productCharacteristics: "Mahsulot xususiyatlari",
    certificateNumber: "№ сертификата",
    sign: "Kirish",
    whatEDSKey: "EDS nima?",
    loginWithEDS: "EDS bilan tizimga kiring",
    loginTab: "Kirish",
    incomingGoods: "Kirib kelgan mahsulotlar",
    outgoingGoods: "Chiqib ketgan mahsulotlar",
    remainingCurrently: "Hozirgi qoldiq",
    shippedProducts: "Yuborilgan maxsulotlar",
    consignmentNote: "Yuk xati",
    unreceivedProducts: "Qabul qilinmagan mahsulotlar",
    sourceWarehouse: "Ombor",
    hintSendOrderAfterCreate:
      "Buyurtma muvofaqqiyatli yaratildi. Bu tugma orqali buyurtmani OMTK bo'limiga jo'nating",
    serverErrorMessages: {
      UNSIGNED_ENTITY_NOT_FOUND: "Mahsulot topilmadi",
      CHANGE_WAREHOUSE: "Bu mahsulot bu omborda mavjud emas",
      PRODUCT_NAME_AND_ATTRIBUTE_WITH_DUPLICATE: "Bunday nomli mahsulot mavjud",
      PRODUCT_NAME_MAX_LENGTH: "Mahsulot nomi 600 ta belgidan oshmasligi kerak",
      HAS_CARRIAGE: "Bu yerda karetka bor",
      CONTRACT_ITEM_CHANGE_STATUS: "Bu holatdan boshqa holatga o'tib bo'lmaydi",
      PRODUCT_NOT_GIVEN_DEPARTMENT: "Ekspluatatsiyaga chiqarilmagan",
      CONTRACT_NUMBER_BUSY: "Shartnoma band",
      USER_NOT_FOUND_WITH_USERNAME:
        "Ushbu foydalanuvchi nomi bilan foydalanuvchi topilmadi",
      ORDER_INITIATOR_NOT_FOUND: "Buyurtma bandida initsiator topilmadi",
      ACCOUNTANT: "Moddiy hisobchi",
      CHEIF_ACCOUNTANT: "Bosh hisobchi",
      TIME_OF_DELIVERY: "Yetkazilgan vaqti",
      ACCOUNT_CODE: "Hisob kodi",
      INVENTORY_VALUE: "Tovar moddiy boyliklari nomi",
      INVOICE_N: "Hisob-faktura №",
      CONTRACT_NUMBER: "Shartnoma raqami",
      SUPPLIER_COMPANY_NAME: "Yetkazib beruvchi korxona nomi",
      RECIEVED_EMPLOYEE: "Qabul qilgan xodim",
      ACCORDING_TO_DOCUMENT: "Hujjat bo'yicha",
      ACCEPTED: "Qabul qilindi",
      DEPARTURE_TIME: "Olib ketilgan vaqti",
      NAME_OF_RECEIVED_COMPANY: "Qabul qilgan korxona nomi",
      REPORT_ON_MATERIALS_IN_ASSORTMENT: "oralig'idagi materialllar hisoboti",
      PRODUCT_REVENUE_STATEMENT: "oralig'idagi mahsulot kirim hisoboti",
      PRODUCT_EXPENSE_REPORT_IN_ASSORTMENT:
        "oralig'idagi mahsulot chiqim hisoboti",
      INITIAL_BALANCE: "Boshlang'ich qoldiq",
      COMING: "Kirim",
      EXPENSE: "Chiqim",
      REMAINDER: "Yakuniy qoldiq",
      QUANTITY: "Soni",
      TOTAL_COST: "Jami qiymati",
      TOTAL: "Jami:",
      PREPARED: "Tayyorladi:",
      AGREED: "Kelishildi:",
      FINANCIALLY_RESPONSIBLE_PERSON: "Moddiy javobgar shaxs",
      PRODUCTION_DIRECTOR: "Ishlab chiqarish bo'yicha direktor",
      CHECKED: "Tekshirdi:",
      WORK_SHOP_HEAD_OF_DEPARTMENT: "Bo'lim boshlig'i",
      FINANCIAL_DIRECTOR: "Moliyaviy direktor",
      MATERIAL_TECHNICAL_CONTROL_DEPARTMENT: "Moddiy-texnik nazorat bo'limi",
      CHECK: "Hisob",
      OFF_BALANCE_SHEET_REPORT: "Balansdan tashqari hisobot",
      DEP_WORKSHOP: "Отд/цех",
      KIPIA: "KIPIA",
      CODE: "Kod",
      PRODUCT_NAME: "Mahsulot nomi",
      DATE_OF_ACCEPTANCE: "Kirim sanasi",
      DATE_OF_DELIVERY: "Chiqim sanasi",
      UNIT: "O'lchov birligi",
      PRICE: "Narxi",
      CHOOSE_THE_WAREHOUSE: "Omborxonani tanlang",
      PRODUCE_HISTORY_IS_NULL: "Mahsulot tarixi bo'sh",
      THE_AMOUNT_OF_PRODUCT_DELIVERED_IS_MORE:
        "Berib yuborilayotgan mahsulot miqdori inisiator so'ragan miqdordan ko'p",
      MUST_GIVE_AT_LEAST_ONE: "Kamida 1 ta berishingiz kerak",
      ERROR_SAVING_FILE: "Fayl saqlashda xatolik bor",
      ONLY_PDF_FILE_CAN_BE_COMPRESSED: "Faqat pdf faylni kichraytirish mumkin",
      OUT_OF_LIMIT: "Berilgan miqdordan ko'p",
      THIS_USER_HAS_NOT_PHONE_NUMBER:
        "Bu foydalanuvchining telefon raqami yo'q",
      YOU_HAVE_NO_ACCESS_TO_RECOVER_YOUR_PASSWORD:
        "Parolingizni tiklashingiz uchun sizda ruhsat yo'q",
      STILLAGE_IS_NULL: "Stellaj yo'q",
      NO_DEPARTMENT_IN_WAREHOUSE: "Omborxona hech bir bo'limga tegishli emas",
      CAN_NOT_RETURN_DEPARTMENT:
        "Qaytarib berish faqat omborxonaga bo'lishi mumkin",
      APPLICATION_NOT_FOUND: "Ariza topilmadi",
      ACCOUNTANT_NOT_FOUND: "Buxgalteriya bo'limini belgilang",
      ACCOUNTANT_TELEGRAM_GROUP_NOT_FOUND:
        "Buxgalteriya bo'limiga telegram guruh biriktiring",
      WAREHOUSE_REQUIRED: "Omborxonani tanlang",
      AKT_FILE_REQUIRED: "Akt hujjat majburiy",
      "0_OR_A_SMALL_VALUE_CAN_NOT_BE_ACCEPTED":
        "0 yoki undan kichik qiymatda qabul qilish mumkin emas",
      NO_PRODUCT_FOUND_BY_ID: "Mahsulot ID topilmadi",
      PRODUCT_ALREADY_TAKEN: "Mahsulot allaqachon olingan",
      USER_HAS_NOT_PERMISSION_TO_GET_PRODUCT:
        "Foydalanuvchi ushbu buyurtma uchun mahsulotni olishga haqli emas",
      ORDER_ID_NOT_FOUND: "Buyurtma ID topilmadi",
      DATA_NOT_FOUND: "Ma'lumot topilmadi",
      DEPARTMENT_OMTK_NOT_FOUND: "ОМТК bo'limi topilmadi",
      CHOOSE_THE_REQUEST_TYPE: "So'rov turini belgilang",
      RECOVERING_PASSWORD_IS_FINISHED:
        "Parolni tiklash tugallandi, qayta urinib koʻring",
      REQUESTCOUNT_IS_REQUIRED: "So'rov soni kiritilmagan",

      CHOOSE_DEPARTMENT_TYPE: "Bo'lim turini kiriting",
      PRODUCT_ID_NOT_FOUND: "Mahsulot ID topilmadi",
      AMONG_THE_SELECTED_PRODUCTS_TAKEN_OUT:
        "Tanlanganlar orasida omborxonadan chiqarilgan mahsulot bor. Mahsulotlarni qayta tanlang",
      MORE_PRODUCTS_ARE_BEING_PROVIDED:
        "Buyurtmada ko'rsatilgandan ko'proq mahsulot berilyapti",
      IMPOSSIBLE_TO_TAKE_ON_THE_TWO_PARTIES_AT_ONCE:
        "Bir vaqtning o'zida ikkita to'plamni olish mumkin emas. Birini olish kerak",
      GOODS_HAVE_NOT_BEEN_GIVEN_FOR_THIS_ORDER_PARTIES:
        "Ushbu buyurtma va partiya uchun tovarlar yetkazib berilmagan",
      ALREADY_TAKEN_AWAY_PRODUCTS_FOR_THIS_ORDER_PARTIES:
        "Ushbu buyurtma va partiya bo'yicha berilgan mahsulotlar olib ketilgan",
      TAKE_MORE_PRODUCTS_THAN_GIVEN:
        "Siz olingandan ko'ra ko'proq mahsulot berdingiz",
      USER_NOT_ATTACHED_TO_DEPARTMENT:
        "Ariza yozgan foydalanuvchi bo'limga biriktirilmagan",
      USER_NOT_ATTACHED_TO_WAREHOUSE:
        "Ariza yozgan foydalanuvchi omborga biriktirilmagan",
      CONTRACT_IS_NOT_FOUND: "Kontrakt topilmadi",
      CANNOT_ACCEPT_MORE_THAN_ONE_SHIPMENT:
        "Berilgan miqdordan ko'p qabul qilolmaysiz",
      PRODUCT_TYPE_NOT_FOUND: "Mahsulot turi topilmadi",
      PRODUCT_GROUP_NOT_FOUND: "Mahsulot guruhi topilmadi",
      SERVLET_RESPONSE_FOR_GENERATE_QR_CODE_IS_NULL:
        "Hosil qilingan QR CODE SERVLET RESPONSE bo'sh",
      MUST_ENTER_NAME: "Ism kiritilishi shart",
      CUSTOMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Bunday ismli mioz allaqachon ro'yxatdan o'tgan",
      CUSTOMER_NOT_FOUND: "Mijoz topilmadi",
      PARENT_ID_FOR_CONTRACT_ITEM_NOT_FOUND:
        "Shartnoma elementi uchun ota-ona identifikatori topilmadi",
      THE_CARRIAGE_DOES_NOT_BELONG_ANY_STELLAGE:
        "Ushbu katak hech bir stellajga tegishli emas",
      STELLAGE_NOT_FOUND: "Stellaj topilmadi",
      REQUEST_IS_NULL: "So'rov mavjud emas",
      COLUMN_SETTINGS_IS_NULL: "Ustun sozlamalari yo'q",
      ENTER_COLUMN_LABEL: "Jadval ustuni nomini kiriting",
      HAS_CONTRACT_ALREADY: "Bu yerda shartnoma bor",
      HAS_ORDER_ALREADY: "Bu yerda buyurtma bor",
      HAS_PRODUCT_ALREADY: "Bu yerda mahsulot bor",
      PRODUCT_IN_STOCK_ROT: "Omborda mahsulot bor, o'chirolmaysiz",
      IDS_FIELD_REQUIRED: "ID null bo'lmasligi kerak",
      CARRIAGE_IS_NULL: "Katak bo'sh",
      CONTRACT_ITEM_PARTITION_ACCEPTED:
        "Shartnoma bandi partiya bo'yicha qabul qilingan",
      CONTRACT_ITEM_PART_ACCEPT: "Shartnoma bandi qisman qabul qilingan",
      CONTRACT_ITEM_ACCEPT: "Shartnoma bandi qabul qilingan",
      CONTRACT_ITEM_REJECT: "Shartnoma bandi rad etilgan",
      TELEGRAM_GROUP_REQUIRED: "Telegram guruhni kiritish kerak",
      TELEGRAM_GROUP_NOT_FOUND: "Telegram guruh topilmadi",
      CONCLUTION_DATE_REQUIRED: "Shartnoma tuzilgan sana kiritilmagan",
      GUESS_RECEIVE_DATE_REQUIRED: "Taxminiy keltirilish vaqti kiritilmagan",
      PRODUCTS_DO_NOT_COME_IN_ONE_BATCH_CANNOT_ADDED:
        "Bitta partiyada kelmagan mahsulotlarni qo'shib bo'lmaydi",
      SECOND_PRODUCT_WAS_NOT_FOUND: "Ikkinchi mahsulot topilmadi",
      THERE_IS_NO_WAREHOUSE_IN_THIS_DEPARTMENT:
        "Bu bo'limda omborxona mavjud emas",
      PRODUCTS_REQUESTED_ORDER_NOT_THE_STATUS_PROVIDED:
        "Buyurtma so'ralgan mahsulotlar beriladigan statusda emas",
      EXCEEDED_THE_QUANTITY_PRODUCT_ORDERED_ALONG_WITH_THE_QUANTITY_PRODUCT_PREVIOUSLY_REQUESTED:
        "Oldinroq so'ralgan mahsulot miqdorlari bilan birga zakaz bo'yicha berilishi kerak bo'lgan mahsulot  miqdoridan oshib ketdi",
      more_than_quantity_product_ordered:
        "Zakaz bo'yicha berilishi kerak bo'lgan mahsulot  miqdordan ko'p so'rayapsiz",
      PRODUCT_WAREHOUSE_IS_NOT_ENOUGH: "Omborda mahsulot yetarli emas",
      YOU_HAVE_NOT_ENTERED_PRODUCT_NUMBER:
        "Siz mahsulot raqamini kiritmadingiz",
      ENTER_THE_QUERY_TYPE: "So'rov turini kiriting",
      MORE_REQUESTED_PRODUCT_QUANTITY_IS_INCLUDED_THE_ORDER:
        "Zakazdagi so'ralgan mahsulot miqdoridan ko'p miqdor kiritilgan",
      CANNOT_DELETE_ITEM_BECAUSE_THE_ITEM_HAS_ALREADY_BEEN_USED:
        "Mahsulotlar foydalanilgani uchun lotni o'chirolmaysiz",
      PARTY_NOT_FOUND: "Partiya topilmadi",
      LOT_NOT_FOUND: "Lot topilmadi",
      WANT_IMPORT_MORE_THAN_VOLUME_OF_PRODUCT_RECEIVED:
        "Qabul qilingan mahsulot hajmidan ko'proq olib kirmoqchisiz",
      INVENTORY_COMPLETE_YOU_HAVE_START_OVER_AGAIN:
        "Ushbu inventarizatsiya tugatilgan. Yangidan boshlashingiz kerak",
      INVENTORY_HAS_BEEN_STARTED_WAREHOUSE_YOU_CAN_CONTINUE:
        "Ushbu omborda inventarizatsiya boshlangan. Davom ettirishingiz mumkin",
      REQUEST_NOT_FOUND: "So'rov topilmadi",
      order_and_products_given_under_batch_were_taken_away:
        "Buyurtma va partiya bo'yicha berilgan mahsulotlar olib ketilgan",
      UNIT_TYPE_NOT_MATCH: "Birlik turi to'g'ri kelmadi",
      SMS_NOT_SEND: "Xabar jo'natilmadi",
      CELLS_USED: "Katakni tanlang",
      CELL_NOT_FOUND: "Katak topilmadi",
      HAS_STELAGE: "Bu yerda stellaj bor",
      SELECT_THE_WAREHOUSE: "Omborxonani tanlang",
      UNIQUE_KEY_DID_NOT_MATCH: "Noyob kalit to'g'ri kelmadi",
      TEAM_NOT_FOUND: "Jamoa topilmadi",
      TEAM_NOT_REQUIRED: "Jamoa kiritilmagan",
      TEAM_LEADER_NOT_FOUND: "Jamoa yetakchisi topilmadi",
      TEAM_LEADER_REQUIRED: "Jamoa yetakchisi kiritilmagan",
      HISTORY_OF_MEDICINE_TAKEN_REQUIRED:
        "Qabul qilingan dorilar tarixini kiriting",
      HISTORY_OF_MEDICINE_TAKEN_NOT_FOUND:
        "Qabul qilingan dorilar tarixi topilmadi",
      MEDICINE_NOT_FOUND: "Dori topilmadi",
      MEDICINE_REQUIRED: "Dorini kiritmadingiz",
      PATIENT_NOT_FOUND: "Bemor topilmadi",
      PATIENT_REQUIRED: "Bemorni kiritmadingiz",
      PASSPORT_REQUIRED: "Passport raqami kiritilmagan",
      RENT_NOT_FOUND: "Ijaraga berish topilmadi",
      RENT_REQUIRED: "Ijaraga berish tanlanmagan",
      EXPIRED_DATE_REQUIRED: "Amal qilish muddati kiritilmagan",
      ELIGIBLE_TO_RECEIVE_GOOD_FOR_THIS_ORDER:
        "Sizda ushbu buyurtma uchun mahsulotni olishga huquq yo'q",
      AMOUNT_ENTERED_MORE_THEN_AMOUNT_LEFT_IN_WAREHOUSE:
        "Kiritilgan mablag' omborda qolgandan ko'p",
      PRODUCT_IS_NOT_ENOUGH_IN_WAREHOUSE: "Omborxonada yetarli mahsulot yo'q",
      CHECK_DATABASE:
        "Bazani tekshiring. Ushbu partiya bo'yicha mahsulot topilmadi",
      USER_NOT_REGISTERED: "Foydalanuvchi registratsiyadan o'tmagan",
      NUMBER_OF_ROWS_IS_NOT_ENOUGH: "Qatorlar soni yetarli emas",
      OLD_PASSWORD_INCORRECT: "Eski parol noto'g'ri",
      OLD_PASSWORD_REQUIRED: "Eski parol kiritilmagan",
      RECOVER_YOUR_PASSWORD: "Parolingizni tiklash uchun sizda ruhsat yo'q",
      CONFIRMATION_CODE_REQUIRED: "Tasdiqlash kodi kiritilmagan",
      USER_REQUIRED: "Foydalanuvchi kiritilmagan",
      PHONE_NUMBER_RIGHT_ENTER: "Telefon raqamingizni to'g'ri kiriting",
      PHONE_NUMBER_REQUIRED: "Telefon raqami kiritilmagan",
      USERNAME_REQUIRED: "Foydalanuvchi nomi kiritilmagan",
      EMAIL_HAS_ALREADY: "Foydalanuvchi pochtasi registratsiyadan o'tgan",
      PHONE_NUMBER_HAS_ALREADY:
        "Foydalanuvchi telefon raqami registratsiyadan o'tgan",
      USER_NAME_HAS_ALREADY: "Foydalanuvchi nomi registratsiyadan o'tgan",
      HAS_NOT_ACCESS: "Sizda ruhsat yo'q",
      USER_NOT_FOUND: "Foydalanuvchi topilmadi",
      UNIT_TYPE_DOES_NOT_MATCH: "Mahsulot birligi to'g'ri kelmadi",
      SMS_DO_NOT_SEND: "Xabar yuborilmagan",
      PERMISSION_NOT_FOUND: "Ruhsatnoma topilmadi",
      ROLE_NOT_FOUND: "Rol topilmadi",
      ORDER_ITEM_COUNT_COUNTABLE: "Berilayotgan miqdor butun bo'lishi kerak",
      PRODUCT_IS_NOT_ENOUGH: "Mahsulot yetarli emas",
      PARTITION_NOT_FOUND: "Partiya topilmadi",
      ORDER_ITEM_AND_CONTRACT_ITEM_REQUIRED:
        "Buyurtma va kontrakt elementlari kiritilmagan",
      PACKAGE_TYPE_NAME_CREATE_ALREADY:
        "Ushbu nom bilan allaqachon ma'lumot yaratilgan",
      PACKAGE_TYPE_NOT_FOUND: "Paket turi topilmadi",
      PACKAGE_NOT_FOUND: "Paket topilmadi",
      COUNT_ENOUGHT: "Ko'p miqdor kiritdingiz",
      COUNT_REQUIRED: "Mahsulot miqdori kiritilmagan",
      OUTGOING_CONTRACT_NUMBER_BUSY: "Bu kontrakt raqami band",
      PASSWORD_CHANGE_ACCESS: "Sizda parolni o'zgartirish uchun ruhsat yo'q",
      CONFIRMATION_CODE_IS_INCORRECT: "Tasdiqlash kodi noto'g'ri",
      ORDER_ITEM_REJECT_MUCH_COUNT:
        "So'ralgan mahsulotdan ko'p mahsulot bekor qilindi",
      OPPORTUNITY_NOT_MATCH_COUNT:
        "Kiritilgan miqdor shartnomadagi miqdorga to'g'ri kelmadi",
      OPPORTUNITY_COUNT_REQUIRED: "Qiymatlardan hech biri kiritilmagan",
      ORDER_ITEM_REQUIRED: "Buyurtma elementlari kiritilmagan",
      UNITTYPE_REQUIRED: "Tovar birligi kiritilmagan",
      PRODUCT_NOT_FOUND: "Mahsulot topilmadi",
      PRODUCT_REQUIRED: "Tovar kiritilmagan",
      INVENTARIZATION_REQUIRED: "Inventarizatsiya boshlanmagan",
      INVENTARIZATION_NOT_FOUND: "Inventarizatsiya topilmadi",
      GIVEN_PRODUCT_TAKEN_AWAY:
        "Bu zakaz va partiya bo‘yicha berilgan maxsulotlar olib ketilgan",
      GIVEN_PRODUCT_NOT_FOUND:
        "Ushbu buyurtma va partiyalar uchun tovarlar berilmagan",
      PRODUCT_ALREADY_TAKEN_AWAY: "Mahsulot allaqachon olib ketilgan",
      MORE_PRODUCTS_DELIVERED_THAN_SPECIFIED_ORDER:
        "Buyurtmada ko'rsatilgandan ko'proq mahsulot berilyapti",
      USER_AGREEMENT_REQUIRED: "Foydalanuvchi shartnomasi kiritilmagan",
      WAREHOUSE_NOT_FOUND: "Ombor topilmadi",
      WAREHOUSE_IS_REQUIRED: "Ombor tanlanmagan",
      DEPARTMENT_REQUIRED: "Bo'lim tanlanmagan",
      DEPARTMENT_HAS_USERS_NOT_DELETE:
        "Bu bo'limni o'chirib bo'lmaydi, chunki bu bo'limda foydalanuvchilar bor",
      ACTION_ALREADY_DONE: "Bu amalni bajarib bo'lgansiz",
      REJECT_REASON_REQUIRED: "Bekor qilish uchun sabab ko'rsating",
      SUPPLIER_TYPE_REQUIRED: "Yetkazib beruvchining turi tanlanmagan",
      UNITTYPE_NOT_FOUND_IN_CONTRACT:
        "Shartnomada o'lchov birligi ko'rsatilmagan",
      PRODUCT_NOT_FOUND_IN_CONTRACT: "Shartnomada mahsulot topilmadi",
      CONTRACT_ITEM_COUNT_LARGE:
        "Shartnomada ko'rsatilgan miqdordan ko'p miqdor kiritilgan",
      DESCRIPTION_REQUIRED: "Izoh kiritilmagan",
      COLUMN_SETTINGS_NOT_FOUND: "Sozlamalar topilmadi",
      TABLE_NOT_SELECTED: "Jadval tanlanmagan",
      PRODUCT_DID_NOT_TO_MATCH: "Mahsulot to'g'ri kelmadi",
      CARRIAGE_NOT_FOUND: "Karetka topilmadi",
      CARRIAGE_IS_REQUIRED: "Karetka tanlanmagan",
      ORDER_COUNT_NOT_ENOUGH: "Buyurtma soni yetarli emas",
      PRODUCT_ITEM_COUNT_NOT_ENOUGH: "Mahsulot soni yetarli emas",
      PRODUCT_ITEM_REQUIRED: "Mahsulot tanlanmagan",
      PRODUCT_ITEM_NOT_FOUND: "Omborda mahsulot topilmadi",
      CONTRACT_REQUIRED: "Shartnoma kiritilmagan",
      CONTRACT_NOT_FOUND: "Shartnoma topilmadi",
      PARTION_NOT_FOUND: "Mahsulot partiyasi topilmadi",
      PRODUCT_TAKEN_FROM_WAREHOUSE: "Mahsulot ombordan olingan",
      PRODUCTS_IS_REQUIRED: "Mahsulotlar tanlanmagan",
      ATTRIBUTE_NOT_FOUND: "Xususiyat topilmadi",
      FILE_NOT_FOUND: "Fayl topilmadi",
      USERNAME_OR_PASSWORD_OR_BLOCK_ACCOUNT:
        "Foydalanuvchi nomi yoki parol notog'ri yoki foydalanuvchi ushbu tizimda faol emas",
      USERNAME_OR_PASSWORD_WRONG: "Foydalanuvchi nomi yoki parol notog'ri",
      PRODUCT_COUNT_NOT_DOT_MATCH: "Mahsulot soni to'g'ri kelmadi",
      OUTGOING_CONTRACT_COUNT_NOT_DOT_MATCH:
        "Shartnomada ko'rsatilgan miqdordan ko'p miqdorni kiritdingiz",
      TO_REVIEW_WAREHOUSE: "ОМТК tomonidan ko'rib chiqilyapti",
      PRODUCT_RECEIVED: "Mahsulot qabul qilindi",
      ENTER_POSITIVE_VALUE: "Musbat qiymat kiriting",
      ORDER_BUSY: "Buyurtma band",
      formatFileNotSupported:
        "Faylni formati tog'ri kelmaydi. Iltimos boshqa fayl yuklang",
      NAME_ALREADY_EXISTS: UzValidateMessages.messages.exist
        .replace("{_title_}", "nom")
        .replace("{_field_}", "attribute"),
      CONTRACT_DECISION_HAS_ALREADY_BEEN_MADE:
        "Shartnoma bo'yicha qaror allaqachon qabul qilingan",
      HASH_CODE_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Hash code"
      ),
      DOCUMENT_PARAMS_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Hujjat parametrlari"
      ),
      ACTION_TYPE_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Vazifa turi"
      ),
      CONTRACT_ITEM_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Shartnoma bandi"
      ),
      BAD_CREDENTIALS: "Login yoki parol noto'g'ri kiritilgan",
      SUPPLIERTYPE_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Yetkazib beruvchi turi"
      ),
      SUPPLIER_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Yetkazib beruvchi"
      ),
      CONFIRMATION_CODE_IS_EXPIRED: "Tasdiqlash kodi xato kirtilgan",
      GIVEN_OLD_PASSWORD_INCORRECT: "Eski parol noto'g'ri kiritilgan",
      USERNAME_NOT_FOUND: "Foydalanuvchi topilmadi",
      NAME_REQUIRED: UzValidateMessages.messages.required.replace(
        "{_field_}",
        "Nomi"
      ),
      UNITTYPE_NOT_FOUND: "O'lchov birligi topilmadi",
      BLOCK_ACCOUNT: "Profilingiz bloklanganan",
      BAD_REQUEST: "Forma maydonlari noto'g'ri kiritilgan",
      NOT_FOUND: "Topilmadi",
      UNAUTHORIZED: "Token eskirgan",
      FILE_REQUIRED: "Fayl maydoni to'ldirilishi shart",
      ERROR_WHILE_SAVING_FILE: "Faylni saqlashda xatolik",
      SUPPLIER_NOT_FOUND: "Ta'minotchi topilmadi",
      NOT_ENOUGH_INFORMATION: "Ma'lumotlar yetarli emas",
      CONTRACT_ITEM_NOT_FOUND: "Shartnoma topilmadi",
      INITIATOR_NOT_FOUND: "Buyurtmachi topilmadi",
      MUST_ENTER_INITIATOR: "Buyurtmachi maydoni to'ldirilishi shart",
      CONTRACT_ITEM_ID_IS_NULL: "Shartnoma id maydoni to'ldirilishi shart",
      CUSTUMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Shu nomli buyurtmachi allaqachon ro'yhatdan o'tqazilgan",
      DEPARTMENT_NOT_FOUND: "Bo'linma topilmadi",
      ID_REQUIRED: "Id maydoni to'ldirilishi shart",
      ORDER_ITEM_ID_REQUIRED: "Buyurtma id maydoni to'ldirilishi shart",
      ORDER_ITEM_NOT_FOUND: "Buyurtma topilmadi",
      ORDER_ITEMS_REQUIRED: "Buyurtmalar maydoni to'ldirilishi shart",
      ORDER_NOT_FOUND: "Buyurtma topilmadi",
      ERROR_SENDING_OTP_CODE: "OTP CODE jo'natilishda xatolik yuz berdi",
      REQUESTCOUNT_AND_GIVENCOUNT_IS_REQUIRED:
        "So'ralgan va berilgan mahsulot soni maydonlari to'ldirilishi shart",
      CONTRACT_NUMBER_REQUIRED: "Shartnoma raqami to'ldirilishi shart",
      OUTGOING_CONTRACT_NOT_FOUND: "Chiquvchi shartnoma topilmadi",
      REALIZATOR_REQUIRED: "Amalga oshiruvchi maydoni to'ldirilishi shart",
      REALIZATOR_NOT_FOUND: "Amalga oshiruvchi topilmadi",
      USER_AGREEMENT_NOT_FOUND: "USER_AGREEMENT_NOT_FOUND",
      NEW_PASSWORD_REQUIRED: "Yangi parol maydoni to'ldirilishi shart",
      ENTER_TIME_FORMAT_CORRECTLY: "Vaqt formatini tog'ri kiriting",
    },
    accountingCode: "Mahsulot raqami",
    accepted: "Qabul qilingan",
    uploadPhoto: "Rasm yuklang",
    enterText: "Matn kiriting",
    find: "Topish",
    start: "Boshlash",
    warnings: "Ogohlantirishlar",
    productIssued: "Mahsulot berib yuborildi",
    givenProduct: "Berib yuborilgan",
    rightClickingMouse:
      "Mahsulotni joylashtirish uchun kerakli katakni sichqonchani o'ng tomonini bosish orqali tanlang",
    hint: "Eslatma",
    viewContractDetails: "Shartnomani batafsil ko'rish",
    admissionConfirmation: "Qabul qilishni tasdiqlash",
    productAcceptance: "Mahsulotni qabul qilish",
    agreementStatus: {
      ORDER_ITEM_PRODUCE: "Qabul qilindi",
      USER_AGREEMENT_ACCEPTED: "Qabul qilindi",
      USER_AGREEMENT_REJECTED: "Bekor qilindi",
    },
    noApprovedContracts: "Tasdiqlanishi zarur bo'lgan shartnomalar yo'q",
    confirmWithKey: "Kalit bilan tasdiqlash",
    accountCode: "Hisob kodi",
    placedBy: "Kim tomonidan",
    deliveredDate: "Omborga kelish sanasi",
    takenAwayDate: "Topshirish sanasi",
    aboutProduct: "Mahsulot haqida",
    existingInv: "Bu tovar inventarizatsiya qilingan",
    inventarizationStopped: "{warehouse} omborida inventarizatsiya to'xtadi",
    continueInventarization: "Davom ettirish",
    finishInventarization: "Tugatish",
    receive: "Qabul qilish",
    toWriteOff: "Hisobdan chiqarish",
    downloadProductList: "Mahsulotlar ro'yxatini yuklab olish",
    carriageAddress: "Karetka manzili",
    stillageAddress: "Stellej manzili",
    viewFile: "Faylni ko'rish",
    productReport: "Mahsulotlar hisoboti",
    productIsNotPlace: "Mahsulot joyida emas",
    numNotEnough: "Mahsulot soni yetarli emas",
    quantityInExcess: "Mahsulot soni ko'p",
    productCount: "Mahsulot soni",
    givenProductQuantity: "Berib yuboriladigan mahsulotlar soni",
    addWithFile: "Fayl bilan mahsulot qo'shish",
    allCarriagesEmpty: "Hamma kataklar bo'sh",
    halfEmpty: "Katak bo'sh emas",
    carriagesFull: "Katak to'la",
    warehouseIndicators:
      "Stellajning o'ng tomonidagi ko'rsatkichlar quyidagilarni anglatadi:",
    naming: "Nomlanishi",
    designation: "Nomi",
    row: "Qator",
    hiddenWarehouses: "Yashirin omborlar",
    supportService: "Qo'llab-quvvatlash xizmati",
    divisionType: "Bo'lim turi",
    toCancel: "Bekor qilish",
    chooseAnotherStatus: "Boshqa holatni tanlang",
    selectWarehouse: "Omborni tanlang",
    datePlaceholder: "kun/oy/yil",
    downloadTemplateFile:
      "Mahsulotlarni kiritish uchun shablon faylni yuklab olish",
    organizationName: "Tashkilot nomi",
    weekShortTitle: {
      0: "Yak",
      1: "Dush",
      2: "Sesh",
      3: "Chor",
      4: "Pay",
      5: "Jum",
      6: "Shan",
    },
    weekShort: {
      0: "Y",
      1: "D",
      2: "S",
      3: "Ch",
      4: "P",
      5: "J",
      6: "Sh",
    },
    monthsNames: {
      0: "Yanvar",
      1: "Fevral",
      2: "Mart",
      3: "Aprel",
      4: "May",
      5: "Iyun",
      6: "Iyul",
      7: "Avgust",
      8: "Sentyabr",
      9: "Oktyabr",
      10: "Noyabr",
      11: "Dekabr",
    },
    monthsNamesShort: {
      0: "Yan",
      1: "Fev",
      2: "Маr",
      3: "Apr",
      4: "May",
      5: "Iyu",
      6: "Iyu",
      7: "Avg",
      8: "Sen",
      9: "Okt",
      10: "Noy",
      11: "Dek",
    },
    startInventarization: "Inventarizatsiyani boshlash",
    inventarization: "Inventarizatsiya",
    wantToDistribute: "{count} mahsulotni tarqatishni xohlaysizmi?",
    enterQuantity: "Miqdorni kiriting",
    distribution: "Tarqatish",
    orderQuantity: "So'rov bo'yicha buyurtmalar miqdori",
    totalOrders: "Buyurtmalarning umumiy soni",
    productDelivery: "Mahsulot berish",
    place: "Joy",
    spaceLeft: "Mahsulot joylangandan so'ng yana joy qoldimi?",
    confirmPlacement: "Mahsulotni shu yerga joylaganingizni tasdiqlang",
    putProduct: "Rostdan ham shu yerga joyladim",
    placeInFreeSpace: "Bo'sh joyga joylashtirish",
    placedDate: "Joylangan sana",
    invDate: "Inv sanasi",
    whoPosted: "Kim joyladi",
    quantity: "Miqdori",
    placedProducts: "Joylashtirilgan mahsulotlar",
    placeHere: "Shu yerga joylash",
    selectPlacement: "Joylashtirish uchun maydon tanlang",
    tmtPlacement: "Mahsulotni joylash",
    determinePlacement: "Joyni aniqlab joylashtirish",
    existingQr: "Bu QR yuklangan",
    addQrCode: "QR kod qo'shish",
    showDetails: "Detallarni ko'rsatish",
    enterQrCode: "QR kodni kiriting",
    scan: "Skanerlash",
    pressToScan: "QR kodni skanerlash uchun tugmani bosing",
    placement: "Joylashtirish",
    leftToCapitalize: "Kirim qilinmaganlar soni",
    palletsNumber: "Palletlar soni",
    invoiceNumber: "Hisob-faktura raqami",
    invoiceDate: "Hisob-faktura sanasi",
    actNumber: "Akt raqami",
    gtd: "GTD",
    manufactureDate: "Ishlab chiqarilgan sana",
    dataOfReceipt: "Kirim sanasi",
    numberOfPackages: "Prixodlar soni",
    createIncome: "Kirimni yaratish",
    createLots: "Lotlar yaratish",
    contractDivisionStatus: {
      /**
       * * Contract item status
       * */
      ACCEPTED: "Qabul qilingan",
      REJECTED: "Bekor qilingan",
      PART_ACCEPTED: "Qisman qabul qilingan",
      WAITING: "Mening qarorim kutilmoqda",
    },
    thinkDefective:
      " Haqiqatan ham {count} {unit_type} mahsulotni nuqsonli deb hisoblaysizmi?",
    rejectedCount: "Rad etilganlar soni",
    defectiveGoodsNumber: "TMTs nuqsonli tovarlar sonini kiriting",
    enterAmount: "TMTs qabul qiladigan miqdorni kiriting",
    leaveComment: "Izoh qoldiring",
    attachPhotosAndComment: "Izoh va rasm qoldiring",
    matched: "Mos keldi",
    partialAdmission: "Qisman qabul qilish",
    notCompatible: "Mos kelmadi",
    partyReception: "Partiyani qabul qilish",
    wantToAdd: "Rostdan ham qo'shishni xohlaysizmi?",
    wantToChange: "Rostdan ham o'zgartirishni xohlaysizmi?",
    contractOmtkStatus: {
      /**
       * * Contract item status
       * */
      CONTRACT_ITEM_ACCEPTED: "Qabul qilingan",
      CONTRACT_ITEM_REJECT: "Bekor qilingan",
      CONTRACT_ITEM_PART_ACCEPTED: "Qisman qabul qilingan",
      CONTRACT_ITEM_PARTITION_ACCEPTED:
        "Partiya bo'yicha qisman qabul qilingan",
      NEW: "Yangi",
    },
    addAnotherRecipient: "Boshqa qabul qiluvchini qo'shish",
    sendPushNotification: "push-xabarnoma jo'natish",
    changeEmployee: "Xodimni o'zgartirish",
    chooseInitiator: "Tashabbuskorni tanlash",
    selectSection: "Bo'limni tanlang",
    changeInitiator: "Ushbu xodimni boshqasiga almashtirishni istaysizmi?",
    confirmWithEimzo: "E-imzo bilan tasdiqlang",
    selectKey: "Kalitni tanlang",
    eimzo: {
      valid: "Действителен",
      certificateNumber: "№ сертификата",
      certificate: "Sertifikat",
      stir: "STIR",
      fullName: "F.I.Sh.",
      organization: "Tashkilot",
      expiryDate: "Sertifikatni amal qilish muddati",
      pnfl: "JSHSHIR",
    },
    selectAll: "Hammasini tanlash",
    acceptedInitiatorCount: "Qabul qilgan buyurtmachilar soni",
    partiallyAccepted: "Qisman qabul qilingan",
    numberOfDelinquencies: "Kechikishlar soni",
    showDuplicates: "Bir xil mahsulotlarni ko'rsatish",
    duplicateProducts: "Bir xil mahsulotlar",
    basicToolReports: "Asosiy vositalar hisoboti",
    basicToolReportsTitle: "Asosiy materiallar bo'yicha hisobot olish",
    oldQr: "Birinchi QR",
    newQr: "Yangi QR",
    moveCount: "Ko'chiriladigan mahsulot soni",
    Id: "ID",
    moveQr: "Yangi QRga ko'chirish",
    moveQrToExist: "Mavjud QRga ko'chirish",
    moveProduct: "Mahsulotni ko'chirish",
    moveProductConfirmDesc:
      "Siz rostdan ham bu mahsulotni ko'chirishni xohlaysizmi?",
    moveToWarehouse: "Omborxonaga qaytarib berish",
    existQr: "Mavjud QR",
    splitQr: "QRni bo'lish",
    materialsThatEnd: "Tugayotgan mahsulotlar",
    analytics: "Analitika",
    frequentlyGoodsMaterials: "Ko'p ishlatiladigan mahsulotlar",
    yearShort: "{0} y",
    delaysReport: "Kechiktirgan ta'minotchilar",
    invalidProductReport: "Yaroqsiz mahsulotlar hisoboti",
    latencyRequests: "Kechikgan buyurtmalar",
    expirationGoodsMaterials: "Muddati o'tgan mahsulotlar hisoboti",
    developedBy: "{0}da ishlab chiqilgan",
    expired: "Muddati o'tgan",
    contractInitiator: "Shartnoma yaratuvchi shaxs",
    pageCount: "Sahifa raqami",
    uploadFile: "Faylni yuklash",
    authorization: "Avtorizatsiya",
    weight: "Vazni/soni",
    reload: "Yangilash",
    reindexAll: "Barchasini qayta indexlash",
    reindex: "Qayta indexlash",
    dateAcceptance: "Qabul qilingan vaqti",
    wantToContinue: "Davom ettirishni xohlaysizmi?",
    loading: "Yuklanmoqda...",
    updatedByUser: "O'zgartirgan foydalanuvchi",
    changed: "O'zgartirilgan",
    price: "Narxi",
    gaveUser: "Kim bergan",
    allProduct: "Barcha mahsulotlar",
    qrCode: "QR kod",
    msdsFile: "MSDS fayl",
    print: "Chop etish",
    printQrCode: "QR chop etish | QR chop etish",
    ourProducts: "Bizning mahsulotlar",
    writeOff: "Chiqarish",
    writeOffProduct: "Mahsulotni chiqarish",
    file: "File",
    reference: "Ma'lumotlar",
    writeOffed: "Chiqarilgan",
    ozl: "OZL",
    login: "Login",
    password: "Parol",
    ourOrders: "Bizning buyurtmalarimiz",
    create: "Yaratish",
    createNewRequest: "Yangi buyurtma yaratish",
    or: "yoki",
    orderNotAddYet:
      "Buyurtmalar yaratilmagan. Yaratish uchun qo'shish tugmasini bosing",
    addOrderItemToRequest: "Buyurtmaga mahsulot qo'shish",
    sortable: "Tartiblanadigan",
    minWidth: "Min. kenglik",
    orderRequestItemNumber: "So`rov tartib raqami",
    limitProductCount: "Minimal mahsulot soni",
    productCategory: "Mahsulot kategoriyasi",
    timeToBeEntered: "Yaratilgan vaqti",
    pendingPurchaseDate: "Hujjatlar qabul qilingan vaqti",
    updatedDate: "O'zgartirilgan sana",
    itemConclusionDate: "Oxirgi o'zgarish vaqti",
    count: "Soni",
    countShort: "Soni",
    countQr: "qr soni",
    unit: "O'lchov birligi",
    from: "dan",
    downloadFile: "Yuklab olish",
    downLoadFileContract: "Shartnoma faylini ko'chirib olish",
    historyContractCode: "{code} shartnomaning tarixi",
    fileRequest: "№{numb} buyurtma uchun fayl",
    error: "Xato",
    inventoryTime: "Inventarizatsiya vaqti",
    writeOffTime: "Hisobdan chiqarish vaqti",
    gotIt: "Tushunarli",
    writeOffByUser: "Kim tomonidan chiqarilgan",
    numberOfValidProducts: "Number of valid products",
    numberOfInvalidProducts: "Number of invalid products",
    inventory: "Inventarizatsiya",
    envNumber: "ENV raqam",
    errorHasOccurred: "Xatolik yuz berdi",
    prev: "Orqaga",
    productName: "Mahsulot nomi",
    whoImplemented: "Kim amalga oshiradi",
    sendDepartmentName: "Mahsulot kelgan bo'lim nomi",
    send: "Yuborish",
    typeProduct: "Mahsulot turi",
    receiverDate: "Yetkazib berilgan sana",
    date: "Sana",
    extraOptions: "Qo'shimcha imkoniyatlar",
    extra: "Qo'shimcha",
    more: "Ba'tafsil",
    sendDate: "Buyurtma jo'natilgan vaqti",
    placeProductIn: "Mahsulotni {warehouse}ga joylashtirish",
    type: "Turi",
    status: "Holati",
    noDataAvailable: "Ma'lumotlar yo'q",
    prevStatus: "Предыдущий статус",
    currentStatus: "Текущий статус",
    nameOfSupplier: "Ta'minotchi nomi",
    nameOfCustomer: "Buyurtmachi nomi",
    warehouse: "Omborxona",
    createWarehouse: "Ombor qo'shish",
    product: "Mahsulot",
    filter: "Filtr",
    columns: "Ustunlar",
    attachFile: "Fayl qo'shish",
    deliveryDate: "Yetkazib berish vaqti",
    orderSent: "Buyurtma yuborildi",
    sendAgain: "Qayta yuborish",
    productGroup: "Mahsulot guruhi",
    reportInventory: "Invetorizatsiya hisoboti",
    writeOffFromThem: "Chiqarilganlar soni",
    edit: "O'zgartirish",
    delete: "O'chirish",
    cancel: "Orqaga",
    save: "Saqlash",
    add: "Qo'shish",
    searchForName: "Nomi bo'yicha izlash",
    orderItemByDepartment: "Buyurtma mahsulotlari bo'limlar bo'yicha",
    searchForNumber: "Raqami bo'yicha izlash",
    productCreate: "Mahsulot yartish",
    productEdit: "Edit product",
    editCategory: "Kategoriyani o'zgartirish",
    byCategory: "Buyurtma mahsulotlari kategoriyasi bo'yicha",
    byOrderItemStatus: "Buyurma holati bo'yicha",
    byTime: "Buyurtmalar soni vaqt bo'yicha",
    category: "Kategoriya",
    nameOfGroup: "Guruh nomi",
    name: "Nomi",
    group: "Guruh",
    description: "Ma'lumot",
    notIncomeSmsHint: "sms kelmagan bo'lsa qayta urinib ko'ring!",
    stillageStatus: {
      full: "Bo'sh joy yo'q",
      empty: "Bo'sh",
      hasSpace: "Bo'sh joy bor",
    },
    warehouseFieldType: {
      corridor: "Yo'lak",
      field: "Bo'sh joy",
      stillage: "Stellaj",
      carriage: "Karetka",
    },
    action: "Vazifalar",
    typeProducts: "Mahsulot turi",
    realization: "Amalga oshirish",
    inventoried: "Kiritilgan",
    day: "Kun",
    month: "Oy",
    year: "Yil",
    allTime: "Hamma vaqt",
    groupProducts: "Mahsulot guruhi",
    whoProduced: "Kim o'tqazgan",
    finishOrder: "Buyurtmani tugatish",
    contractCompleteDate: "Shartnomaning yoplishi sanasi",
    nContract: "Shartnoma №",
    groups: "Guruhlar",
    requests: "Buyurtmalar",
    clear: "Tozalash",
    itIsEmpty: "Bo'm-bo'sh",
    addProduct: "Mahsulot qo'shish",
    hasProductInWereHouse: "Mahsulot bor",
    implementator: "Amalga oshiruvchi",
    clearFilter: "Filtrni tozalash",
    expiration: "Amal qilish muddati(kun)",
    notEnoughProduct: "Soni yetarli emas",
    implementDate: "Amalga oshirish vaqti",
    noProduct: "Mahsulot yo'q",
    noPlacementProduct: "Joylashtirilgan mahsulot yo'q",
    enterValue: "Qiymatni kiriting",
    addAttribute: "Attribut qo'shish",
    material: "Material",
    nameAttribute: "Attribut nomi",
    reportWriteOff: "Chiqarilgan mahsulotlar hisoboti",
    value: "Qiymati",
    attributes: "Atributlar",
    used: "Ishlatilgan",
    attributeProduct: "Mahsulot attributi",
    done: "Saqlash",
    ourRequest: "Buyurtmalarimiz",
    requestNumber: "So`rov raqami",
    requestNumberN: "Buyurtma raqami {number}",
    numberPositionInContract: "Shartnoma tartib raqami",
    newVersionFoundHint: "Yangi versiya topildi. Yangilashni istaysizmi?",
    occupancyPercent: "Bandlik darajasi",
    occupiedPlacePercent: "{percent}% joy band",
    subdivision: "Bo'linma",
    initiator: "Buyurtmachi",
    categoryTMC: "Kategoriya TMC",
    documents: "Fayllar",
    typeTMC: "TMC tip",
    contractNumber: "Shartnoma raqami",
    contractDocuments: "Shartnoma hujjatlari",
    number: "Raqam",
    requestStatus: "Buyurtma holati",
    requestPositionStatus: "Buyurtma joylashgan holati",
    viewHistory: "Tarixini ko'rish",
    packageCount: "Qr soni",
    userName: "Foydalanuvchi nomi",
    assumptionSendDate: "Taxminiy olib kelinish sanasi",
    importFromExcel: "Excel fayldan import qilish",
    exampleExcel:
      "Mahsulotlarni import qilish uchun misol fayl  ko'chirib olish",
    guessReceiveDate: "Taxminiy olib kelinish sanasi",
    phone: "Telefon raqam",
    firstName: "Ism",
    changePassword: "Parolni o'zgartirish",
    viewContractHistory: "Shartnoma tarixini ko'rish",
    doYouWantGoBack: "Siz rostdan ham shu tarixga qaytmoqchimisiz?",
    lastName: "Otasining ismi",
    email: "Email",
    middleName: "Familiya",
    forgetPassword: "Parolni unutdingizmi?",
    passwordChanged: "Parol o'zgartirildi",
    logOut: "Chiqish",
    enterToSystem: "Sistemaga kirish",
    notification: "Bildirishnoma",
    next: "Keyingisi",
    confirmPassword: "Parolni takrorlash",
    limit: "Limit",
    filled: "Сўм",
    income: "Mahsulot kiritish",
    incomeReport: "Mahsulot kiritish hisoboti",
    movedToWarehouseAndInProgress:
      "Boshqa omborxonaga ko'chirilgan va tasdiqlanishi kutilyapti",
    reportIncome: "Kirim hisoboti",
    reportExpense: "Xarajatlar hisoboti",
    show: "Ko'rsatish",
    department: "Bo'lim",
    department2: "Bo'lim",
    departmentIdAlert:
      "Tizimdan foydalanish uchun sizda department bo'lishi kerak. Adminga murojaat qilishingizni so'raymiz!",
    successfullySaved: "Muvaffaqiyatli saqlandi",
    addedNewOrder: "Yangi buyurtma qo'shildi",
    addedNewContract: "Yangi shartnoma qo'shildi",
    enable: "Yoqilgan",
    updatedSuccessfully: "Muvofaqqiyatli o'zgartirildi!",
    successfullyAccepted: "Muvofaqqiyatli qabul qilindi",
    successfullyRejected: "Muvofaqqiyatli rad qilindi",
    newPassword: "Yangi parol",
    oldPassword: "Eski parol",
    oldWarehouse: "Eski omborxona",
    successfullyDeleted: "Muvofaqqiyatli o'chirildi",
    title: "Sarlavha",
    orderHistoryNumb: "{numb} buyurtma tarixi",
    successfullySent: "Muvofaqqiyatli yuborildi",
    deleteDepartmentHint:
      "Agar bu bo'limni o'chirib yuborsangiz, ushbu bo'limga tegishli barcha foydalanuvchilar ham o'chib ketadi!!!",
    receptionDate: "Qabul qilish vaqtini kiriting",
    typeDelivery: "Yetkazib berish turi",
    contractDate: "Shartnoma tuzilgan vaqt",
    estimatedDeliveryDate: "Taxminiy keltirilish vaqti",
    sendNotificationToOMTK: "OMTK ga xabar jo'natish",
    sendNotification: "Xabar jo'natish",
    sendNotificationToAccounting: "Buxgalteriya ga xabar jo'natish",
    toOMTK: "ОМТК ga",
    toAccounting: "Buxgalteriya ga",
    accountant: "Buxgalteriya",
    contractHistory: "Shartnomalar tarixi |Shartnoma raqam tarixi",
    orderHistory: "Buyurtma tarixi | Buyurtma raqami tarixi",
    productHistory: "Mahsulot tarixi",
    provider: "Ta'minotchi",
    users: "Foydalanuvchilar",
    dateWriteOff: "Chiqarilgan sana",
    doYouWantReject: "{count} mahsulotni bekor qilishni istaysizmi?",
    outGoingContracts: "Chiquvchi shartnomalar",
    listOfVisits: "Tashriflar ro'yxati",
    whoChangeStatus: "Buyurtma holatini kim tekshirgan",
    statusChangedUser: "Buyurtma holatini kim tekshirgan",
    positionStatus: "Buyurtma holati",
    allAttributes: "Barcha sifatlar",
    attributeSearch: "Sifatlarni qidirish",
    valueSearch: "Qiymat qidirish",
    roles: "Lavozimlar",
    additionalRole: "Qo'shimcha lavozim",
    permissions: "Ruxsatnomalar",
    internal: "Ichki",
    import: "Import",
    categories: "Kategoriyalar",
    added: "Qo‘shildi",
    productNumber: "Mahsulot raqami",
    lotName: "Lot nomi",
    searchByName: "Nomi bo'yicha qidirish",
    requestSubmissionDate: "Topshiriladigan sana",
    //status
    createContract: "Shartnoma yaratish",
    filterBySupplier: "Yetkazib beruvchi bo'yicha izlash",
    filterByInitiator: "Buyurtmachi bo'yicha izlash",
    profile: "Profil",
    all: "Hammasi",
    addToContract: "Shartnomaga qo'shish",
    settings: "Sozlash",
    tableName: "Jadval nomi",
    columnLabel: "Ustun nomi",
    columnValue: "Qiymat nomi",
    reject: "Bekor qilish",
    nameOfProduct: "Mahsulot nomi",
    measure: "O'lchov belgisi",
    measureShort: "O'lchov belgisi",
    terminate: "To'xtatish",
    contractTerminated: "Shartnomani bekor qilish",
    signed: "Imzolangan",
    addMoreProductToRequest:
      "Bu mahsulot buyurtmaga allaqachon qo'shilgan yana qo'shing",
    products: "Mahsulotlar",
    omtk: "OMTK",
    tender: "Tender",
    groupOfProduct: "Muhsulot guruhi",
    dateWhenYouNeedToPutEverything: "Mahsulotlarni to'liq joylashtirish vaqti",
    hide: "Berkitish",
    remainingContract: "Shartnoma bo'yicha qoldiq",
    remains: "Qoldiq",
    implemented: "Amalga oshirilgan",
    willBeAddedToNewRequest: "{0}si yangi buyurtmaga qo'shiladi",
    dateOfConclusionContract: "Shartnoma tuzilgan sana",
    new: "New",
    enterDate: "Sanani kiriting",
    customer: "Mijoz",
    rejectRequest: "Buyurtmani bekor qilish",
    addPosition: "Qo'shish",
    expenses: "Xarajatlar",

    //status
    NOT_ACCEPTED_ORDER: "Qanoatlantirilmagan",
    RECEIVED: "Olib ketilgan",
    DELETED: "O'chirilgan",
    [orderItemStatus["ISSUED_ORDER_ITEM"]]: "Mahsulot yetib kelgan",
    [orderItemStatus["OZL_TO_DEPARTMENT"]]: "O'zgartirilishi kutilyapti",
    [orderItemStatus["DELIVERY_EXPECTED"]]: "Shartnoma tuzildi",
    [orderItemStatus["READY_TO_PRODUCE"]]: "Mahsulot berib yuborilgan",
    [orderItemStatus.YES_PRODUCT]: "Berib yuborishga tayyor",
    [orderItemStatus["COMPLETED"]]: "Tugatilgan",
    ACCEPTED_ORDER: "Qanoatlantirilgan",
    TO_REVIEW_WAREHOUSE: "ОМТК tomonidan ko'rib chiqilyapti",
    NO_PRODUCT: "TMS omborxonda yo'q",
    [orderItemStatus.YES_PRODUCT]: "TMS omborxonada",
    REJECT_ORDER_ITEM: "Buyurtma ОМТК tomonidan bekor qilingan",
    PAPER_EXPECTED_SPECIFICATION: "Buyurtma hujjatlari kutilyapti",
    PENDING_PURCHASE: "Sotib olinishi kutilmoqda",
    PRODUCT_DELIVERED: "Buyurtma yetkazildi",
    APPLICATION_REJECTED_OZL: "Buyurtma OZL tomonidan bekor qilingan",
    CONTRACT_CONCLUTION: "Shartnoma tuzilgan",
    CONTRACT_TERMINATED: "Shartnoma buzilgan",
    NEW: "Yangi",
    to: "gacha",
    parentNameCategories: "Ota-onaning ismi toifalar",
    resentHint: "Birozdan keyin yana qayta yuborishingiz mumkin",
    columnName: "Ustun nomi jadvalda",
    parent: "Otasi",
    reasonRejectContract: "Bekor qilish sababi",
    acceptedCount: "Qabul qilingan soni",
    uploadFileRequest: "Buyurtma uchun faylni yuklash",
    contractRejectionHint: "Shartnomani bekor qilish sababini keltiring",
    conclusionAndReceived: "Tuzilgan va qabul qilingan shartnomalar",
    newCategoryName: "Yangi toifadagi nom",
    addCategory: "Kategoriya qo'shish",
    addInventory: "Inventarizatsiya qo'shing",
    nameCategory: "toifaning nomi",
    nameOfGoodsAndMaterials: "Tovar va materiallarning nomi",
    acceptedContracts: "Qabul qilingan shartnomalar",
    conclusionContracts: "Tuzilgan shartnomalar",
    reasonForRefusal: "Buyurtma bekor qilinishining sababi",
    changeCategory: "Toifani o'zgartirish",
    changeInventory: "Inventarizatsiyani o'zgartirish",
    addGroup: "Guruh qo'shish",
    homeFurniture: "Uy mebellari",
    hasCount: "Mavjud",
    livingRoomFurniture: "Yashash xonasi uchun mebel",
    initiatorOzl: "Buyurtmachi OZL",
    areAvailable: "Yetarli",
    notEnoughQuantity: "Soni yetarli emas",
    hasPlace: "Joy bor",
    noPlace: "Joy yo'q",
    yes: "Ha",
    notAvailable: "Yetarli emas",
    sendToOzl: "Mahsulot yo'q, OZL ga jo'natish",
    specAccepted: "Spetsifikatsiya qabul qilindi",
    productAvailableNotEnoughQuantity: "Mahsulot yetarli emas",
    givePartiallyProduct: "Mahsulot bor, qisman berish",
    sofa: "Divan",
    state: "Holati",
    editGroup: "Guruhni tahrirlash",
    editZone: "Zonani tahrirlash",
    createZone: "Zona yaratish",
    suppliers: "Ta'minotchilar",
    supplier: "Ta'minotchi",
    giveOut: "Berib yuborish",
    available: "Mavjud",
    refuse: "Bekor qilinadi",
    asked: "So'ralgan",
    requestApproved: "Buyurtma qanoatlantirildi",
    team: "Guruh",
    addRealizationProduct: "Amalga oshirilgan mahsulotni qo'shish",
    hidden: "Berkitish",
    mainWarehouse: "Bosh omborxona",
    inWarehouse: "Omborxonada",
    mainDepartment: "Bosh bo'lim",
    productsInDraft: "Tekshirilmagan mahsulotlar",
    browseFile:
      "Fayl yuklash uchun bu yerga bosing yoki faylni bu yerga tashlang",
    wantAddProduct: "Yana mahsulot qo'shishni istaysizmi?",
    warehouses: "Omborxonalar",
    orders: "Buyurtmalar",
    teamLeader: "Guruh sardori",
    productCode: "Mahsulot raqami",
    countOfRequested: "So'ralgan mahsulot soni",
    requestRejection: "Buyurtmani bekor qilish",
    requestRejectionHint: "Buyurmani bekor qilish uchun sababini keltiring",
    movingProducts: "Mahsulotni ko'chirish",
    requestFinishHint: "Buyurmani tugatish uchun sababini keltiring",
    reasonRejectRequest: "Bekor qilishi sababi",
    months: [
      "Yanvar",
      "Fevral",
      "Mart",
      "Aprel",
      "May",
      "Iyun",
      "Iyul",
      "Avgust",
      "Sentabr",
      "Oktabr",
      "Noyabr",
      "Dekabr",
    ],
    createSupplier: "Ta'minotchi yaratish",
    createOrder: "Buyurtma yaratish",
    createType: "Tur yaratish",
    typeSupply: "Yetkazib berish turi",
    update: "Yuklash",
    updateNewVersion: "Yangilash",
    updateType: "Turni yangilash",
    updateSupplier: "Ta'minotchini yangilash",
    updateCustomer: "Buyurmachini yangilash",
    position: "O'rnatilgan joyi",
    visible: "Ko'rinadigan",
    numberRequest: "Buyurtma raqami",
    approve: "Tasdiqlash",
    categoryProduct: "Mahsulot kategoriyasi",
    approveRequest: "Buyurtmani tasdiqlash",
    no: "Yo'q",
    yesDelete: "Ha, o'chirish",
    warning: "Ogohlantirish!",
    wantDeleteHint: "O'chirishni hohlaysizmi ?",
    comment: "Izoh",
    color: "Rang",
    size: "Shrift hajmi",
    youHaveNotAccess: "Sizda ruxsat yo'q",
    acts: "Aktlar",
    editContract: "Shartnomani o'zgartirish",
    attachAct: "Akt ni biriktirish",
    code: "Kod",
    address: "Manzil",
    contracts: "Shartnomalar",
    open: "Ochish",
    nameGroup: "Guruh nomi",
    addToBasket: "Savatga qo'shish",
    moveProductStatus: {
      NEW: "Yangi",
      APPROVED: "Qabul qilingan",
      REJECTED: "Bekor qilingan",
    },
    receptionStatus: {
      NEW: "Berib yuborilmagan",
      REQUEST_DONE: "Berib yuborilgan",
    },
    history: "Harakatlar tarixi",
    successMessages: {
      reIndexed: "Indexlandi",
    },

    notificationTemplate: {
      departmentToOmtk: "{userName} {count} {productName}ni olib ketmoqchi",
      ozlToOmtkProfitProduct:
        "№{contractNumber} raqamli shartnoma bo'yicha {productName} yetib keldi",
      ozlToAccountProfitProduct:
        "Ushbu {contractNumber}-sonli shartnoma bo'yicha tovarlar etkazib berish kutilmoqda. Iltimos, ishonchnomani tayyorlang.",
    },
    orderItemStatusDescription: {
      [orderItemStatus.YES_PRODUCT]:
        "Mahsulotni {name} omborxonadan olishingiz mumkin",
      [orderItemStatus["PAPER_EXPECTED_SPECIFICATION"]]:
        "Sotib olinishi kerak bo'lgan buyurtma yaratish uchun tegishli bo'lim bilan bog'laning",
    },
    outGoingContractStatus: {
      CONCLUDED: "Tuzilgan",
      COMPLETED: "Yopilgan",
    },
    contractStatus: {
      /**
       * * Contract status
       * */
      USER_AGREEMENT_ACCEPTED: "Qabul qilingan",
      USER_AGREEMENT_DELETED: "O'chirilgan",
      USER_AGREEMENT_REJECTED: "Bekor qilingan",
      USER_AGREEMENT_PART_ACCEPTED: "Qisman qabul qilingan",

      CONTRACT_CONCLUTION: "Kontrakt tuzilgan",
      CONTRACT_ACCEPTED: "Qabul qilingan",
      CONTRACT_ITEM_PARTITION_ACCEPTED:
        "Shartnoma partiya bilan qabul qilingan",
      PART_ACCEPTED: "Qisman qabul qilingan",
      CONTRACT_REJECT: "Buzilgan",

      /**
       * * Contract item status
       * */
      NEW: "Yangi",
      CONTRACT_ITEM_ACCEPTED: "Qabul qilingan",
      CONTRACT_ITEM_REJECT: "Bekor qilingan",
      CONTRACT_ITEM_PART_ACCEPTED: "Qisman qabul qilingan",
      CONTRACT_NEW: "New",
      DELETED: "O'chirilgan",
    },
    orderItemStateOmtk: {
      available: "Mavjud",
      noAvailable: "Mavjud emas",
      notEnough: "Yetarli emas",
    },
    productPackageType: {
      COUNTABLE: "Dona",
      PACKAGEABLE: "Qadoq",
    },
    productItemStatus: {
      NEW: "Yangi",
      PRODUCT_PRODUCED: "Mahsulot olib ketilgan",
      PRODUCT_USED: "Ishlatilgan",
      DELETED: "O'chirilgan",
    },
    validation: UzValidateMessages.messages,
    $vuetify: {
      fileInput: {
        counter: "{0} files",
      },
      dataIterator: {
        loadingText: "Yangilanmoqda",
      },
      datePicker: {
        nextMonthAriaLabel: "next month",
        prevMonthAriaLabel: "prev month",
        prevYearAriaLabel: "prev year",
        nextYearAriaLabel: "next year",
      },
      noDataText: "Ma'lumotlar yo'q",
      pagination: {
        ariaLabel: {
          next: "Next",
          wrapper: "Wrapper",
          previous: "Previous",
          currentPage: "Current page",
          page: "Page",
        },
      },
      dataTable: {
        sortBy: "Tartiblash",
        ariaLabel: {
          sortNone: "Sort no",
          activateAscending: "Active ascending",
          activateDescending: "activateDescending",
          sortAscending: "sortAscending",
          sortDescending: "sortDescending",
          activateNone: "activateNone",
        },
      },
    },
    errors: {
      productNotSaved: "Mahsulot saqlanmadi",
      "Request aborted": "Request aborted",
      noRequestAdded: "Buyurtma qo'shmadingiz",
      "Request failed with status code 400": "Request failed 400",
      "Request failed with status code 500": "Request failed 500",
      "Request failed with status code 502": "Request failed 502",
      "Request failed with status code 401": "Request failed 401",
      "Request failed with status code 404":
        "Request failed with status code 404",
      "Network Error": "Serverga ulanib bo'lmadi",
      "E-Imzo not installed": "E-imzo o'rnatilmagan",
    },
    packageType: "Qadoq turi",
    printQr: "QRni chop etish",
    printedQr: "Chop etilgan",
    notPrintedQr: "Chop etilmagan",
    acceptUser: "Qabul qiluvchi",
    reports: "Hisobotlar",
    materialReport: "Moddiy boyliklar hisoboti",
    dashboardTableType: {
      graph: "Grafik",
      table: "Jadval",
    },
    getMaterialReport: "Moddiy boyliklar hisobotini ko'chirib olish",
    support: "Qo'llab-quvvatlash",
    dateFrom: "Boshlang'ich sana",
    dateTo: "Tugash sanasi",
  },
  cyrl: {
    productCharacteristics: "Характеристики товара",
    productPhoto: "Фото товара",
    shippedProducts: "Юборилган махсулотлар",
    consignmentNote: "Юк хати",
    unreceivedProducts: "Қабул қилинмаган маҳсулотлар",
    sourceWarehouse: "Омбор",
    gotIt: "Тушунарли",
    hintSendOrderAfterCreate:
      "Буюртма мувофаққиятли яратилди. Бу тугма орқали буюртмани ОМТК булимига жунатинг.",
    serverErrorMessages: {
      UNSIGNED_ENTITY_NOT_FOUND: "Маҳсулот топилмади",
      CHANGE_WAREHOUSE: "Бу маҳсулот бу омборда мавжуд эмас",
      PRODUCT_NAME_AND_ATTRIBUTE_WITH_DUPLICATE: "Бундай номли маҳсулот мавжуд",
      PRODUCT_NAME_MAX_LENGTH: "Маҳсулот номи 600 та белгидан ошмаслиги керак",
      HAS_CARRIAGE: "Бу ерда каретка бор",
      CONTRACT_ITEM_CHANGE_STATUS: "Бу ҳолатдан бошқа ҳолатга ўтиб бўлмайди",
      PRODUCT_NOT_GIVEN_DEPARTMENT: "Эксплуатацияга чиқарилмаган",
      CONTRACT_NUMBER_BUSY: "Шартнома банд",
      USER_NOT_FOUND_WITH_USERNAME:
        "Ушбу фойдаланувчи номи билан фойдаланувчи топилмади",
      ORDER_INITIATOR_NOT_FOUND: "Буюртма бандида инициатор топилмади",
      ACCOUNTANT: "Моддий ҳисобчи",
      CHEIF_ACCOUNTANT: "Бош ҳисобчи",
      TIME_OF_DELIVERY: "Етказилган вақти",
      ACCOUNT_CODE: "Hisob kodi",
      INVENTORY_VALUE: "Товар Моддий Бойликлари номи",
      INVOICE_N: "Ҳисоб-Фактура №",
      CONTRACT_NUMBER: "Шартнома рақами",
      SUPPLIER_COMPANY_NAME: "Этказиб берувчи Корхона номи",
      RECIEVED_EMPLOYEE: "Қабул қилган ходим",
      ACCORDING_TO_DOCUMENT: "Ҳужжат бўйича",
      ACCEPTED: "Қабул қилинди",
      DEPARTURE_TIME: "Олиб кетилган вақти",
      NAME_OF_RECEIVED_COMPANY: "Қабул қилган Корхона номи",
      REPORT_ON_MATERIALS_IN_ASSORTMENT: "оралиғидаги Материаллар ҳисоботи",
      PRODUCT_REVENUE_STATEMENT: "оралиғидаги Маҳсулот кирим ҳисоботи",
      PRODUCT_EXPENSE_REPORT_IN_ASSORTMENT:
        "оралиғидаги Маҳсулот чиқим ҳисоботи",
      INITIAL_BALANCE: "Бошланғич қолдиқ",
      COMING: "Кирим",
      EXPENSE: "Чиқим",
      REMAINDER: "Якуний қолдиқ",
      QUANTITY: "Cони",
      TOTAL_COST: "Жами қиймати",
      TOTAL: "Жами:",
      PREPARED: "Тайёрлади:",
      AGREED: "Келишилди:",
      FINANCIALLY_RESPONSIBLE_PERSON: "Моддий жавобгар шахс",
      PRODUCTION_DIRECTOR: "Ишлаб чиқариш бўйича Директор",
      CHECKED: "Текширди:",
      WORK_SHOP_HEAD_OF_DEPARTMENT: "Цех/бўлим бошлиғи",
      FINANCIAL_DIRECTOR: "Молиявий директор",
      MATERIAL_TECHNICAL_CONTROL_DEPARTMENT: "Моддий-техник назорат бўлими",
      CHECK: "Ҳисоб",
      OFF_BALANCE_SHEET_REPORT: "Балансдан ташқари ҳисобот",
      DEP_WORKSHOP: "Отд/цех",
      KIPIA: "КИПиА",
      CODE: "Код",
      PRODUCT_NAME: "Махсулот номи",
      DATE_OF_ACCEPTANCE: "Кирим санаси",
      DATE_OF_DELIVERY: "чиқим санаси",
      UNIT: "ўлчов бирлик",
      PRICE: "Нархи",
      CHOOSE_THE_WAREHOUSE: "Омборхонани танланг",
      PRODUCE_HISTORY_IS_NULL: "Маҳсулот тарихи бўш",
      THE_AMOUNT_OF_PRODUCT_DELIVERED_IS_MORE:
        "Бериб юборилаётган маҳсулот миқдори инициатор сўраган миқдордан кўп",
      MUST_GIVE_AT_LEAST_ONE: "Камида 1 та беришингиз керак",
      ERROR_SAVING_FILE: "Файл сақлашда хатолик бор",
      ONLY_PDF_FILE_CAN_BE_COMPRESSED: "Фақат PDF файл ни компреслаш мумкин",
      OUT_OF_LIMIT: "Берилган миқдордан кўп",
      THIS_USER_HAS_NOT_PHONE_NUMBER: "Бу фойдаланувчининг телефон рақами йўқ",
      YOU_HAVE_NO_ACCESS_TO_RECOVER_YOUR_PASSWORD:
        "Паролингизни тиклашингиз учун сизда руҳсат йўқ",
      STILLAGE_IS_NULL: "Стеллаж йўқ",
      NO_DEPARTMENT_IN_WAREHOUSE: "Омборхона ҳеч бир бўлимга тегишли эмас",
      CAN_NOT_RETURN_DEPARTMENT:
        "Қайтариб бериш фақат омборхонага бўлиши мумкин",
      APPLICATION_NOT_FOUND: "Ариза топилмади",
      ACCOUNTANT_NOT_FOUND: "Бухгалтерия бўлимини белгиланг",
      ACCOUNTANT_TELEGRAM_GROUP_NOT_FOUND:
        "Бухгалтерия бўлимига телеграм гуруҳини бириктиринг",
      WAREHOUSE_REQUIRED: "Омборхонани танланг",
      AKT_FILE_REQUIRED: "Акт хужжат мажбурий",
      "0_OR_A_SMALL_VALUE_CAN_NOT_BE_ACCEPTED":
        "0 ёки ундан кичик қийматда қабул қилиш мумкин эмас",
      NO_PRODUCT_FOUND_BY_ID: "Маҳсулот ID топилмади",
      PRODUCT_ALREADY_TAKEN: "Маҳсулот аллақачон олинган",
      USER_HAS_NOT_PERMISSION_TO_GET_PRODUCT:
        "Фойдаланувчи ушбу буюртма учун маҳсулотни олишга ҳақли эмас",
      ORDER_ID_NOT_FOUND: "Буюртма ID топилмади",
      DATA_NOT_FOUND: "Маълумот топилмади",
      DEPARTMENT_OMTK_NOT_FOUND: "ОМТК бўлими топилмади",
      CHOOSE_THE_REQUEST_TYPE: "Сўров турини белгиланг",
      RECOVERING_PASSWORD_IS_FINISHED:
        "Паролни тиклаш тугалланди, қайта уриниб кўринг",
      REQUESTCOUNT_IS_REQUIRED: "Сўров сони киритилмаган",

      CHOOSE_DEPARTMENT_TYPE: "Бўлим типини киритинг",
      PRODUCT_ID_NOT_FOUND: "Махсулот id топилмади",
      AMONG_THE_SELECTED_PRODUCTS_TAKEN_OUT:
        "Танланганлар орасида омборхонадан чиқарилган махсулот бор. Махсулотларни қайта танланг",
      MORE_PRODUCTS_ARE_BEING_PROVIDED:
        "Заказда кўрсатилганидан кўпроқ маҳсулот бериляпти",
      IMPOSSIBLE_TO_TAKE_ON_THE_TWO_PARTIES_AT_ONCE:
        "Бир вақтнинг ўзида иккита тўпламни олиш мумкин эмас. Бирини олиш керак",
      GOODS_HAVE_NOT_BEEN_GIVEN_FOR_THIS_ORDER_PARTIES:
        "Ушбу буюртма ва партия учун товарлар етказиб берилмаган",
      ALREADY_TAKEN_AWAY_PRODUCTS_FOR_THIS_ORDER_PARTIES:
        "у заказ ва бу партия бўйича берилган махсулотлар олиб кетилган",
      TAKE_MORE_PRODUCTS_THAN_GIVEN:
        "Siz olingandan ko'ra ko'proq mahsulot berdingiz",
      USER_NOT_ATTACHED_TO_DEPARTMENT:
        "Ариза ёзган фойдаланувчи бўлимга бириктирилмаган",
      USER_NOT_ATTACHED_TO_WAREHOUSE:
        "Ариза ёзган фойдаланувчига обморхона бириктирилмаган",
      CONTRACT_IS_NOT_FOUND: "Контракт топилмади",
      CANNOT_ACCEPT_MORE_THAN_ONE_SHIPMENT:
        "Миқдордан ортиқ юк қабул қилолмайсиз",
      PRODUCT_TYPE_NOT_FOUND: "Махсулот тури топилмади",
      PRODUCT_GROUP_NOT_FOUND: "Махсулот гуруҳи топилмади",
      SERVLET_RESPONSE_FOR_GENERATE_QR_CODE_IS_NULL:
        "Генерация қилинган QR-CODE SERVLET RESPONSE БЎШ",
      MUST_ENTER_NAME: "Исмни киритиш шарт",
      CUSTOMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Бундай номли мижоз аллақачон рўйхатдан ўтган",
      CUSTOMER_NOT_FOUND: "Мижоз топилмади",
      PARENT_ID_FOR_CONTRACT_ITEM_NOT_FOUND:
        "Шартнома элементи учун ота-она идентификатори топилмади",
      THE_CARRIAGE_DOES_NOT_BELONG_ANY_STELLAGE:
        "Ушбу каретка ҳеч бир стиллажга тегишли эмас",
      STELLAGE_NOT_FOUND: "Стeллаж топилмади",
      REQUEST_IS_NULL: "Сўров мавжуд эмас",
      COLUMN_SETTINGS_IS_NULL: "Устун созламалари йўқ",
      ENTER_COLUMN_LABEL: "Таблица устуни номини киритинг",

      HAS_CONTRACT_ALREADY: "Бу ерда шартнома бор",
      HAS_ORDER_ALREADY: "Бу ерда буюртма бор",
      HAS_PRODUCT_ALREADY: "Бу ерда продукт бор",
      PRODUCT_IN_STOCK_ROT: "Омборда маҳсулот мавжуд. Ўчиролмайсиз",
      IDS_FIELD_REQUIRED: "ID null bolmasligi kerak",
      CARRIAGE_IS_NULL: "Катак бўш",
      CONTRACT_ITEM_PARTITION_ACCEPTED:
        "Шартнома банди партия бўйича қабул қилинган",
      CONTRACT_ITEM_PART_ACCEPT: "Шартнома банди қисман қабул қилинган",
      CONTRACT_ITEM_ACCEPT: "Шартнома банди қабул қилинган",
      CONTRACT_ITEM_REJECT: "Шартнома банди рад этилган",
      TELEGRAM_GROUP_REQUIRED: "Телеграм гуруҳни киритиш керак",
      TELEGRAM_GROUP_NOT_FOUND: "Телеграм гуруҳи топилмади",
      CONCLUTION_DATE_REQUIRED: "Шартнома тузилган сана киритилмаган",
      GUESS_RECEIVE_DATE_REQUIRED: "Тахминий келтирилиш вақти киритилмаган",
      PRODUCTS_DO_NOT_COME_IN_ONE_BATCH_CANNOT_ADDED:
        "Битта партияда келмаган маҳсулотларни қўшиб бўлмайди",
      SECOND_PRODUCT_WAS_NOT_FOUND: "Иккинчи маҳсулот топилмади",
      THERE_IS_NO_WAREHOUSE_IN_THIS_DEPARTMENT:
        "Бу бўлимда омборхона мавжуд эмас",
      PRODUCTS_REQUESTED_ORDER_NOT_THE_STATUS_PROVIDED:
        "Буюртма сўралган маҳсулотлар бериладиган статусда эмас",
      EXCEEDED_THE_QUANTITY_PRODUCT_ORDERED_ALONG_WITH_THE_QUANTITY_PRODUCT_PREVIOUSLY_REQUESTED:
        "Олдинроқ сўралган маҳсулот миқдорлари билан бирга заказ бўйича берилиши керак бўлган маҳсулот  миқдоридан ошиб кетди",
      more_than_quantity_product_ordered:
        "Заказ бўйича берилиши керак бўлган маҳсулот  миқдордан кўп сўраяпсиз",
      PRODUCT_WAREHOUSE_IS_NOT_ENOUGH: "Омборда маҳсулот етарли эмас",
      YOU_HAVE_NOT_ENTERED_PRODUCT_NUMBER:
        "Сиз маҳсулот рақамини киритмадингиз",
      ENTER_THE_QUERY_TYPE: "Сўров турини киритинг",
      MORE_REQUESTED_PRODUCT_QUANTITY_IS_INCLUDED_THE_ORDER:
        "Заказдаги сўралган маҳсулот миқдоридан кўп миқдор киритилган",
      CANNOT_DELETE_ITEM_BECAUSE_THE_ITEM_HAS_ALREADY_BEEN_USED:
        "Продуктлар фойдаланилгани учун лотни ўчиролмайсиз",
      PARTY_NOT_FOUND: "Партия топилмади",
      LOT_NOT_FOUND: "Лот топилмади",
      WANT_IMPORT_MORE_THAN_VOLUME_OF_PRODUCT_RECEIVED:
        "Қабул қилинган махсулот ҳажмидан кўпроқ олиб кирмоқчисиз",
      INVENTORY_COMPLETE_YOU_HAVE_START_OVER_AGAIN:
        "Ушбу инвентаризация тугатилган. Янгидан бошлашингиз лозим",
      INVENTORY_HAS_BEEN_STARTED_WAREHOUSE_YOU_CAN_CONTINUE:
        "Ушбу омборда инвентаризация бошланган. Давом эттиришингиз мумкин",
      REQUEST_NOT_FOUND: "Сўров топилмади",
      order_and_products_given_under_batch_were_taken_away:
        "Буюртма ва партия бўйича берилган маҳсулотлар олиб кетилган",
      UNIT_TYPE_NOT_MATCH: "Бирлик тури тўғри келмади",
      SMS_NOT_SEND: "Хабар жўнатилмади",
      CELLS_USED: "Ячейкани танланг",
      CELL_NOT_FOUND: "Ячейка топилмади",
      HAS_STELAGE: "Бу ерда стилаж бор",
      SELECT_THE_WAREHOUSE: "Омборхонани танланг",
      UNIQUE_KEY_DID_NOT_MATCH: "Ноёб калит тўғри келмади",
      TEAM_NOT_FOUND: "Жамоа топилмади",
      TEAM_NOT_REQUIRED: "Жамоа киритилмаган",
      TEAM_LEADER_NOT_FOUND: "Жамоа етакчиси топилмади",
      TEAM_LEADER_REQUIRED: "Жамоа етакчиси киритилмаган",
      HISTORY_OF_MEDICINE_TAKEN_REQUIRED:
        "Қабул қилинган дорилар тарихини киритмадингиз",
      HISTORY_OF_MEDICINE_TAKEN_NOT_FOUND:
        "Қабул қилинган дорилар тарихи топилмади",
      MEDICINE_NOT_FOUND: "Дори топилмади",
      MEDICINE_REQUIRED: "Дорини киритмадингиз",
      PATIENT_NOT_FOUND: "Бемор топилмади",
      PATIENT_REQUIRED: "Беморни киритмадингиз",
      PASSPORT_REQUIRED: "Пасспорт рақамини киритмадингиз",
      RENT_NOT_FOUND: "Ижарага бериш топилмади",
      RENT_REQUIRED: "Ижарага бериш танланмаган",
      EXPIRED_DATE_REQUIRED: "Амал қилиш муддати киритилмаган",
      ELIGIBLE_TO_RECEIVE_GOOD_FOR_THIS_ORDER:
        "Сиз ушбу буюртма учун маҳсулотни олишга хуқуқингиз йўқ",
      AMOUNT_ENTERED_MORE_THEN_AMOUNT_LEFT_IN_WAREHOUSE:
        "Киритилган маблағ омборда қолган миқдордан кўпроқ",
      PRODUCT_IS_NOT_ENOUGH_IN_WAREHOUSE: "Омборхонада етарли махсулот йўқ",
      CHECK_DATABASE: "Базани текширинг. Ушбу партия бўйича махсулот топилмади",
      USER_NOT_REGISTERED: "Бу фойдаланувчи регистрациядан ўтмаган",
      NUMBER_OF_ROWS_IS_NOT_ENOUGH: "Қаторлар сони етарли эмас",
      OLD_PASSWORD_INCORRECT: "Эски парол нотўғри",
      OLD_PASSWORD_REQUIRED: "Эски парол киритилмаган",
      RECOVER_YOUR_PASSWORD: "Паролингизни тиклаш учун сизда рухсат йўқ",
      CONFIRMATION_CODE_REQUIRED: "Тасдиқлаш коди киритилмаган",
      USER_REQUIRED: "Фойдаланувчи киритилмаган",
      PHONE_NUMBER_RIGHT_ENTER: "Телефон рақамингизни тўғри киритинг",
      PHONE_NUMBER_REQUIRED: "Телефон рақами киритилмаган",
      USERNAME_REQUIRED: "Фойдаланувчи номи киритилмаган",
      EMAIL_HAS_ALREADY: "Фойдаланувчи почтаси регистрациядан ўтган",
      PHONE_NUMBER_HAS_ALREADY:
        "Фойдаланувчи телефон рақами регистрациядан ўтган",
      USER_NAME_HAS_ALREADY: "Бу фойдаланувчи номи регистрациядан ўтган",
      HAS_NOT_ACCESS: "Сизда руҳсат йўқ",
      USER_NOT_FOUND: "Фойдаланувчи топилмади",
      UNIT_TYPE_DOES_NOT_MATCH: "Махсулот бирлиги тўғри келмади",
      SMS_DO_NOT_SEND: "Хабар юборилмаган",
      PERMISSION_NOT_FOUND: "Рухсатнома топилмади",
      ROLE_NOT_FOUND: "Рол топилмади",
      ORDER_ITEM_COUNT_COUNTABLE: "Берилаётган миқдор бутун булиши керак",
      PRODUCT_IS_NOT_ENOUGH: "Маҳсулот етарли эмас",
      PARTITION_NOT_FOUND: "Партия топилмади",
      ORDER_ITEM_AND_CONTRACT_ITEM_REQUIRED:
        "Буюртма ва контракт элементлари киритилмаган",
      PACKAGE_TYPE_NAME_CREATE_ALREADY:
        "Ушбу ном билан аллақачон маълумот яратилган",
      PACKAGE_TYPE_NOT_FOUND: "Пакет тури топилмади",
      PACKAGE_NOT_FOUND: "Пакет топилмади",
      COUNT_ENOUGHT: "Кўп миқдор киритдингиз",
      COUNT_REQUIRED: "Маҳсулот миқдори киритилмаган",
      OUTGOING_CONTRACT_NUMBER_BUSY: "Ушбу контракт рақам банд",
      PASSWORD_CHANGE_ACCESS: "Сизда паролни ўзгартириш учун рухсат йўқ",
      CONFIRMATION_CODE_IS_INCORRECT: "Тасдиқлаш коди нотўғри",
      ORDER_ITEM_REJECT_MUCH_COUNT:
        "Сўралган маҳсулотдан кўп маҳсулот бекор қилинди",
      OPPORTUNITY_NOT_MATCH_COUNT:
        "Киритилган миқдор шартномадаги миқдорга тўғри келмади",
      OPPORTUNITY_COUNT_REQUIRED: "Қийматлардан ҳеч бири киритилмаган",
      ORDER_ITEM_REQUIRED: "Буюртма элементлари киритилмаган",
      UNITTYPE_REQUIRED: "Товар бирлиги киритилмаган",
      PRODUCT_NOT_FOUND: "Маҳсулот топилмади",
      PRODUCT_REQUIRED: "Товар киритилмаган",
      INVENTARIZATION_REQUIRED: "Инвентаризация бошланмаган",
      INVENTARIZATION_NOT_FOUND: "Инвентаризация топилмади",
      GIVEN_PRODUCT_TAKEN_AWAY:
        "Бу заказ ва партия бўйича берилган махсулотлар олиб кетилган",
      GIVEN_PRODUCT_NOT_FOUND:
        "Ушбу буюртма ва партиялар учун товарлар берилмаган",
      PRODUCT_ALREADY_TAKEN_AWAY: "Маҳсулот аллақачон олиб кетилган",
      MORE_PRODUCTS_DELIVERED_THAN_SPECIFIED_ORDER:
        "Буюртмада кўрсатилгандан кўпрок махсулот бериляпти",
      USER_AGREEMENT_REQUIRED: "Фойдаланувчи шартномасини киритилмаган",
      WAREHOUSE_NOT_FOUND: "Омбор топилмади",
      WAREHOUSE_IS_REQUIRED: "Омбор танланмаган",
      DEPARTMENT_REQUIRED: "Бўлим танланмаган",
      DEPARTMENT_HAS_USERS_NOT_DELETE:
        "Бу бўлимни ўчириб бўлмайди, чунки бу бўлимда фойдаланувчилар бор",
      ACTION_ALREADY_DONE: "Бу амални бажариб бўлгансиз",
      REJECT_REASON_REQUIRED: "Бекор қилиш учун сабаб кўрсатинг",
      SUPPLIER_TYPE_REQUIRED: "Етказиб берувчининг тури танланмаган",
      UNITTYPE_NOT_FOUND_IN_CONTRACT: "Шартномада ўлчов бирлиги кўрсатилмаган",
      PRODUCT_NOT_FOUND_IN_CONTRACT: "Шартномада махсулот топилмади",
      CONTRACT_ITEM_COUNT_LARGE:
        "Шартномада кўрсатилган миқдордан кўп миқдор киритилган",
      DESCRIPTION_REQUIRED: "Изох киритилмаган",
      COLUMN_SETTINGS_NOT_FOUND: "Созламалар топилмади",
      TABLE_NOT_SELECTED: "Жадвал танланмаган",
      PRODUCT_DID_NOT_TO_MATCH: "Маҳсулот тўғри келмади",
      CARRIAGE_NOT_FOUND: "Каретка топилмади",
      CARRIAGE_IS_REQUIRED: "Каретка танланмаган",
      ORDER_COUNT_NOT_ENOUGH: "Буюртма сони етарли эмас",
      PRODUCT_ITEM_COUNT_NOT_ENOUGH: "Махсулот сони етарли эмас",
      PRODUCT_ITEM_REQUIRED: "Махсулот танланмаган" + "",
      PRODUCT_ITEM_NOT_FOUND: "Омборда маҳсулот топилмади",
      CONTRACT_REQUIRED: "Шартнома киритилмаган",
      CONTRACT_NOT_FOUND: "Шартнома топилмади",
      PARTION_NOT_FOUND: "Маҳсулот партияси топилмади",
      PRODUCT_TAKEN_FROM_WAREHOUSE: "Маҳсулот омбордан олинган",
      PRODUCTS_IS_REQUIRED: "Маҳсулотлар танланмаган",
      ATTRIBUTE_NOT_FOUND: "Хусусият топилмади",
      FILE_NOT_FOUND: "Файл топилмади",
      USERNAME_OR_PASSWORD_OR_BLOCK_ACCOUNT:
        "Фойдаланувчи номи ёки парол нотўғри ёки фойдаланувчи ушбу тизимда фаол эмас",
      USERNAME_OR_PASSWORD_WRONG: "Фойдаланувчи номи ёки пароль нотоғри",
      PRODUCT_COUNT_NOT_DOT_MATCH: "Маҳсулот сони тўғри келмади",
      OUTGOING_CONTRACT_COUNT_NOT_DOT_MATCH:
        "Шартномада кўрсатилган миқдордан кўп миқдор киритдингиз",
      TO_REVIEW_WAREHOUSE: "ОМТК томонидан кўриб чиқиляпти",
      PRODUCT_RECEIVED: "Маҳсулот қабул қилинди",
      ENTER_POSITIVE_VALUE: "Мусбат қиймат киритинг",
      ORDER_BUSY: "Буюртма банд",
      formatFileNotSupported:
        "Файлни формати туғри келмайди. Илтимос бошқа файл юкланг",
      NAME_ALREADY_EXISTS: CyrlValidationMessages.messages.exist
        .replace("{_title_}", "ном")
        .replace("{_field_}", "аттрибут"),
      CONTRACT_DECISION_HAS_ALREADY_BEEN_MADE:
        "Шартнома буйича қарор аллақачон қабул қилинган",
      HASH_CODE_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Hash code"
      ),
      DOCUMENT_PARAMS_REQUIRED:
        CyrlValidationMessages.messages.required.replace(
          "{_field_}",
          "Хужжат параметрлари"
        ),
      ACTION_TYPE_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Вазифа тури"
      ),
      CONTRACT_ITEM_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Шартнома банди"
      ),
      BAD_CREDENTIALS: "Логин ёки парол нотўғри киритилган",
      SUPPLIERTYPE_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Етказиб берувчи тури"
      ),
      SUPPLIER_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Етказиб берувчи"
      ),
      CONFIRMATION_CODE_IS_EXPIRED: "Тасдиқлаш коди хато киритилган",
      GIVEN_OLD_PASSWORD_INCORRECT: "Эски парол нотўғри киритилган",
      USERNAME_NOT_FOUND: "Фойдаланувчи топилмади",
      NAME_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Номи"
      ),
      UNITTYPE_NOT_FOUND: "Ўлчов бирлиги топилмади",
      BLOCK_ACCOUNT: "Профилингиз блокланган",
      BAD_REQUEST: "Форма майдонлари нотўғри киритилган",
      NOT_FOUND: "Топилмади",
      UNAUTHORIZED: "Токен эскирган",
      FILE_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Файл"
      ),
      ERROR_WHILE_SAVING_FILE: "Файлни сақлашда хатолик",
      SUPPLIER_NOT_FOUND: "Таъминотчи топилмади",
      NOT_ENOUGH_INFORMATION: "Маълумотлар етарли эмас",
      CONTRACT_ITEM_NOT_FOUND: "Шартнома берилмади",
      INITIATOR_NOT_FOUND: "Буюртмачи топилмади",
      MUST_ENTER_INITIATOR: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Буюртмачи"
      ),
      CONTRACT_ITEM_ID_IS_NULL:
        CyrlValidationMessages.messages.required.replace(
          "{_field_}",
          "Шартнома Id"
        ),
      CUSTUMER_WITH_SAME_NAME_IS_ALREADY_REGISTERED:
        "Шу номли буюртмачи аллақачон рўйҳатдан ўтқазилган",
      DEPARTMENT_NOT_FOUND: "Бўлинма топилмади",
      ID_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "id"
      ),
      ORDER_ITEM_ID_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Буюртма id"
      ),
      ORDER_ITEM_NOT_FOUND: "Буюртма топилмади",
      ORDER_ITEMS_REQUIRED: "Буюртмалар майдони тўлдирилиши шарт",
      ORDER_NOT_FOUND: "Буюртма топилмади",
      ERROR_SENDING_OTP_CODE: "OTP CODE жўнатишда хатолик юз берди",
      REQUESTCOUNT_AND_GIVENCOUNT_IS_REQUIRED:
        "Сўралган ва берилган маҳсулот сони майдонлари тўлдирилиши шарт",
      CONTRACT_NUMBER_REQUIRED:
        CyrlValidationMessages.messages.required.replace(
          "{_field_}",
          "Шартнома рақами"
        ),
      OUTGOING_CONTRACT_NOT_FOUND: "чиқувчи шартнома топилмади",
      REALIZATOR_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Амалга оширувчи"
      ),
      REALIZATOR_NOT_FOUND: "Амалга оширувчи топилмади",
      USER_AGREEMENT_NOT_FOUND: "USER_AGREEMENT_NOT_FOUND",
      NEW_PASSWORD_REQUIRED: CyrlValidationMessages.messages.required.replace(
        "{_field_}",
        "Янги парол"
      ),
      ENTER_TIME_FORMAT_CORRECTLY: "Вақт форматини туғри киритинг",
    },
    accountingCode: "Маҳсулот рақами",
    accepted: "Қабул қилинган",
    uploadPhoto: "Расм юкланг",
    enterText: "Матн киритинг",
    find: "Топиш",
    start: "Бошлаш",
    warnings: "Огоҳлантиришлар",
    productIssued: "Маҳсулот бериб юборилди",
    givenProduct: "Бериб юборилган",
    downloadProductList: "Маҳсулотлар рўйхатини юклаб олиш",
    carriageAddress: "Каретка манзили",
    stillageAddress: "Стеллеж манзили",
    viewFile: "Файлни кўриш",
    productReport: "Маҳсулотлар рўйхати",
    productIsNotPlace: "Маҳсулот жойлаштирилмаган",
    numNotEnough: "Маҳсулот сони етарли эмас",
    quantityInExcess: "Маҳсулот сони етарли эмас",
    givenProductQuantity: "Бериб юбориладиган маҳсулотлар сони",
    addWithFile: "Файл билан маҳсулот қўшиш",
    allCarriagesEmpty: "Ҳамма катаклар бўш",
    halfEmpty: "Катак бўш эмас",
    carriagesFull: "Катак тўла",
    warehouseIndicators:
      "Стеллажнинг ўнг томонидаги кўрсаткичлар қуйидагиларни англатади:",
    hint: "Эслатма",
    rightClickingMouse:
      "Маҳсулотни жойлаштириш учун керакли катакни сичқончани ўнг томонини босиш орқали танланг",
    viewContractDetails: "Шартномани батафсил кўриш",
    admissionConfirmation: "Қабул қилишни тасдиқлаш",
    productAcceptance: "Маҳсулотни қабул қилиш",
    agreementStatus: {
      ORDER_ITEM_PRODUCE: "Қабул қилинди",
      USER_AGREEMENT_ACCEPTED: "Қабул қилинди",
      USER_AGREEMENT_REJECTED: "Бекор қилинди",
    },
    noApprovedContracts: "Тасдиқланиши зарур бўлган шартномалар йўқ",
    confirmWithKey: "Калит билан тасдиқлаш",
    accountCode: "Ҳисоб коди",
    placedBy: "Ким томонидан",
    deliveredDate: "Омборга келиш санаси",
    takenAwayDate: "Топшириш санаси",
    aboutProduct: "Маҳсулот ҳақида",
    existingInv: "Бу товар инвентаризация қилинган",
    inventarizationStopped: "{warehouse} омборида инвентаризация тўхтади",
    continueInventarization: "Инвентаризацияни давом эттириш",
    finishInventarization: "Инвентаризацияни тугатиш",
    receive: "Қабул қилиш",
    toWriteOff: "Ҳисобдан чиқариш",
    naming: "Номланиши",
    designation: "Номи",
    row: "Қатор",
    hiddenWarehouses: "Яширин омборлар",
    supportService: "Қўллаб-қувватлаш хизмати",
    divisionType: "Бўлим тури",
    toCancel: "Бекор қилиш",
    chooseAnotherStatus: "Бошқа ҳолатни танланг",
    selectWarehouse: "Омборни танланг",
    datePlaceholder: "кун/ой/йил",
    downloadTemplateFile: "Маҳсулотларни киритиш учун шаблон файлни юклаб олиш",
    organizationName: "Ташкилот номи",
    weekShortTitle: {
      0: "Якш",
      1: "Душ",
      2: "Сеш",
      3: "Чор",
      4: "Пай",
      5: "Жум",
      6: "Шан",
    },
    weekShort: {
      0: "Я",
      1: "Д",
      2: "С",
      3: "Ч",
      4: "П",
      5: "Ж",
      6: "Ш",
    },
    monthsNames: {
      0: "Январ",
      1: "Феврал",
      2: "Март",
      3: "Апрел",
      4: "Май",
      5: "Июн",
      6: "Июл",
      7: "Август",
      8: "Сентябр",
      9: "Октябр",
      10: "Ноябр",
      11: "Декабр",
    },
    monthsNamesShort: {
      0: "Янв",
      1: "Фев",
      2: "Мар",
      3: "Апр",
      4: "Май",
      5: "Июн",
      6: "Июл",
      7: "Авг",
      8: "Сен",
      9: "Окт",
      10: "Ноя",
      11: "Дек",
    },
    startInventarization: "Инвентаризацияни бошлаш",
    inventarization: "Инвентаризация",
    wantToDistribute: "{count} маҳсулотни тарқатишни хоҳлайсизми?",
    enterQuantity: "Миқдорни киритинг",
    distribution: "Тарқатиш",
    orderQuantity: "Сўров бўйича буюртмалар миқдори",
    totalOrders: "Буюртмаларнинг умумий сони",
    productDelivery: "Маҳсулот бериш",
    place: "Жой",
    spaceLeft: "Маҳсулот жойлангандан сўнг яна жой қолдими?",
    confirmPlacement: "Маҳсулотни шу ерга жойлаганингизни тасдиқланг",
    putProduct: "Ростдан ҳам шу ерга жойладим",
    placeInFreeSpace: "Бўш жойга жойлаштириш",
    placedDate: "Жойланган сана",
    invDate: "Инв санаси",
    whoPosted: "Ким жойлади",
    quantity: "Миқдори",
    placedProducts: "Жойлаштирилган маҳсулотлар",
    placeHere: "Шу ерга жойлаш",
    selectPlacement: "Жойлаштириш учун майдон танланг",
    tmtPlacement: "Маҳсулотни жойлаш",
    determinePlacement: "Жойни аниқлаб жойлаштириш" + "",
    existingQr: "Бу QR юкланган",
    addQrCode: "QR код қўшиш",
    showDetails: "Деталларни кўрсатиш",
    enterQrCode: "QR кодни киритинг",
    scan: "Сканерлаш",
    pressToScan: "QR кодни сканерлаш учун тугмани босинг",
    placement: "Жойлаштириш",
    leftToCapitalize: "Кирим қилинмаганлар сони",
    palletsNumber: "Паллетлар сони",
    invoiceNumber: "Ҳисоб-фактура рақами",
    invoiceDate: "Ҳисоб-фактура санаси",
    actNumber: "Акт рақами",
    gtd: "ГТД",
    manufactureDate: "Ишлаб чиқарилган сана",
    dataOfReceipt: "Кирим санаси",
    numberOfPackages: "Приходлар сони",
    createIncome: "Киримни яратиш",
    createLots: "Лотлар яратиш",
    contractDivisionStatus: {
      /**
       * * Contract item status
       * */
      ACCEPTED: "қабул қилинган",
      REJECTED: "Бекор қилинган",
      PART_ACCEPTED: "Қисман қабул қилинган",
      WAITING: "Менинг қарорим кутилмоқда",
    },
    thinkDefective:
      "Ҳақиқатан ҳам {count} {unit_type} маҳсулотни нуқсонли деб ҳисоблайсизми?",
    rejectedCount: "Рад этилганлар сони",
    defectiveGoodsNumber: "Товар нуқсонли товарлар сонини киритинг",
    enterAmount: "Товар қабул қиладиган миқдорни киритинг",
    leaveComment: "Изоҳ қолдиринг",
    attachPhotosAndComment: "Изоҳ ва расм қолдиринг",
    matched: "Мос келди",
    partialAdmission: "Қисман қабул қилиш",
    notCompatible: "Мос келмади",
    partyReception: "Партияни қабул қилиш",
    wantToAdd: "Ростдан ҳам қўшишни хоҳлайсизми?",
    wantToChange: "Ростдан ҳам ўзгартиришни хоҳлайсизми?",
    contractOmtkStatus: {
      /**
       * * Contract item status
       * */
      CONTRACT_ITEM_ACCEPTED: "Қабул қилинган",
      CONTRACT_ITEM_REJECT: "Бекор қилинган",
      CONTRACT_ITEM_PART_ACCEPTED: "Қисман қабул қилинган",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Партия бўйича қисман қабул қилинган",
      NEW: "Янги",
    },
    addAnotherRecipient: "Бошқа қабул қилувчини қўшиш",
    sendPushNotification: "push-хабарнома жўнатиш",
    changeEmployee: "Ходимни ўзгартириш",
    chooseInitiator: "Ташаббускорни танлаш",
    selectSection: "Бўлимни танланг",
    changeInitiator: "Ушбу ходимни бошқасига алмаштиришни истайсизми?",
    confirmWithEimzo: "Е-имзо билан тасдиқланг",
    selectKey: "Калитни танланг",
    eimzo: {
      valid: "Действителен",
      certificateNumber: "№ сертификата",
      certificate: "Сертификат",
      stir: "СТИР",
      fullName: "Ф.И.Ш.",
      organization: "Ташкилот",
      expiryDate: "Сертификатни амал қилиш муддати",
      pnfl: "JSHSHIR",
    },
    selectAll: "Ҳаммасини танлаш",
    acceptedInitiatorCount: "Қабул қилган буюртмачилар сони",
    partiallyAccepted: "Қисман қабул қилинган",
    exampleExcel: "Маҳсулотларни импорт қилиш учун мисол файлни кучириб олиш",
    showDuplicates: "Бир хил маҳсулотларни кўрсатиш",
    duplicateProducts: "Бир хил маҳсулотлар",
    basicToolReports: "Асосий воситалар ҳисоботи",
    basicToolReportsTitle: "Асосий материаллар бўйича ҳисобот олиш",
    numberOfDelinquencies: "Кечикишлар сони",
    oldQr: "Биринчи QR",
    newQr: "Янги QR",
    moveCount: "Кўчириладиган маҳсулот сони",
    Id: "Id",
    moveQr: "Янги QR яратиш",
    moveQrToExist: "Мавжуд QRга ўтказиш",
    moveProduct: "Маҳсулотни кўчириш",
    moveProductConfirmDesc:
      "Сиз ростдан хам бу маҳсулотни кўчиришни хоҳлайсизми?",
    moveToWarehouse: "Омборхонога қайтариб бериш",
    existQr: "Мавжуд QR",
    splitQr: "QRни бўлиш",
    materialsThatEnd: "Тугаётган маҳсулотлар",
    analytics: "Таҳлил",
    frequentlyGoodsMaterials: "Кўп ишлатиладиган маҳсулотлар",
    yearShort: "{0} й.",
    delaysReport: "Кечиктирган таъминотчилар",
    invalidProductReport: "Яроксиз маҳсулотлар ҳисоботи",
    latencyRequests: "Кечикган буюртмалар",
    expirationGoodsMaterials: "Муддати ўтган маҳсулотлар ҳисоботи",
    developedBy: "{0}да ишлаб чиқилган",
    expired: "Муддати ўтган",
    contractInitiator: "Шартнома яратувчи шахс",
    pageCount: "Саҳифа рақами",
    uploadFile: "Файлни юклаш",
    authorization: "Авторизация",
    weight: "Вазни/сони",
    reload: "Янгилаш",
    reindexAll: "Барчасини қайта индекслаш",
    reindex: "Қайта индекслаш",
    dateAcceptance: "Қабул қилинган вақти",
    wantToContinue: "Давом эттиришни хохлайсизми?",
    loading: "Юкланмоқда...",
    updatedByUser: "Ўзгартирган фойдаланувчи",
    changed: "Ўзгартирилган",
    price: "Нархи",
    gaveUser: "Ким берган",
    allProduct: "Барча маҳсулотлар",
    qrCode: "QR-код",
    msdsFile: "MSDS файл",
    print: "Чоп этиш",
    printQrCode: "QR чоп этиш | QR чоп этиш",
    ourProducts: "Бизнинг маҳсулотлар",
    writeOff: "Чиқариш",
    writeOffProduct: "Маҳсулотни чиқариш",
    file: "Файл",
    reference: "Маълумотлар",
    writeOffed: "Чиқарилган",
    ozl: "ОЗЛ",
    login: "Логин",
    password: "Пароль",
    ourOrders: "Бизнинг буюртмаларимиз",
    create: "Яратиш",
    createNewRequest: "Янги буюртма яратиш",
    or: "ёки",
    orderNotAddYet:
      "Буюртмалар яратилмаган. Яратиш учун қўшиш тугмасини босинг",
    addOrderItemToRequest: "Буюртмага маҳсулот қўшиш",
    sortable: "Тартибланадиган",
    minWidth: "Мин. кенглик",
    orderRequestItemNumber: "Буюртма маҳсулот рақами",
    limitProductCount: "Минимал маҳсулот сони",
    productCategory: "Маҳсулот категорияси",
    timeToBeEntered: "Яратилган вақти",
    pendingPurchaseDate: "Ҳужжатлар қабул қилинган вақти",
    updatedDate: "Ўзгартирилган сана",
    itemConclusionDate: "Оҳирги ўзгариш вақти",
    count: "Сони",
    countShort: "Сони",
    countQr: "qr сони",
    unit: "Ўлчов бирлиги",
    from: "дан",
    downloadFile: "Кўчириб олиш",
    downLoadFileContract: "Шартнома файлини кўчириб олиш",
    historyContractCode: "{code} шартноманинг тарихи",
    fileRequest: "№{numb} буюртма учун файл",
    error: "Хато",
    inventoryTime: "Инвентаризация вақти",
    writeOffTime: "Ҳисобдан чиқариш вақти",
    writeOffByUser: "Ким томонидан чиқарилган",
    numberOfValidProducts: "Number of valid products",
    numberOfInvalidProducts: "Number of invalid products",
    inventory: "Инвентаризация",
    envNumber: "ENV рақам",
    errorHasOccurred: "Хатолик юз берди",
    prev: "Орқага",
    productName: "Маҳсулот номи",
    whoImplemented: "Ким амалга оширди",
    sendDepartmentName: "Маҳсулот келган бўлим номи",
    send: "Юбориш",
    typeProduct: "Маҳсулот Тури",
    receiverDate: "Етказиб берилган сана",
    date: "Сана",
    extraOptions: "Қўшимча имкониятлар",
    extra: "Қўшимча",
    more: "Баътафсил",
    sendDate: "Буюртма жўнатилган вақти",
    placeProductIn: "Маҳсулотни {warehouse}га жойлаштириш",
    type: "Тури",
    status: "Ҳолати",
    noDataAvailable: "Маълумотлар йўқ",
    prevStatus: "Аввалги ҳолати",
    currentStatus: "Ҳозирги ҳолати",
    nameOfSupplier: "Таъминотчи номи",
    nameOfCustomer: "Буюртмачи номи",
    warehouse: "Омборхона",
    createWarehouse: "Яратиш омборхона",
    product: "Маҳсулот",
    filter: "Фильтр",
    columns: "Устунлар",
    attachFile: "Файл қўшиш",
    deliveryDate: "Етказиб бериш вақти",
    orderSent: "Буюртма юборилди",
    sendAgain: "Қайта юбориш",
    productGroup: "Маҳсулот гуруҳи",
    reportInventory: "Инвентаризация ҳисоботи",
    writeOffFromThem: "Чиқарилганлар сони",
    edit: "Ўзгартириш",
    delete: "Ўчириш",
    cancel: "Орқага",
    save: "Сақлаш",
    add: "Қўшиш",
    searchForName: "Номи бўйича излаш",
    orderItemByDepartment: "Буюртма маҳсулотлари бўлимлар бўйича",
    searchForNumber: "Рақами бўйича излаш",
    productCreate: "Маҳсулот яратиш",
    productEdit: "Маҳсулотни Ўзгартириш",
    editCategory: "Категорияни Ўзгартириш",
    byCategory: "Буюртмалар маҳсулот категорияси буйича",
    byOrderItemStatus: "Буюртма холати буйича",
    byTime: "Буюртмалар сони вақт буйича",
    category: "Категория",
    nameOfGroup: "Гуруҳ номи",
    name: "Номи",
    group: "Гуруҳ",
    description: "Маълумот",
    notIncomeSmsHint: "смс келмаган бўлса қайта уриниб кўринг!",
    stillageStatus: {
      full: "Бўш жой йўқ",
      empty: "Бўш",
      hasSpace: "Бўш жой бор",
    },
    warehouseFieldType: {
      corridor: "Йўлак",
      stillage: "Стеллаж",
      field: "Бўш жой",
      carriage: "Каретка",
    },
    action: "Вазифалар",
    typeProducts: "Маҳсулот тури",
    realization: "Амалга ошириш",
    inventoried: "Киритилган",
    day: "Кун",
    month: "Ой",
    year: "Йил",
    allTime: "Хамма вақт",
    groupProducts: "Маҳсулот гуруҳи",
    whoProduced: "Ким ўтқизган",
    finishOrder: "Буюртмани тугатиш",
    contractCompleteDate: "Шартноманинг ёпилиш санаси",
    nContract: "Шартнома №",
    groups: "Гуруҳлар",
    requests: "Буюртмалар",
    clear: "Тозалаш",
    itIsEmpty: "Бўм-бўш",
    addProduct: "Маҳсулот қўшиш",
    hasProductInWereHouse: "Маҳсулот бор",
    implementator: "Амалга оширувчи",
    clearFilter: "Филтрни тозалаш",
    expiration: "Амал қилиш муддати(кун)",
    notEnoughProduct: "Сони етарли эмас",
    implementDate: "Амалга ошириш вақти",
    noProduct: "Маҳсулот йўқ",
    noPlacementProduct: "Жойлаштирилган маҳсулот йўқ",
    enterValue: "Қийматини киритинг",
    addAttribute: "Аттрибут қўшиш",
    material: "Материал",
    nameAttribute: "Аттрибут номи",
    reportWriteOff: "Чиқарилган маҳсулотлар ҳисоботи",
    value: "Қиймати",
    attributes: "Атрибутлар",
    used: "Ишлатилган",
    attributeProduct: "Маҳсулот аттрибути",
    done: "Сақлаш",
    ourRequest: "Буюртмаларимиз",
    requestNumber: "Буюртма рақами",
    requestNumberN: "Буюртма рақами {number}",
    numberPositionInContract: "Шартнома маҳсулот рақами",
    newVersionFoundHint: "Янги версия топилди. Янгилашни истайсизми?",
    occupancyPercent: "Бандлик даражаси",
    occupiedPlacePercent: "{percent}% joy band",
    subdivision: "Бўлинма",
    initiator: "Буюртмачи",
    categoryTMC: "Категория Товар",
    documents: "Файллар",
    typeTMC: "Товар тури",
    contractNumber: "Шартнома рақами",
    contractDocuments: "Шартнома Ҳужжатлари",
    number: "Рақам",
    requestStatus: "Буюртма ҳолати",
    requestPositionStatus: "Буюртма жойлашган ҳолати",
    viewHistory: "Тарихини кўриш",
    packageCount: "Qr сони",
    userName: "Фойдаланувчи номи",
    assumptionSendDate: "Таҳминий либ келениш санаси",
    importFromExcel: "Excel файлдан импорт қилиш",
    guessReceiveDate: "Таҳминий олиб келиниш санаси",
    phone: "Телефон рақам",
    firstName: "Исм",
    changePassword: "Паролни узгартириш",
    viewContractHistory: "Шартнома тарихини кўриш",
    doYouWantGoBack: "Сиз ростдан хам шу тарихга қайтмойчисиз?",
    lastName: "Отасининг исми",
    email: "Почта",
    middleName: "Фамилия",
    forgetPassword: "Парольни унутдингизми?",
    passwordChanged: "Парол узгартирилди",
    logOut: "Чиқиш",
    enterToSystem: "Системага кириш",
    notification: "Билдиришнома",
    next: "Кейингиси",
    confirmPassword: "Паролни такрорлаш",
    limit: "Лимит",
    filled: "Сўм",
    income: "Маҳсулот киритиш",
    incomeReport: "Маҳсулот киритиш ҳисоботи",
    movedToWarehouseAndInProgress:
      "Бошқа омборхонага кўчирилган ва тасдиқланиши кутиляпти",
    reportIncome: "Кирим ҳисоботи",
    reportExpense: "Харажатлар ҳисоботи",
    show: "Кўрсатиш",
    department: "Бўлим",
    departmentIdAlert:
      "Тизимдан фойдаланиш учун сизда департмент бўлиши керак. Админга мурожаат қилишингизни сўраймиз!",
    successfullySaved: "Муваффақиятли сақланди",
    addedNewOrder: "Янги буюртма қўшилди",
    addedNewContract: "Янги шартнома қўшилди",
    enable: "Ёқилган",
    updatedSuccessfully: "Мувофаққиятли ўзгартирилди!",
    successfullyAccepted: "Мувофаққиятли қабул қилинди",
    successfullyRejected: "Мувофаққиятли рад қилинди",
    newPassword: "Янги парол",
    oldPassword: "Эски парол",
    oldWarehouse: "Эски омборхона",
    successfullyDeleted: "Мувофаққиятли ўчирилди",
    title: "Сарлавҳа",
    orderHistoryNumb: "{numb} буюртма тарихи",
    successfullySent: "Мувофаққиятли юборилди",
    deleteDepartmentHint:
      "Агар бу бўлимни ўчириб юборсангиз, ўшбу бўлимга тегишли барча фойдаланувчилар ҳам ўчиб кетади!!! ",
    receptionDate: "Кабул килиш вактини киритинг",
    typeDelivery: "Етказиб бериш тури",
    contractDate: "Шартнома тузилган вақти",
    estimatedDeliveryDate: "Таҳминий келтирилиш вақти",
    sendNotificationToOMTK: "ОМТК ага хабар жўнатиш",
    sendNotification: "Хабар жўнатиш",
    sendNotificationToAccounting: "Бухгалтерия га хабар жунатиш",
    toOMTK: "ОМТК га",
    toAccounting: "Бухгалтерия га",
    accountant: "Бухгалтерия",
    contractHistory: "Шартномалар тарихи | Шартнома рақами тарихи",
    orderHistory: "Буюртмалар тарихи | Буюртма рақами тарихи",
    productHistory: "Маҳсулот тарихи",
    provider: "Таъминотчи",
    users: "Фойдаланувчилар",
    dateWriteOff: "Чиқарилган сана",
    doYouWantReject: "{count} маҳсулотни бекор килмокчимисиз?",
    outGoingContracts: "Чиқувчи шартномалар",
    listOfVisits: "Ташрифлар руйхати",
    whoChangeStatus: "Буюртма ҳолатини ким текширган",
    statusChangedUser: "Буюртма ҳолатини ким текширган",
    positionStatus: "Буюртма ҳолати",
    allAttributes: "Барча сифатлар",
    attributeSearch: "Сифатларни қидириш",
    valueSearch: "Қиймат қидириш",
    roles: "Лавозимлар",
    additionalRole: "Қўшимча лавозим",
    permissions: "Рухсатномалар",
    internal: "Ички",
    import: "Ташқи",
    categories: "Категориялар",
    added: "Қўшилди",
    productNumber: "Маҳсулот рақами",
    lotName: "Лот номи",
    searchByName: "Номи бўйича қидириш",
    requestSubmissionDate: "Топшириладиган сана",
    //status
    createContract: "Шартнома яратиш",
    filterBySupplier: "Етказиб берувчи бўйича излаш",
    filterByInitiator: "Буюртмачи бўйича излаш",
    profile: "Профиль",
    all: "Ҳаммаси",
    addToContract: "Шартнома қўшиш",
    settings: "Созлаш",
    tableName: "Жадвал номи",
    columnLabel: "Устун номи",
    columnValue: "Қиймат номи",
    reject: "Бекор қилиш",
    nameOfProduct: "Маҳсулот номи",
    measure: "Ўлчов белгиси",
    measureShort: "Ўлчов белгиси",
    terminate: "Тўхтатиш",
    contractTerminated: "Шартномани бекор қилиш",
    signed: "Имзоланган",
    addMoreProductToRequest:
      "Бу маҳсулот буюртмага аллақачон қўшилган яна қўшинг",
    products: "Маҳсулотлар",
    omtk: "ОМТК",
    tender: "ОЗЛга юбориш",
    groupOfProduct: "Маҳсулот гуруҳи",
    dateWhenYouNeedToPutEverything: "Маҳсулотларни тўлиқ жойлаштириш вақти",
    hide: "Беркитиш",
    remainingContract: "Шартнома бўйича қолдиқ",
    remains: "Колди",
    implemented: "Амалга оширилган",
    willBeAddedToNewRequest: "{0}си янги буюртмага қушилади",
    dateOfConclusionContract: "Шартнома тузилган сана",
    new: "New",
    enterDate: "Санани киритинг",
    customer: "Мижоз",
    rejectRequest: "Буюртмани бекор қилиш",
    addPosition: "Қўшиш",
    expenses: "Харажатлар",
    //status
    NOT_ACCEPTED_ORDER: "Қаноатлантирилмаган",
    RECEIVED: "Олиб кетилган",
    DELETED: "Ўчирилган",
    [orderItemStatus["ISSUED_ORDER_ITEM"]]: "Маҳсулот етиб келган",
    [orderItemStatus["OZL_TO_DEPARTMENT"]]: "Ўзгартирилиши кутиляпти",
    [orderItemStatus["DELIVERY_EXPECTED"]]: "Шартнома тузилган",
    [orderItemStatus.YES_PRODUCT]: "Бериб юборишга тайёр",
    [orderItemStatus["READY_TO_PRODUCE"]]: "Маҳсулот бериб юборилган",
    [orderItemStatus["COMPLETED"]]: "Тугатилган",
    ACCEPTED_ORDER: "Қаноатлантирилган",
    TO_REVIEW_WAREHOUSE: "ОМТК томонидан кўриб чиқиляпти",
    NO_PRODUCT: "Товар омборхонада йўқ",
    [orderItemStatus.YES_PRODUCT]: "Товар омборхонада",
    REJECT_ORDER_ITEM: "Буюртма ОМТК томонидан бекор қилинган",
    PAPER_EXPECTED_SPECIFICATION: "Буюртма ҳужжатлари кутиляпти",
    PENDING_PURCHASE: "Сотиб олиниши кутилмоқда",
    PRODUCT_DELIVERED: "Буюртма етказилди",
    APPLICATION_REJECTED_OZL: "Буюртма ОЗЛ томонидан бекор қилинган",
    CONTRACT_CONCLUTION: "Шартнома тузилган",
    CONTRACT_TERMINATED: "Шартнома бузилган",
    NEW: "Янги",
    to: "гача",
    parentNameCategories: "Ота-онанинг исм тоифалари",
    resentHint: "Бироздан кейин қайта юборишингиз мумкин",
    columnName: "Устун номи жадвалда",
    parent: "Отаси",
    reasonRejectContract: "Бекор қилиш сабаби",
    acceptedCount: "Қабул қилинган сони",
    uploadFileRequest: "Буюртма учун файл юклаш",
    contractRejectionHint: "Шартномани бекор қилиш сабабини келтиринг",
    conclusionAndReceived: "Тузилган ва қабул қилинган шартномалар",
    newCategoryName: "Янги тоифадаги ном",
    addCategory: "Категория қўшиш",
    addInventory: "Инвентаризация қўшинг",
    nameCategory: "тоифанинг номи",
    nameOfGoodsAndMaterials: "Маҳсулот ёки материалнинг номи",
    acceptedContracts: "Қабул қилинган шартномалар",
    conclusionContracts: "Тузилган шартномалар",
    reasonForRefusal: "Буюртма бекор қилинишининг сабаби",
    changeCategory: "Тоифани ўзгартириш",
    changeInventory: "Инвентаризацияни ўзгартириш",
    addGroup: "Гуруҳ қўшиш",
    homeFurniture: "Уй мебеллари",
    hasCount: "Мавжуд",
    livingRoomFurniture: "Яшаш хонаси учун мебел",
    initiatorOzl: "Буюртмачи OZL",
    areAvailable: "Етарли",
    notEnoughQuantity: "сони етарли эмас",
    hasPlace: "Жой бор",
    noPlace: "Жой йўқ",
    yes: "Ха",
    notAvailable: "етарли эмас",
    sendToOzl: "Маҳсулот йўқ, ОЗЛ га жўнатиш",
    specAccepted: "Спецификация қабул қилинди",
    productAvailableNotEnoughQuantity: "Маҳсулот етарли эмас",
    givePartiallyProduct: "Маҳсулот бор, қисман бериш",
    state: "Ҳолати",
    editGroup: "Гуруҳни таҳрирлаш",
    suppliers: "Таъминотчилар",
    supplier: "Таъминотчи",
    giveOut: "Berib yuborish",
    available: "Мавжуд",
    refuse: "Бекор қилинади",
    asked: "Сўралган",
    requestApproved: "Буюртма қаноатлантирилди",
    team: "Гуруҳ",
    addRealizationProduct: "Амалга оширилган маҳсулотни қўшиш",
    hidden: "Беркитиш",
    mainWarehouse: "Бош омборхона",
    inWarehouse: "Омборхонада",
    mainDepartment: "Бош бўлим",
    productsInDraft: "Текширилмаган маҳсулотлар",
    browseFile: "Файл юклаш учун бу ерга босинг ёки файлни бу ерга ташланг",
    wantAddProduct: "Яна маҳсулот қўшишни истайсизми?",
    warehouses: "Омборхоналар",
    orders: "Буюртмалар",
    teamLeader: "Гуруҳ сардори",
    productCode: "Маҳсулот рақами",
    countOfRequested: "Сўралган маҳсулот сони",
    requestRejection: "Буюртмани бекор қилиш",
    requestRejectionHint: "Буюртмани бекор қилиш учун сабабини келтиринг",
    movingProducts: "Маҳсулотни кўчириш",
    requestFinishHint: "Буюртмани тугатиш учун сабабини келтиринг",
    reasonRejectRequest: "Бекор қилиш сабаби",
    months: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ],
    createSupplier: "Таъминотчи яратиш",
    createOrder: "Буюртма яратиш",
    createType: "Тур яратиш",
    typeSupply: "Етказиб бериш тури",
    update: "Юклаш",
    updateType: "Турни янгилаш",
    updateSupplier: "Таъминотчини янгилаш",
    updateCustomer: "Буюртмачини янгилаш",
    position: "Ўрнатилган жойи",
    visible: "Кўринадиган",
    numberRequest: "Буюртма рақами",
    approve: "Тасдиқлаш",
    categoryProduct: "Маҳсулот категорияси",
    approveRequest: "Буюртмани тасдиқлаш",
    no: "Йўқ",
    yesDelete: "Ҳа, ўчириш",
    warning: "Огоҳлантириш!",
    wantDeleteHint: "Ўчиришни ҳоҳлайсизми ?",
    comment: "Изоҳ",
    color: "Ранг",
    size: "Шрифт ҳажми",
    youHaveNotAccess: "Сизда рухсат йўқ",
    acts: "Актлар",
    editContract: "Шартномани ўзгартириш",
    attachAct: "Акт ни бириктириш",
    code: "Код",
    address: "Манзил",
    contracts: "Шартномалар",
    open: "Очиш",
    nameGroup: "Гуруҳ номи",
    addToBasket: "Саватга кушиш",
    moveProductStatus: {
      NEW: "Янги",
      APPROVED: "қабул қилинган",
      REJECTED: "Бекор қилинган",
    },
    receptionStatus: {
      NEW: "Бериб юборилмаган",
      REQUEST_DONE: "Бериб юборилган",
    },
    history: "Ҳаракатлар тарихи",
    successMessages: {
      reIndexed: "Индексланди",
    },

    notificationTemplate: {
      departmentToOmtk: "{userName} {count} {productName}ни олиб кетмоқчи",
      ozlToOmtkProfitProduct:
        "№{contractNumber} рақамли шартнома бўйича {productName} етиб келди",
      ozlToAccountProfitProduct:
        "Ушбу {contractNumber}-сонли шартнома бўйича товарлар етказиб бериш кутилмоқда. Илтимос, ишончномани таёрланг.",
    },
    orderItemStatusDescription: {
      [orderItemStatus.YES_PRODUCT]:
        "Маҳсулотни {name} омборхонадан олишингиз мумкин",
      [orderItemStatus["PAPER_EXPECTED_SPECIFICATION"]]:
        "Сотиб олиниши керак бўлган буюртма яратиш учун тегишли бўлим билан боғланинг",
    },
    outGoingContractStatus: {
      CONCLUDED: "Тузилган",
      COMPLETED: "Ёпилган",
    },
    contractStatus: {
      /**
       * * Contract status
       * */
      USER_AGREEMENT_ACCEPTED: "Қабул қилинган",
      USER_AGREEMENT_DELETED: "Ўчирилган",
      USER_AGREEMENT_REJECTED: "Бекор қилинган",
      USER_AGREEMENT_PART_ACCEPTED: "Қисман қабул қилинган",

      CONTRACT_CONCLUTION: "Шартнома тузилган",
      CONTRACT_ACCEPTED: "Қабул қилинган",
      CONTRACT_ITEM_PARTITION_ACCEPTED: "Шартнома партия билан қабул қилинган",
      PART_ACCEPTED: "Қисман қабул қилинган",
      CONTRACT_REJECT: "Бузилган",

      /**
       * * Contract item status
       * */
      NEW: "Янги",
      CONTRACT_ITEM_ACCEPTED: "Қабул қилинган",
      CONTRACT_ITEM_REJECT: "Бекор қилинган",
      CONTRACT_ITEM_PART_ACCEPTED: "Қисман қабул қилинган",
      CONTRACT_NEW: "New",
      DELETED: "Ўчирилган",
    },
    orderItemStateOmtk: {
      available: "Мавжуд",
      noAvailable: "Мавжуд эмас",
      notEnough: "Етарли эмас",
    },
    productPackageType: {
      COUNTABLE: "Дона",
      PACKAGEABLE: "Қадоқ",
    },
    productItemStatus: {
      NEW: "Янги",
      PRODUCT_PRODUCED: "Маҳсулот олиб кетилган",
      PRODUCT_USED: "Ишлатилган",
      DELETED: "Ўчирилган",
    },
    validation: CyrlValidationMessages.messages,
    $vuetify: {
      fileInput: {
        counter: "{0} files",
      },
      dataIterator: {
        loadingText: "Yangilanmoqda",
      },
      datePicker: {
        nextMonthAriaLabel: "next month",
        prevMonthAriaLabel: "prev month",
        prevYearAriaLabel: "prev year",
        nextYearAriaLabel: "next year",
      },
      noDataText: "Маълумотлар йўқ",
      pagination: {
        ariaLabel: {
          next: "Next",
          wrapper: "Wrapper",
          previous: "Previous",
          currentPage: "Current page",
          page: "Page",
        },
      },
      dataTable: {
        sortBy: "Тартиблаш",
        ariaLabel: {
          sortNone: "Sort no",
          activateAscending: "Active ascending",
          activateDescending: "activateDescending",
          sortAscending: "sortAscending",
          sortDescending: "sortDescending",
          activateNone: "activateNone",
        },
      },
    },
    errors: {
      productNotSaved: "Маҳсулот сақланмади",
      "Request aborted": "Request aborted",
      noRequestAdded: "Буюртма қушмадингиз",
      "Request failed with status code 400": "Request failed 400",
      "Request failed with status code 500": "Request failed 500",
      "Request failed with status code 502": "Request failed 502",
      "Request failed with status code 401": "Request failed 401",
      "Request failed with status code 404":
        "Request failed with status code 404",
      "Network Error": "Серверга уланиб булмади",
      "E-Imzo not installed": "Э-имзо ўрнатилмаган",
    },
    packageType: "Қадоқ тури",
    printQr: "QRни чоп этиш",
    printedQr: "Чоп этилган",
    notPrintedQr: "Чоп этилмаган",
    acceptUser: "Қабул қилувчи",
    reports: "Ҳисоботлар",
    materialReport: "Моддий бойликлар ҳисоботи",
    dashboardTableType: {
      graph: "График",
      table: "Жадвал",
    },
    getMaterialReport: "Моддий бойликлар ҳисоботи кўчириб олиш",
    support: "Техник кўмак",
    dateFrom: "Бошланғич сана",
    dateTo: "Тугаш санаси",
  },
};
